webpackJsonp([1,2],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1526)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(1207),
  /* template */
  __webpack_require__(1701),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1207:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(71);




var icons = {};

/* harmony default export */ __webpack_exports__["default"] = {
  name: 'icon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val) {
          if (!(val in icons)) {
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].util.warn('Invalid prop: prop "icon" is referring to an unregistered icon "' + val + '".' + '\nPlesase make sure you have imported this icon before using it.', this);
            return false;
          }
          return true;
        }
        return null;
      }
    },
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    pulse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String
  },
  data: function data() {
    return {
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].util.warn('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    clazz: function clazz() {
      return {
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-inverse': this.inverse,
        'fa-pulse': this.pulse
      };
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    ratio: function ratio() {
      if (!this.icon) {
        return 1;
      }
      var _icon = this.icon,
          width = _icon.width,
          height = _icon.height;

      return Math.max(width, height) / 16;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.icon) {
      return;
    }
    this.$children.forEach(function (child) {
      child.outerScale = _this.normalizedScale;
    });
    var width = 0;
    var height = 0;
    this.$children.forEach(function (child) {
      width = Math.max(width, child.width);
      height = Math.max(height, child.height);
    });
    this.childrenWidth = width;
    this.childrenHeight = height;
    this.$children.forEach(function (child) {
      child.x = (width - child.width) / 2;
      child.y = (height - child.height) / 2;
    });
  },
  register: function register(data) {
    for (var name in data) {
      var icon = data[name];

      if (!icon.paths) {
        icon.paths = [];
      }
      if (icon.d) {
        icon.paths.push({ d: icon.d });
      }

      if (!icon.polygons) {
        icon.polygons = [];
      }
      if (icon.points) {
        icon.polygons.push({ points: icon.points });
      }

      icons[name] = icon;
    }
  },

  icons: icons
};

/***/ }),

/***/ 1208:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  name: 'App',

  created: function created() {
    var _this = this;

    this.$root.$on('temporary-problem', function () {
      _this.$router.push('/temporary-problem');
    });

    this.$root.$on('error', function () {
      _this.$router.push('/error');
    });

    this.$root.$on('unauthorized', function () {
      _this.$router.push('/access-denied');
    });
  }
};

/***/ }),

/***/ 1209:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  name: 'EditableGrid',

  props: {
    rows: Number,
    columns: Number,
    focused: Boolean
  },

  data: function data() {
    return {
      selectedRow: null,
      selectedColumn: null,
      isBeingEdited: false
    };
  },


  computed: {
    activeRow: function activeRow() {
      if (!this.focused) {
        return null;
      } else {
        return this.selectedRow;
      }
    },
    activeColumn: function activeColumn() {
      if (!this.focused) {
        return null;
      } else {
        return this.selectedColumn;
      }
    }
  },

  methods: {
    selectLeftCell: function selectLeftCell() {
      if (this.isBeingEdited) {
        this.isBeingEdited = false;
      }

      if (this.selectedColumn > 0) {
        this.selectedColumn -= 1;
      }
    },
    selectRightCell: function selectRightCell() {
      if (this.isBeingEdited) {
        this.isBeingEdited = false;
      }

      if (this.selectedColumn < this.columns - 1) {
        this.selectedColumn += 1;
      }
    },
    selectUpCell: function selectUpCell() {
      if (this.isBeingEdited) {
        this.isBeingEdited = false;
      }

      if (this.selectedRow > 0) {
        this.selectedRow -= 1;
      }
    },
    selectDownCell: function selectDownCell() {
      if (this.isBeingEdited) {
        this.isBeingEdited = false;
      }

      if (this.selectedRow < this.rows - 1) {
        this.selectedRow += 1;
      }
    }
  },

  created: function created() {
    var _this = this;

    this.$on('activated', function (data) {
      _this.isBeingEdited = false;
      _this.selectedRow = data.row;
      _this.selectedColumn = data.column;
    });

    this.$on('edit', function (value) {
      _this.isBeingEdited = value;
    });
  }
};

/***/ }),

/***/ 1210:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(71);



/* harmony default export */ __webpack_exports__["default"] = {
  name: 'EditableGridCell',

  props: {
    row: Number,
    column: Number,
    activeRow: Number,
    activeColumn: Number,
    isBeingEdited: Boolean,
    isEditable: {
      type: Boolean,
      'default': true
    },
    hasDanger: {
      type: Boolean,
      'default': false
    },
    hasPadding: {
      type: Boolean,
      'default': false
    }
  },

  computed: {
    isActive: function isActive() {
      return this.row === this.activeRow && this.column === this.activeColumn;
    }
  },

  watch: {
    isActive: function isActive() {
      this.focus();
    },
    isBeingEdited: function isBeingEdited() {
      this.focus();
    }
  },

  methods: {
    activate: function activate() {
      this.$parent.$emit('activated', { row: this.row, column: this.column });
    },
    focus: function focus() {
      var _this = this;

      if (this.isActive && this.isBeingEdited) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].nextTick(function () {
          var inputs = _this.$refs.cell.getElementsByTagName('input');
          var selects = _this.$refs.cell.getElementsByTagName('select');
          var buttons = _this.$refs.cell.getElementsByTagName('button');

          if (buttons.length > 0) {
            buttons[buttons.length - 1].focus();
          } else if (inputs.length > 0) {
            inputs[inputs.length - 1].focus();
          } else if (selects.length > 0) {
            selects[selects.length - 1].focus();
          }
        });
      } else if (this.isActive && !this.isBeingEdited) {
        this.$refs.cell.focus();
      }
    },
    toggleEdit: function toggleEdit() {
      if (this.isBeingEdited) {
        this.$parent.$emit('edit', false);
      } else {
        this.$parent.$emit('edit', true);
      }
    }
  }
};

/***/ }),

/***/ 1211:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  name: 'EditableGridRow',

  props: {
    activeRow: Number
  },

  created: function created() {
    var _this = this;

    this.$on('activated', function (data) {
      _this.$parent.$emit('activated', data);
    });

    this.$on('edit', function (data) {
      _this.$parent.$emit('edit', data);
    });
  }
};

/***/ }),

/***/ 1212:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  name: 'LoadingIndicator',

  props: {
    show: {}
  }
};

/***/ }),

/***/ 1213:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  props: ['pagination', 'offset'],
  methods: {
    isCurrentPage: function isCurrentPage(page) {
      return this.pagination.current_page === page;
    },
    changePage: function changePage(page) {
      if (page > this.pagination.last_page) {
        page = this.pagination.last_page;
      }
      this.pagination.current_page = page;
      this.$emit('paginate');
    }
  },
  computed: {
    pages: function pages() {
      var pages = [];
      var from = this.pagination.current_page - Math.floor(this.offset / 2);
      if (from < 1) {
        from = 1;
      }
      var to = from + this.offset - 1;
      if (to > this.pagination.last_page) {
        to = this.pagination.last_page;
      }
      while (from <= to) {
        pages.push(from);
        from++;
      }
      return pages;
    }
  }
};

/***/ }),

/***/ 1214:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  name: 'SelectableGrid',

  props: {
    rows: Number,
    focused: Boolean
  },

  data: function data() {
    return {
      selectedRow: null
    };
  },


  computed: {
    activeRow: function activeRow() {
      if (!this.focused) {
        return null;
      } else {
        return this.selectedRow;
      }
    }
  },

  watch: {
    focused: function focused(value) {
      if (value) {
        this.selectedRow = 0;
      }
    }
  },

  methods: {
    selectNextRow: function selectNextRow() {
      if (this.selectedRow < this.rows - 1) {
        this.selectedRow += 1;
      }
    },
    selectPreviousRow: function selectPreviousRow() {
      if (this.selectedRow > 0) {
        this.selectedRow -= 1;
      }
    }
  },

  created: function created() {
    var _this = this;

    this.$on('activated', function (data) {
      _this.selectedRow = data.row;
    });
  }
};

/***/ }),

/***/ 1215:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  name: 'SelectableGridCell',

  props: {
    row: Number,
    activeRow: Number
  },

  computed: {
    isActive: function isActive() {
      return this.row === this.activeRow;
    }
  },

  watch: {
    isActive: function isActive() {
      this.focus();
    }
  },

  methods: {
    activate: function activate() {
      this.$parent.$emit('activated', { row: this.row });
    },
    focus: function focus() {
      if (this.isActive) {
        this.$refs.cell.focus();
      }
    }
  }
};

/***/ }),

/***/ 1216:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  name: 'SelectableGridRow',

  props: {
    activeRow: Number
  },

  methods: {
    select: function select() {
      this.$emit('select');
    }
  },

  created: function created() {
    var _this = this;

    this.$on('activated', function (data) {
      _this.$parent.$emit('activated', data);
    });
  }
};

/***/ }),

/***/ 1217:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Service__ = __webpack_require__(40);







var Campaigns = function (_Service) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Campaigns, _Service);

  function Campaigns() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Campaigns);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Campaigns.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Campaigns)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Campaigns, [{
    key: 'get',
    value: function get(params) {
      var _this2 = this;

      params.request = 'getCampaigns';

      return this.fetchAllRecords('', params).catch(function (response) {
        return _this2.handleErrorResponse(response);
      });
    }
  }, {
    key: 'getCampaigns',
    value: function getCampaigns(id) {
      var _this3 = this;

      return this.connection.get('events/' + id + '/campaigns', {}).then(function (response) {
        return response.data.records;
      }).catch(function (response) {
        return _this3.handleErrorResponse(response);
      });
    }
  }, {
    key: 'addCampaign',
    value: function addCampaign(campaign, id) {
      campaign.mode = 'post';
      if (campaign.rewards.sumOff !== undefined && campaign.rewards.sumOff === 0) {
        delete campaign.rewards.sumOff;
      }
      return this.connection.requestSpea('events/' + id + '/campaigns', campaign).then(function (response) {
        return response;
      });
    }
  }, {
    key: 'edit',
    value: function edit(id, campaign) {
      var _this4 = this;

      var request = 'events/' + id + '/campaigns/' + campaign.campaignId;
      campaign.mode = 'patch';
      return this.connection.requestSpea(request, campaign).then(function (response) {
        return _this4.handleEmptyResponse(response);
      }).catch(function (response) {
        return _this4.handleErrorResponse(response);
      });
    }
  }, {
    key: 'remove',
    value: function remove(id, campaign) {
      var _this5 = this;

      var request = 'events/' + id + '/campaigns/' + campaign.campaignId;
      return this.connection.requestSpea(request, { mode: 'delete' }).then(function (response) {
        return _this5.handleEmptyResponse(response);
      }).catch(function (response) {
        return _this5.handleErrorResponse(response);
      });
    }
  }]);

  return Campaigns;
}(__WEBPACK_IMPORTED_MODULE_5__Service__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = Campaigns;

/***/ }),

/***/ 1218:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Service__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);









var Customers = function (_Service) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Customers, _Service);

  function Customers() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Customers);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Customers.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(Customers)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Customers, [{
    key: 'getGroups',
    value: function getGroups() {
      var _this2 = this;

      if (this.cachedGroups && this.groupCacheTime && __WEBPACK_IMPORTED_MODULE_7_moment___default()().diff(this.groupCacheTime, 'seconds') < this.cacheTimeNormal) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(this.cachedGroups);
      }

      var params = {};
      params.request = 'getCustomerGroups';

      return this.fetchAllRecords('', params).then(function (groups) {
        _this2.cachedGroups = groups;
        _this2.groupCacheTime = __WEBPACK_IMPORTED_MODULE_7_moment___default()();
        return groups;
      }).catch(function (response) {
        return _this2.handleErrorResponse(response);
      });
    }
  }]);

  return Customers;
}(__WEBPACK_IMPORTED_MODULE_6__Service__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = Customers;

/***/ }),

/***/ 1219:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Service__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);











var Events = function (_Service) {
  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(Events, _Service);

  function Events(connection) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, Events);

    var _this = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Events.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(Events)).call(this, connection));

    _this.cachedEvents = [];
    _this.eventsCacheTime = [];
    _this.cachedReasonCodes = [];
    _this.reasonCodesCacheTime = 0;
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(Events, [{
    key: 'createNewEvent',
    value: function createNewEvent(params) {
      var _this2 = this;

      params.mode = 'post';
      return this.connection.requestSpea('events', params).then(function (response) {
        _this2.cachedEvents = [];
        _this2.eventsCacheTime = 61;
        return response.data;
      }).catch(function (response) {
        return _this2.handleErrorResponse(response);
      });
    }
  }, {
    key: 'getEventsByPage',
    value: function getEventsByPage(pageNo, params) {
      var _this3 = this;

      if (typeof params === 'undefined') params = {};

      params.reverse = 1;

      params.limit = 100;
      params.page = pageNo;

      return this.connection.get('events/filtered', params).then(function (response) {
        return _this3.handleMultiRecordResponse(response, true);
      }).then(function (resp) {

        return resp;
      });
    }
  }, {
    key: 'getEvents',
    value: function getEvents(params) {
      var _this4 = this;

      if (this.cachedEvents.length && this.eventsCacheTime && __WEBPACK_IMPORTED_MODULE_9_moment___default()().diff(this.eventsCacheTime, 'seconds') < 60) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(this.cachedEvents);
      }

      if (typeof params === 'undefined') params = {};
      return this.fetchAllRecords('events', params).then(function (response) {
        var newEvents = response.filter(function (event) {
          return event.speaApiVersion;
        });
        _this4.cachedEvents = newEvents;
        _this4.eventsCacheTime = __WEBPACK_IMPORTED_MODULE_9_moment___default()();
        return newEvents;
      });
    }
  }, {
    key: 'getEvent',
    value: function getEvent(id) {
      var _this5 = this;

      return this.connection.get('events/' + id, {}).then(function (response) {
        return response.data;
      }).catch(function (response) {
        return _this5.handleErrorResponse(response);
      });
    }
  }, {
    key: 'deleteEvent',
    value: function deleteEvent(id) {
      var _this6 = this;

      return this.connection.requestSpea('events/' + id + '?withAssociations=1', { mode: 'delete' }).then(function (response) {
        _this6.cachedEvents = [];
        _this6.eventsCacheTime = 61;
        _this6.handleEmptyResponse(response);
      }).catch(function (response) {
        return _this6.handleErrorResponse(response);
      });
    }
  }, {
    key: 'save',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(params) {
        var _this7 = this;

        var request;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                request = 'events/' + params.id;

                params.mode = 'patch';
                _context.next = 4;
                return this.connection.requestSpea(request, params).then(function (response) {
                  _this7.cachedEvents = [];
                  _this7.eventsCacheTime = 61;
                  _this7.handleEmptyResponse(response);
                }).catch(function (response) {
                  return _this7.handleErrorResponse(response);
                });

              case 4:
                return _context.abrupt('return', _context.sent);

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function save(_x) {
        return _ref.apply(this, arguments);
      }

      return save;
    }()
  }, {
    key: 'getReasonCodes',
    value: function getReasonCodes() {
      var _this8 = this;

      if (this.cachedReasonCodes.length && this.reasonCodesCacheTime && __WEBPACK_IMPORTED_MODULE_9_moment___default()().diff(this.reasonCodesCacheTime, 'seconds') < this.cacheTimeNormal) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(this.cachedReasonCodes);
      }

      var params = {};
      params.request = 'getReasonCodes';
      params.recordsOnPage = 100;
      params.purpose = 'PROMOTION';

      return this.fetchAllRecords('', params).then(function (reasonCodes) {
        _this8.cachedReasonCodes = reasonCodes;
        _this8.reasonCodesCacheTime = __WEBPACK_IMPORTED_MODULE_9_moment___default()();
        return reasonCodes;
      }).catch(function (response) {
        return _this8.handleErrorResponse(response);
      });
    }
  }]);

  return Events;
}(__WEBPACK_IMPORTED_MODULE_8__Service__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = Events;

/***/ }),

/***/ 1220:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Service__ = __webpack_require__(40);








var PriceLists = function (_Service) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(PriceLists, _Service);

  function PriceLists(connection, productsInPriceList) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, PriceLists);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (PriceLists.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(PriceLists)).call(this, connection));

    _this.productsInPriceList = productsInPriceList;
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(PriceLists, [{
    key: 'get',
    value: function get(params) {
      var _this2 = this;

      params.request = 'getPriceLists';
      return this.fetchAllRecords('', params).catch(function (response) {
        return _this2.handleErrorResponse(response);
      }).then(function (priceLists) {
        return priceLists.map(function (priceList) {
          if (!priceList.pricelistRules) priceList.pricelistRules = [];
          return priceList;
        });
      });
    }
  }, {
    key: 'getById',
    value: function getById(id) {
      return this.get({
        pricelistID: id
      }).then(function (priceLists) {
        return priceLists[0];
      });
    }
  }, {
    key: 'getByIds',
    value: function getByIds(ids) {
      if (ids.length === 0) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve([]);
      }

      return this.get({
        priceListIDs: ids.join(',')
      });
    }
  }]);

  return PriceLists;
}(__WEBPACK_IMPORTED_MODULE_6__Service__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = PriceLists;

/***/ }),

/***/ 1221:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Service__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);









var Products = function (_Service) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Products, _Service);

  function Products(connection, cacheTimeNormal) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Products);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Products.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(Products)).call(this, connection, cacheTimeNormal));

    _this.cachedProducts = {};
    _this.productsCacheTimes = {};
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Products, [{
    key: 'get',
    value: function get(params) {
      var _this2 = this;

      params.request = 'getProducts';

      return this.fetchAllRecords('', params).catch(function (response) {
        return _this2.handleErrorResponse(response);
      });
    }
  }, {
    key: 'getSome',
    value: function getSome(params, count) {
      var _this3 = this;

      if (typeof params.codePrefix !== 'undefined' && this.cachedProducts['search-' + (params.codePrefix ? params.codePrefix : 'all')] && __WEBPACK_IMPORTED_MODULE_7_moment___default()().diff(this.productsCacheTimes['search-' + (params.codePrefix ? params.codePrefix : 'all')], 'seconds') < this.cacheTimeNormal) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(this.cachedProducts['search-' + (params.codePrefix ? params.codePrefix : 'all')]);
      }
      params.request = 'getProducts';
      params.recordsOnPage = count;

      return this.connection.postErply(params).then(function (response) {
        if (typeof params.codePrefix !== 'undefined') {
          _this3.cachedProducts['search-' + (params.codePrefix ? params.codePrefix : 'all')] = response.data.records;
          _this3.productsCacheTimes['search-' + (params.codePrefix ? params.codePrefix : 'all')] = __WEBPACK_IMPORTED_MODULE_7_moment___default()();
        }

        return _this3.handleMultiRecordResponse(response);
      }).catch(function (response) {
        return _this3.handleErrorResponse(response);
      });
    }
  }, {
    key: 'getByIds',
    value: function getByIds(ids) {
      if (ids.length === 0) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve([]);
      }

      return this.get({ productIDs: ids.join(',') });
    }
  }, {
    key: 'getProducts',
    value: function getProducts(id) {
      var _this4 = this;

      return this.connection.get('events/' + id + '/pricelist-products', {}).then(function (response) {
        return response.data.records;
      }).catch(function (response) {
        return _this4.handleErrorResponse(response);
      });
    }
  }, {
    key: 'remove',
    value: function remove(id, product) {
      var _this5 = this;

      var request = 'events/' + id + '/pricelist-products/' + product.priceListProductId;
      return this.connection.requestSpea(request, { mode: 'delete' }).then(function (response) {
        _this5.cachedProducts[id] = [];
        _this5.productsCacheTimes[id] = [];
        return _this5.handleEmptyResponse(response);
      }).catch(function (response) {
        return _this5.handleErrorResponse(response);
      });
    }
  }, {
    key: 'edit',
    value: function edit(id, product) {
      var _this6 = this;

      var request = 'events/' + id + '/pricelist-products/' + product.priceListProductId;
      product.mode = 'patch';
      return this.connection.requestSpea(request, product).then(function (response) {
        _this6.cachedProducts[id] = [];
        _this6.productsCacheTimes[id] = [];
        return _this6.handleEmptyResponse(response);
      }).catch(function (response) {
        return _this6.handleErrorResponse(response);
      });
    }
  }, {
    key: 'addProduct',
    value: function addProduct(id, product) {
      var _this7 = this;

      product.mode = 'post';
      return this.connection.requestSpea('events/' + id + '/pricelist-products', product).then(function (response) {
        _this7.cachedProducts[id] = [];
        _this7.productsCacheTimes[id] = [];
        return response;
      });
    }
  }]);

  return Products;
}(__WEBPACK_IMPORTED_MODULE_6__Service__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = Products;

/***/ }),

/***/ 1222:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Service__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);









var RegionCustomerGroupPriceLists = function (_Service) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(RegionCustomerGroupPriceLists, _Service);

  function RegionCustomerGroupPriceLists(connection, storeRegions, priceLists) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, RegionCustomerGroupPriceLists);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (RegionCustomerGroupPriceLists.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(RegionCustomerGroupPriceLists)).call(this, connection));

    _this.storeRegions = storeRegions;
    _this.priceLists = priceLists;
    _this.cachedBasePriceLists = [];
    _this.basePriceListCacheTimes = [];
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(RegionCustomerGroupPriceLists, [{
    key: 'getBasePriceList',
    value: function getBasePriceList(regionId, customerGroupId, startDate, endDate) {
      var _this2 = this;

      if (this.cachedBasePriceLists[regionId] && this.cachedBasePriceLists[regionId][customerGroupId] && this.basePriceListCacheTimes[regionId] && this.basePriceListCacheTimes[regionId][customerGroupId] && this.checkDate(this.cachedBasePriceLists[regionId][customerGroupId], startDate, endDate) && __WEBPACK_IMPORTED_MODULE_7_moment___default()().diff(this.basePriceListCacheTimes[regionId][customerGroupId], 'seconds') < this.cacheTimeNormal) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(this.cachedBasePriceLists[regionId][customerGroupId]);
      }

      return this.storeRegions.getById(regionId).then(function (region) {
        var customerGroupPriceListsItems = region.customerGroupPriceLists ? region.customerGroupPriceLists : [];
        var currentGroupPriceListItem = customerGroupPriceListsItems.find(function (priceList) {
          return priceList.customerGroupID === customerGroupId;
        });
        var currentGroupPriceList = currentGroupPriceListItem ? currentGroupPriceListItem.priceLists : [];
        var activeBasePriceLists = currentGroupPriceList.filter(function (pricelist) {
          return pricelist.type === 'BASE_PRICE_LIST';
        });
        var periodsPriceLists = _this2.filterByDate(activeBasePriceLists, startDate, endDate);

        var priceListIds = periodsPriceLists.map(function (pricelist) {
          return pricelist.priceListID;
        }).filter(function (id) {
          return !!id;
        });

        return _this2.priceLists.getByIds(priceListIds);
      }).then(function (priceLists) {
        return priceLists.reduce(function (result, priceList) {
          return priceList;
        }, { pricelistRules: [] });
      }).then(function (priceList) {
        if (!_this2.cachedBasePriceLists[regionId]) {
          _this2.cachedBasePriceLists[regionId] = [];
        }
        if (!_this2.basePriceListCacheTimes[regionId]) {
          _this2.basePriceListCacheTimes[regionId] = [];
        }

        _this2.cachedBasePriceLists[regionId][customerGroupId] = priceList;
        _this2.basePriceListCacheTimes[regionId][customerGroupId] = __WEBPACK_IMPORTED_MODULE_7_moment___default()();
        return priceList;
      });
    }
  }, {
    key: 'filterByDate',
    value: function filterByDate(dateables, startDate, endDate) {
      var _this3 = this;

      return dateables.filter(function (dateable) {
        return _this3.checkDate(dateable, startDate, endDate);
      });
    }
  }, {
    key: 'checkDate',
    value: function checkDate(dateable, startDate, endDate) {
      if (dateable.startDate === '0000-00-00') {
        dateable.startDate = null;
      }
      if (dateable.endDate === '0000-00-00') {
        dateable.endDate = null;
      }
      if (dateable.startDate && dateable.startDate > endDate) {
        return false;
      } else if (dateable.endDate && dateable.endDate < startDate) {
        return false;
      } else {
        return true;
      }
    }
  }]);

  return RegionCustomerGroupPriceLists;
}(__WEBPACK_IMPORTED_MODULE_6__Service__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = RegionCustomerGroupPriceLists;

/***/ }),

/***/ 1223:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Service__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);









var RegionPriceLists = function (_Service) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(RegionPriceLists, _Service);

  function RegionPriceLists(connection, storeRegions, priceLists) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, RegionPriceLists);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (RegionPriceLists.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(RegionPriceLists)).call(this, connection));

    _this.storeRegions = storeRegions;
    _this.priceLists = priceLists;
    _this.cachedBasePriceLists = [];
    _this.basePriceListCacheTimes = [];
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(RegionPriceLists, [{
    key: 'getBasePriceList',
    value: function getBasePriceList(regionId, startDate, endDate) {
      var _this2 = this;

      if (this.cachedBasePriceLists[regionId] && this.basePriceListCacheTimes[regionId] && this.checkDate(this.cachedBasePriceLists[regionId], startDate, endDate) && __WEBPACK_IMPORTED_MODULE_7_moment___default()().diff(this.basePriceListCacheTimes[regionId], 'seconds') < this.cacheTimeNormal) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(this.cachedBasePriceLists[regionId]);
      }

      return this.storeRegions.getById(regionId).then(function (region) {
        var regionPriceLists = region.priceLists ? region.priceLists : [];
        var activeBasePriceLists = regionPriceLists.filter(function (pricelist) {
          return pricelist.type === 'BASE_PRICE_LIST';
        });
        var periodPriceLists = _this2.filterByDate(activeBasePriceLists, startDate, endDate);
        var priceListIds = periodPriceLists.map(function (pricelist) {
          return pricelist.priceListID;
        }).filter(function (id) {
          return !!id;
        });

        return _this2.priceLists.getByIds(priceListIds);
      }).then(function (priceLists) {
        return priceLists.reduce(function (result, priceList) {
          return priceList;
        }, { pricelistRules: [] });
      }).then(function (priceList) {
        _this2.cachedBasePriceLists[regionId] = priceList;
        _this2.basePriceListCacheTimes[regionId] = __WEBPACK_IMPORTED_MODULE_7_moment___default()();
        return priceList;
      });
    }
  }, {
    key: 'filterByDate',
    value: function filterByDate(dateables, startDate, endDate) {
      var _this3 = this;

      return dateables.filter(function (dateable) {
        return _this3.checkDate(dateable, startDate, endDate);
      });
    }
  }, {
    key: 'checkDate',
    value: function checkDate(dateable, startDate, endDate) {
      if (dateable.startDate === '0000-00-00') {
        dateable.startDate = null;
      }
      if (dateable.endDate === '0000-00-00') {
        dateable.endDate = null;
      }
      if (dateable.startDate && dateable.startDate > endDate) {
        return false;
      } else if (dateable.endDate && dateable.endDate < startDate) {
        return false;
      } else {
        return true;
      }
    }
  }]);

  return RegionPriceLists;
}(__WEBPACK_IMPORTED_MODULE_6__Service__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = RegionPriceLists;

/***/ }),

/***/ 1224:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Service__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);










var RegionSupplierPriceLists = function (_Service) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(RegionSupplierPriceLists, _Service);

  function RegionSupplierPriceLists(connection) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, RegionSupplierPriceLists);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (RegionSupplierPriceLists.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(RegionSupplierPriceLists)).call(this, connection));

    _this.cachedPriceLists = [];
    _this.priceListCacheTimes = [];
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(RegionSupplierPriceLists, [{
    key: 'getAll',
    value: function getAll(regionId, startDate, endDate) {
      var _this2 = this;

      if (this.cachedPriceLists[regionId] && this.priceListCacheTimes[regionId] && this.checkDate(this.cachedPriceLists[regionId], startDate, endDate) && __WEBPACK_IMPORTED_MODULE_8_moment___default()().diff(this.priceListCacheTimes[regionId], 'seconds') < this.cacheTimeNormal) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(this.cachedPriceLists[regionId]);
      }

      var params = {};
      params.request = 'getSupplierPriceLists';
      params.searchAttributeName = 'store_region_id';
      params.searchAttributeValue = regionId;

      return this.connection.postErply(params).then(function (response) {
        return response.data.records;
      }).then(function (priceLists) {

        var regionalSuppliersPricelists = priceLists || [];
        var periodsPriceList = _this2.filterByDate(regionalSuppliersPricelists, startDate, endDate);
        if ((typeof periodsPriceList === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(periodsPriceList)) === undefined || !periodsPriceList) periodsPriceList = { pricelistRules: [] };

        _this2.cachedPriceLists[regionId] = periodsPriceList;
        _this2.priceListCacheTimes[regionId] = __WEBPACK_IMPORTED_MODULE_8_moment___default()();
        return periodsPriceList;
      }).catch(function (response) {
        return _this2.handleErrorResponse(response);
      });
    }
  }, {
    key: 'filterByDate',
    value: function filterByDate(dateables, startDate, endDate) {
      var _this3 = this;

      var filtered = dateables.filter(function (dateable) {
        return _this3.checkDate(dateable, startDate, endDate);
      });

      var ordered = filtered.sort(function (a, b) {
        var distancea = Math.abs(__WEBPACK_IMPORTED_MODULE_8_moment___default()(a.startDate).diff(__WEBPACK_IMPORTED_MODULE_8_moment___default()(startDate)));
        var distanceb = Math.abs(__WEBPACK_IMPORTED_MODULE_8_moment___default()(b.startDate).diff(__WEBPACK_IMPORTED_MODULE_8_moment___default()(startDate)));
        return distancea - distanceb;
      });


      return ordered;
    }
  }, {
    key: 'checkDate',
    value: function checkDate(dateable, startDate, endDate) {
      if (dateable.startDate === '0000-00-00') {
        dateable.startDate = null;
      }
      if (dateable.endDate === '0000-00-00') {
        dateable.endDate = null;
      }

      if (dateable.startDate && dateable.startDate > endDate) {
        return false;
      } else if (dateable.endDate && dateable.endDate < startDate) {
        return false;
      } else {
        return true;
      }
    }
  }]);

  return RegionSupplierPriceLists;
}(__WEBPACK_IMPORTED_MODULE_7__Service__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = RegionSupplierPriceLists;

/***/ }),

/***/ 1225:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Service__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);









var StoreRegions = function (_Service) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(StoreRegions, _Service);

  function StoreRegions() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, StoreRegions);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (StoreRegions.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(StoreRegions)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(StoreRegions, [{
    key: 'get',
    value: function get() {
      var _this2 = this;

      if (this.cachedRegions && this.regionCacheTime && __WEBPACK_IMPORTED_MODULE_7_moment___default()().diff(this.regionCacheTime, 'seconds') < this.cacheTimeNormal) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(this.cachedRegions);
      }

      var params = {};
      params.getPriceLists = 1;
      params.getCustomerGroupPriceLists = 1;
      params.request = 'getStoreRegions';

      return this.fetchAllRecords('', params).then(function (regions) {
        _this2.cachedRegions = regions;
        _this2.regionCacheTime = __WEBPACK_IMPORTED_MODULE_7_moment___default()();
        return regions;
      }).catch(function (response) {
        return _this2.handleErrorResponse(response);
      });
    }
  }, {
    key: 'getById',
    value: function getById(id) {
      return this.get().then(function (regions) {
        return regions.find(function (region) {
          return region.storeRegionID === id;
        });
      });
    }
  }]);

  return StoreRegions;
}(__WEBPACK_IMPORTED_MODULE_6__Service__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = StoreRegions;

/***/ }),

/***/ 1226:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getAttribute;
function getAttribute(record, attributeName) {
  if (typeof record.attributes === 'undefined') {
    return null;
  }

  return record.attributes.reduce(function (result, attribute) {
    if (attribute.attributeName === attributeName) {
      return attribute.attributeValue;
    } else {
      return result;
    }
  }, null);
}

/***/ }),

/***/ 1227:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var EventToProductIdsTransformer = function () {
  function EventToProductIdsTransformer() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, EventToProductIdsTransformer);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(EventToProductIdsTransformer, [{
    key: "transform",
    value: function transform(event) {
      var discountedProductIds = event.discountedProducts.map(function (product) {
        return product.id;
      });
      var promotedProductIds = event.specialPromotions.reduce(function (result, promotion) {
        if (promotion.rewards.awardedProducts) {
          result = result.concat(promotion.rewards.awardedProducts.map(function (product) {
            return product.productId;
          }));
        }

        if (promotion.requirements.purchasedProducts) {
          result = result.concat(promotion.requirements.purchasedProducts.map(function (product) {
            return product.productId;
          }));
        }

        return result;
      }, []);

      return discountedProductIds.concat(promotedProductIds);
    }
  }]);

  return EventToProductIdsTransformer;
}();

/* harmony default export */ __webpack_exports__["a"] = EventToProductIdsTransformer;

/***/ }),

/***/ 1228:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PriceListsAndPromotionsToEventTransformer__ = __webpack_require__(191);




var PriceListsAndPromotionsToEventsTransformer = function () {
  function PriceListsAndPromotionsToEventsTransformer() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PriceListsAndPromotionsToEventsTransformer);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(PriceListsAndPromotionsToEventsTransformer, [{
    key: 'transform',
    value: function transform(masterPriceLists, relatedPriceLists, promotions) {
      var eventTransformer = new __WEBPACK_IMPORTED_MODULE_2__PriceListsAndPromotionsToEventTransformer__["a" /* default */]();
      var events = [];

      for (var i = 0; i < masterPriceLists.length; i++) {
        var master = masterPriceLists[i];

        {

          var masterRelated = relatedPriceLists[i] ? relatedPriceLists[i] : [];
          var masterPromotions = promotions[i] ? promotions[i] : [];
          var event = eventTransformer.transform(master, masterRelated, masterPromotions);
          event.speaApiVersion = master.speaApiVersion;
          events.push(event);
        }
      }
      return events;
    }
  }]);

  return PriceListsAndPromotionsToEventsTransformer;
}();

/* harmony default export */ __webpack_exports__["a"] = PriceListsAndPromotionsToEventsTransformer;

/***/ }),

/***/ 1229:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model_EventRepository__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__validators_greaterOrEqualTo__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__validators_noMatchinOccurrences__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EditEvent_EventForm_vue__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EditEvent_EventForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__EditEvent_EventForm_vue__);






/* harmony default export */ __webpack_exports__["default"] = {
  name: 'AddEventView',

  data: function data() {
    return {
      loading: false,

      regions: [],
      types: [],
      eventCodeOccurrences: [],

      event: {
        eventCode: '',
        name: '',
        regionId: null,
        startDate: null,
        endDate: null,
        type: null,
        notes: null,
        discountedProducts: []
      }
    };
  },


  computed: {
    regionOptions: function regionOptions() {
      return this.regions.map(function (region) {
        return {
          text: region.name,
          value: region.storeRegionID
        };
      });
    }
  },

  validations: {
    event: {
      name: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      eventCode: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
        unique: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__validators_noMatchinOccurrences__["a" /* default */])('eventCodeOccurrences', function (value, parentVm) {
          return {
            regionId: parentVm.regionId,
            eventCode: value.toLowerCase(),
            type: parentVm.type
          };
        })
      },
      startDate: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      endDate: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
        greater: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__validators_greaterOrEqualTo__["a" /* default */])('startDate')
      },
      regionId: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      type: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      }
    }
  },

  components: {
    'event-form': __WEBPACK_IMPORTED_MODULE_4__EditEvent_EventForm_vue___default.a
  },

  methods: {
    load: function load() {
      var _this = this;

      this.loading = true;
      this.types = this.eventRepository.getTypes();

      this.eventRepository.getStoreRegions().then(function (regions) {
        _this.regions = regions;
      }).then(function () {
        _this.loading = false;
      }).catch(function (error) {
        _this.loading = false;
        _this.$reportError(error);
      });
    },
    save: function save() {
      var _this2 = this;

      this.loading = true;

      this.eventRepository.getEventCodeOccurrences().then(function (eventCodeOccurrences) {
        _this2.eventCodeOccurrences = eventCodeOccurrences;
      }).then(function () {
        if (_this2.$v.$invalid) {
          _this2.$v.$touch();
          _this2.loading = false;
          return;
        }

        _this2.eventRepository.createEvent(_this2.event).then(function (event) {
          _this2.$router.push('edit-event/' + event.id);
        }).catch(function (error) {
          _this2.loading = false;
          _this2.$reportError(error);
        });
      });
    }
  },

  created: function created() {
    this.eventRepository = new __WEBPACK_IMPORTED_MODULE_0__model_EventRepository__["a" /* default */](this.$api);
    this.load();
  }
};

/***/ }),

/***/ 1230:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__model_AccountConfigRepository__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__model_EventRepository__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__model_EventProductRepository__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__validators_greaterOrEqualTo__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__validators_inParentBounds__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__validators_noOverlapInSimilarSiblings__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__validators_noMatchinOccurrences__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__validators_noDuplicateOccurrences__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__EditEvent_EventForm_vue__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__EditEvent_EventForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__EditEvent_EventForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__CopyEventItems_vue__ = __webpack_require__(1639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__CopyEventItems_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__CopyEventItems_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_uuid__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_uniq__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_uniq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_lodash_uniq__);



















/* harmony default export */ __webpack_exports__["default"] = {
  name: 'CopyEventView',

  data: function data() {
    return {
      loading: false,
      step: 0,

      regions: [],
      types: [],
      customerGroups: [],
      eventCodeOccurrences: [],
      productOccurrences: [],
      maxCustomerGroupId: null,

      event: {
        eventCode: '',
        name: '',
        regionId: null,
        startDate: null,
        endDate: null,
        type: null,
        notes: null,
        discountedProducts: [],
        specialPromotions: []
      }
    };
  },


  computed: {
    currentProductOccurrences: function currentProductOccurrences() {
      var _this = this;

      var discountOccurrences = this.event.discountedProducts.reduce(function (result, discount) {
        return result.concat(_this.getCurrentDiscountOccurrences(discount));
      }, []);
      var promotionOccurrences = this.event.specialPromotions.reduce(function (result, promotion) {
        return result.concat(_this.getCurrentPromotionOccurrences(promotion));
      }, []);

      return discountOccurrences.concat(promotionOccurrences);
    },
    allProductOccurrences: function allProductOccurrences() {
      return this.productOccurrences.concat(this.currentProductOccurrences);
    }
  },

  validations: function validations() {
    return {
      event: {
        name: {
          required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"]
        },
        eventCode: {
          required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"],
          unique: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__validators_noMatchinOccurrences__["a" /* default */])('eventCodeOccurrences', function (value, parentVm) {
            return {
              regionId: parentVm.regionId,
              eventCode: value.toLowerCase(),
              type: parentVm.type
            };
          })
        },
        startDate: {
          required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"]
        },
        endDate: {
          required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"],
          greater: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__validators_greaterOrEqualTo__["a" /* default */])('startDate')
        },
        regionId: {
          required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"]
        },
        type: {
          required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"]
        },

        discountedProducts: {
          $each: {
            unique: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__validators_noDuplicateOccurrences__["a" /* default */])(this.getCurrentDiscountOccurrences, this.getMatchingDiscountOccurrences, this.getDisplayableDiscountOccurrences),
            startDate: {
              required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"],
              inBounds: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__validators_inParentBounds__["a" /* default */])('event.startDate', 'event.endDate'),
              noOverlap: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__validators_noOverlapInSimilarSiblings__["a" /* default */])('event.discountedProducts', 'startDate', 'endDate', function (discount1, discount2) {
                return discount1.id === discount2.id && discount1.customerGroupId === discount2.customerGroupId;
              })

            },
            endDate: {
              required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"],
              inBounds: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__validators_inParentBounds__["a" /* default */])('event.startDate', 'event.endDate'),
              greater: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__validators_greaterOrEqualTo__["a" /* default */])('startDate'),
              noOverlap: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__validators_noOverlapInSimilarSiblings__["a" /* default */])('event.discountedProducts', 'startDate', 'endDate', function (discount1, discount2) {
                return discount1.id === discount2.id && discount1.customerGroupId === discount2.customerGroupId;
              })

            },
            page: {
              required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"]
            },
            positionOnPage: {
              required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"]
            },
            salesPrice: {
              required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"]
            }
          }
        },

        specialPromotions: {
          $each: {
            unique: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__validators_noDuplicateOccurrences__["a" /* default */])(this.getCurrentPromotionOccurrences, this.getMatchingPromotionOccurrences, this.getDisplayablePromotionOccurrences),
            name: {
              required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"]
            },
            startDate: {
              required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"],
              inBounds: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__validators_inParentBounds__["a" /* default */])('event.startDate', 'event.endDate')
            },
            endDate: {
              required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"],
              inBounds: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__validators_inParentBounds__["a" /* default */])('event.startDate', 'event.endDate'),
              greater: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__validators_greaterOrEqualTo__["a" /* default */])('startDate')
            },
            page: {
              required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"]
            },
            positionOnPage: {
              required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"]
            }
          }
        }
      }
    };
  },


  components: {
    'event-items': __WEBPACK_IMPORTED_MODULE_15__CopyEventItems_vue___default.a,
    'event-form': __WEBPACK_IMPORTED_MODULE_14__EditEvent_EventForm_vue___default.a
  },

  methods: {
    cancel: function cancel() {
      this.$router.push('/');
    },
    getCurrentDiscountOccurrences: function getCurrentDiscountOccurrences(discount) {
      return [{
        customerGroupId: discount.customerGroupId,
        startDate: discount.startDate,
        endDate: discount.endDate,
        regionId: this.event.regionId,
        id: discount.id,
        eventCode: this.event.eventCode
      }];
    },
    getCurrentPromotionOccurrences: function getCurrentPromotionOccurrences(promotion) {
      var _this2 = this;

      if (promotion.rewards.awardedProducts.length) {
        return promotion.rewards.awardedProducts.map(function (product) {
          return {
            customerGroupId: promotion.customerGroupId,
            startDate: promotion.startDate,
            endDate: promotion.endDate,
            regionId: _this2.event.regionId,
            id: product.productId || product.productID,
            eventCode: _this2.event.eventCode
          };
        });
      } else {
        return promotion.requirements.purchasedProducts.map(function (product) {
          return {
            customerGroupId: promotion.customerGroupId,
            startDate: promotion.startDate,
            endDate: promotion.endDate,
            regionId: _this2.event.regionId,
            id: product.productId || product.productID,
            eventCode: _this2.event.eventCode
          };
        });
      }
    },
    getDisplayableDiscountOccurrences: function getDisplayableDiscountOccurrences(discount) {
      var occurrences = this.getMatchingDiscountOccurrences(discount);
      return __WEBPACK_IMPORTED_MODULE_17_lodash_uniq___default()(occurrences.map(function (occurrence) {
        return occurrence.eventCode;
      })).join(', ');
    },
    getMatchingDiscountOccurrences: function getMatchingDiscountOccurrences(discount) {
      console.log('getMatchingPromotionOccurrences in: ', discount);
      var occurrencesToCheck = this.getCurrentDiscountOccurrences(discount);
      var allOccurrences = this.allProductOccurrences;

      var matchCheckFunction = function matchCheckFunction(occurrenceA, occurrenceB) {

        if (occurrenceA.customerGroupId === occurrenceB.customerGroupId && occurrenceA.id === occurrenceB.id) {

          if (occurrenceA.regionId !== occurrenceB.regionId) {
            return true;
          } else return occurrenceA.startDate <= occurrenceB.endDate && occurrenceA.endDate >= occurrenceB.startDate;
        } else {
          return false;
        }
      };

      var ret = occurrencesToCheck.reduce(function (result, occurenceToCheck) {
        return result.concat(allOccurrences.filter(function (occurence) {
          return matchCheckFunction(occurence, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, occurenceToCheck, { regionId: discount.regionId }));
        }));
      }, []);

      return ret;
    },
    getDisplayablePromotionOccurrences: function getDisplayablePromotionOccurrences(promotion) {

      var occurrences = this.getMatchingPromotionOccurrences(promotion);
      return __WEBPACK_IMPORTED_MODULE_17_lodash_uniq___default()(occurrences.map(function (occurrence) {
        return occurrence.eventCode;
      })).join(', ');
    },
    getMatchingPromotionOccurrences: function getMatchingPromotionOccurrences(promotion) {
      var occurrencesToCheck = this.getCurrentPromotionOccurrences(promotion);
      var allOccurrences = this.allProductOccurrences;

      var matchCheckFunction = function matchCheckFunction(occurrenceA, occurrenceB) {
        if (occurrenceA.customerGroupId === occurrenceB.customerGroupId && occurrenceA.id === occurrenceB.id) {

          if (occurrenceA.regionId !== occurrenceB.regionId) {
            return true;
          } else return occurrenceA.startDate <= occurrenceB.endDate && occurrenceA.endDate >= occurrenceB.startDate;
        } else {
          return false;
        }
      };

      var ret = occurrencesToCheck.reduce(function (result, occurenceToCheck) {
        return result.concat(allOccurrences.filter(function (occurence) {
          return matchCheckFunction(occurence, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, occurenceToCheck, { regionId: promotion.regionId }));
        }));
      }, []);

      return ret;
    },
    loadStep0: function loadStep0() {
      var _this3 = this;

      this.loading = true;
      var promises = [];
      var eventId = this.$route.params.id;

      return this.accountConfigRepository.getCustomerGroupIds().then(function (groupIds) {
        _this3.customerGroups = _this3.eventRepository.getCustomerGroups(groupIds);
        _this3.eventRepository.setMaxCustomerGroupId(groupIds.maxGroupId);
      }).then(function () {
        _this3.statuses = _this3.eventRepository.getStatuses();
        _this3.types = _this3.eventRepository.getTypes();

        promises.push(_this3.eventRepository.getEvent(eventId).then(function (event) {
          event.discountedProducts = [];
          event.specialPromotions = [];
          _this3.event = event;
        }));

        promises.push(_this3.eventRepository.getStoreRegions().then(function (regions) {
          _this3.regions = regions;
        }));

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
          _this3.loading = false;
        });
      }).catch(function (error) {
        _this3.loading = false;
        _this3.$reportError(error);
      });
    },
    loadStep1: function loadStep1() {
      var _this4 = this;

      this.loading = true;
      var eventId = this.$route.params.id;

      return this.eventRepository.getEvent(eventId).then(function (event) {
        _this4.event.discountedProducts = event.discountedProducts.map(function (discount) {
          var isCustomDate = discount.startDate !== event.startDate || discount.endDate !== event.endDate;
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(discount, {
            isCustomDate: isCustomDate,
            uuid: __WEBPACK_IMPORTED_MODULE_16_uuid___default.a.v4(),
            regionId: event.regionId,
            startDate: _this4.event.startDate,
            endDate: _this4.event.endDate
          });
        });

        _this4.event.specialPromotions = event.specialPromotions.map(function (promotion) {
          var isCustomDate = promotion.startDate !== event.startDate || promotion.endDate !== event.endDate;
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(promotion, {
            isCustomDate: isCustomDate,
            uuid: __WEBPACK_IMPORTED_MODULE_16_uuid___default.a.v4(),
            regionId: event.regionId,
            startDate: _this4.event.startDate,
            endDate: _this4.event.endDate
          });
        });
      }).then(function () {
        _this4.loading = false;
      }).catch(function (error) {
        _this4.loading = false;
        _this4.$reportError(error);
      });
    },
    nextStep: function nextStep() {
      var _this5 = this;

      console.log('copyEvent.nextStep');
      this.loading = true;

      if (this.$v.$invalid) {
        this.$v.$touch();
        this.loading = false;
        return;
      }

      this.eventRepository.getEventCodeOccurrences().then(function (eventCodeOccurrences) {
        _this5.eventCodeOccurrences = eventCodeOccurrences;
      }).then(function () {
        if (_this5.$v.$invalid) {
          _this5.$v.$touch();
          _this5.loading = false;
          return;
        }

        return _this5.loadStep1().then(function () {
          _this5.$v.$reset();
          _this5.loading = false;
          _this5.step = 1;
        }).catch(function (error) {
          _this5.loading = false;
          _this5.$reportError(error);
        });
      });
    },
    save: function save() {
      var _this6 = this;

      console.log('copyEvent.save');
      this.loading = true;

      if (this.$v.$invalid) {
        this.$v.$touch();
        this.loading = false;
        return;
      }

      console.log(this.eventProductRepository);

      this.eventProductRepository.getProductOccurrences(this.event.regionId, this.event.startDate, this.event.endDate).then(function (productOccurrences) {
        console.log('copyEvent.save - products', productOccurrences);
        _this6.productOccurrences = productOccurrences;
      }).then(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this6.$v.$invalid) {
                  _context.next = 4;
                  break;
                }

                _this6.$v.$touch();
                _this6.loading = false;
                return _context.abrupt('return');

              case 4:

                console.log('pre copyEvent', _this6.event);
                _context.next = 7;
                return _this6.eventRepository.copyEvent(_this6.event).then(function (event) {
                  _this6.$router.push('/edit-event/' + event.id);
                }).catch(function (error) {
                  _this6.loading = false;
                  _this6.$reportError(error);
                });

              case 7:
                return _context.abrupt('return', _context.sent);

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this6);
      })));
    }
  },

  created: function created() {
    this.accountConfigRepository = new __WEBPACK_IMPORTED_MODULE_5__model_AccountConfigRepository__["a" /* default */](this.$api);
    this.eventRepository = new __WEBPACK_IMPORTED_MODULE_6__model_EventRepository__["a" /* default */](this.$api);
    this.eventProductRepository = new __WEBPACK_IMPORTED_MODULE_7__model_EventProductRepository__["a" /* default */](this.$api);
    this.loadStep0();
  }
};

/***/ }),

/***/ 1231:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DiscountedProduct_vue__ = __webpack_require__(1640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DiscountedProduct_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__DiscountedProduct_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SpecialPromotionItem_vue__ = __webpack_require__(1641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SpecialPromotionItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SpecialPromotionItem_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_EditableGrid_vue__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_EditableGrid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_EditableGrid_vue__);




/* harmony default export */ __webpack_exports__["default"] = {
  name: 'CopyEventItemsView',

  props: {
    eventStartDate: {
      type: String
    },
    eventEndDate: {
      type: String
    },
    customerGroups: {
      type: Array,
      required: true
    },
    discountedProducts: {
      type: Array
    },
    specialPromotions: {
      type: Array
    },
    $v: {
      type: Object,
      required: true
    }
  },

  data: function data() {
    return {
      gridFocused: true
    };
  },


  computed: {
    totalRows: function totalRows() {
      return this.discountedProducts.length + this.specialPromotions.length;
    }
  },

  components: {
    'discounted-product': __WEBPACK_IMPORTED_MODULE_0__DiscountedProduct_vue___default.a,
    'special-promotion': __WEBPACK_IMPORTED_MODULE_1__SpecialPromotionItem_vue___default.a,
    'editable-grid': __WEBPACK_IMPORTED_MODULE_2__components_EditableGrid_vue___default.a
  },

  methods: {
    scrollItems: function scrollItems(event) {
      var elem = this.$refs.itemsTableWrapper;
      var scrollMultiplier = event.target.scrollLeft / (event.target.scrollWidth - event.target.offsetWidth);
      elem.scrollLeft = (elem.scrollWidth - elem.offsetWidth) * scrollMultiplier;
    }
  }
};

/***/ }),

/***/ 1232:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_EditableGridRow_vue__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_EditableGridRow_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_EditableGridRow_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_EditableGridCell_vue__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_EditableGridCell_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_EditableGridCell_vue__);



/* harmony default export */ __webpack_exports__["default"] = {
  name: 'DiscountedProductPartialView',

  props: {
    hideStartDate: {
      type: String
    },
    hideEndDate: {
      type: String
    },
    row: Number,
    activeRow: Number,
    activeColumn: Number,
    isBeingEdited: Boolean,
    discount: {
      type: Object,
      required: true
    },
    customerGroups: {
      type: Array,
      required: true
    },
    $v: {
      type: Object,
      required: true
    }
  },

  computed: {
    basePrice: function basePrice() {
      return this.discount.customerGroupId === 0 ? this.discount.regularPrice : this.discount.regularCustomerGroupPrice;
    },
    customerGroupName: function customerGroupName() {
      var _this = this;

      return this.customerGroups.reduce(function (result, customerGroup) {
        return customerGroup.value === _this.discount.customerGroupId ? customerGroup.text : result;
      }, '');
    },
    margin: function margin() {
      var salesPrice = parseFloat(this.discount.salesPrice);
      var cost = parseFloat(this.discount.cost);

      if (isNaN(cost) || isNaN(salesPrice)) {
        return 0;
      }

      if (salesPrice === 0) {
        return 0;
      }

      return (salesPrice - cost) / salesPrice * 100;
    },
    showDates: function showDates() {
      return this.hideStartDate !== this.discount.startDate || this.hideEndDate !== this.discount.endDate;
    }
  },

  components: {
    'editable-grid-row': __WEBPACK_IMPORTED_MODULE_0__components_EditableGridRow_vue___default.a,
    'editable-grid-cell': __WEBPACK_IMPORTED_MODULE_1__components_EditableGridCell_vue___default.a
  },

  created: function created() {
    var _this2 = this;

    this.$on('activated', function (data) {
      _this2.$parent.$emit('activated', data);
    });

    this.$on('edit', function (data) {
      _this2.$parent.$emit('edit', data);
    });
  }
};

/***/ }),

/***/ 1233:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_EditableGridRow_vue__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_EditableGridRow_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_EditableGridRow_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_EditableGridCell_vue__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_EditableGridCell_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_EditableGridCell_vue__);



/* harmony default export */ __webpack_exports__["default"] = {
  name: 'SpecialPromotionItemPartialView',

  props: {
    hideStartDate: {
      type: String
    },
    hideEndDate: {
      type: String
    },
    row: Number,
    activeRow: Number,
    activeColumn: Number,
    isBeingEdited: Boolean,
    item: {
      type: Object,
      required: true
    },
    itemIndex: {
      type: Number,
      required: true
    },
    promotion: {
      type: Object,
      required: true
    },
    customerGroups: {
      type: Array,
      required: true
    },
    $v: {
      type: Object,
      required: true
    }
  },

  data: function data() {
    return {
      types: [{
        text: 'Buy x (PLU) and get y (PLU) reduced or Free',
        value: 'BUY_ITEMS_GET_PERCENTAGE_OFF_ITEMS'
      }, {
        text: 'Buy x (PLU) and get y (PLU) reduced or Free',
        value: 'BUY_ITEMS_GET_SUM_OFF_ITEMS'
      }, {
        text: 'Multi-buy',
        value: 'BUY_ITEMS_FOR_SPECIAL_UNIT_PRICE'
      }, {
        text: 'Spend x$ and get y (PLU) Free or reduced price (% off)',
        value: 'SPEND_GET_PERCENTAGE_OFF_ITEMS'
      }, {
        text: 'Spend x$ and get y (PLU) Free or reduced price (sum of)',
        value: 'SPEND_GET_SUM_OFF_ITEMS'
      }, {
        text: 'Item % off',
        value: 'MULTIBUY_GET_PERCENTAGE_OFF'
      }, {
        text: 'Item $ off',
        value: 'MULTIBUY_GET_SUM_OFF'
      }]
    };
  },


  computed: {
    basePrice: function basePrice() {
      var regularPrice = this.item.regularPrice;
      var regularCustomerGroupPrice = this.item.regularCustomerGroupPrice;

      if (this.promotion.customerGroupId === 0) {
        return regularPrice;
      } else {
        return regularCustomerGroupPrice;
      }
    },
    customerGroupName: function customerGroupName() {
      var _this = this;

      return this.customerGroups.reduce(function (result, customerGroup) {
        return customerGroup.value === _this.promotion.customerGroupId ? customerGroup.text : result;
      }, '');
    },
    discountedPrice: function discountedPrice() {
      if (this.promotion.rewards.sumOff) {
        return this.basePrice - this.promotion.rewards.sumOff;
      } else if (this.promotion.rewards.percentageOff) {
        return this.basePrice - this.basePrice * this.promotion.rewards.percentageOff / 100;
      } else {
        return this.basePrice;
      }
    },
    margin: function margin() {
      var salesPrice = parseFloat(this.discountedPrice);
      var cost = parseFloat(this.item.cost);

      if (isNaN(cost) || isNaN(salesPrice)) {
        return 0;
      }

      if (salesPrice === 0) {
        return 0;
      }

      return (salesPrice - cost) / salesPrice * 100;
    },
    showDates: function showDates() {
      return this.hideStartDate !== this.promotion.startDate || this.hideEndDate !== this.promotion.endDate;
    },
    typeName: function typeName() {
      var _this2 = this;

      var type = this.types.find(function (type) {
        return type.value === _this2.promotion.type;
      });
      if (type) {
        return type.text;
      } else {
        return '';
      }
    }
  },

  components: {
    'editable-grid-row': __WEBPACK_IMPORTED_MODULE_0__components_EditableGridRow_vue___default.a,
    'editable-grid-cell': __WEBPACK_IMPORTED_MODULE_1__components_EditableGridCell_vue___default.a
  },

  created: function created() {
    var _this3 = this;

    this.$on('activated', function (data) {
      _this3.$parent.$emit('activated', data);
    });

    this.$on('edit', function (data) {
      _this3.$parent.$emit('edit', data);
    });
  }
};

/***/ }),

/***/ 1234:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EditEvent_EventForm_vue__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EditEvent_EventForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__EditEvent_EventForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_AccountConfigRepository__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_EventRepository__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__model_EventProductRepository__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__validators_noMatchinOccurrences__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__validators_noDuplicateOccurrences__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_uniq__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_uniq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_uniq__);










/* harmony default export */ __webpack_exports__["default"] = {
  name: 'CopyEventToRegionsView',

  data: function data() {
    return {
      loading: false,

      regions: [],
      types: [],
      customerGroups: [],
      eventCodeOccurrences: [],
      productOccurrences: [],
      maxCustomerGroupId: null,

      event: {
        id: null,
        eventCode: '',
        name: '',
        regionId: null,
        startDate: null,
        endDate: null,
        type: null,
        isConfirmed: false,
        isLocked: false,
        notes: null,
        discountedProducts: []
      },

      events: []
    };
  },


  computed: {
    currentProductOccurrencesPerRegion: function currentProductOccurrencesPerRegion() {
      var _this = this;

      return this.selectedEvents.reduce(function (result, event) {
        var discountOccurrences = event.discountedProducts.reduce(function (result, discount) {
          return result.concat(_this.getCurrentDiscountOccurrences(discount));
        }, []);
        var promotionOccurrences = event.specialPromotions.reduce(function (result, promotion) {
          return result.concat(_this.getCurrentPromotionOccurrences(promotion));
        }, []);

        result[event.regionId] = discountOccurrences.concat(promotionOccurrences);
        return result;
      }, []);
    },
    allProductOccurrencesPerRegion: function allProductOccurrencesPerRegion() {
      var _this2 = this;

      return this.selectedEvents.reduce(function (result, event) {
        var currentProductOccurrences = _this2.currentProductOccurrencesPerRegion[event.regionId];
        var productOccurrences = [];
        if (_this2.productOccurrences[event.regionId]) {
          productOccurrences = _this2.productOccurrences[event.regionId];
        }
        result[event.regionId] = productOccurrences.concat(currentProductOccurrences);
        return result;
      }, []);
    },
    otherRegions: function otherRegions() {
      var _this3 = this;

      return this.regions.filter(function (region) {
        return region.storeRegionID !== _this3.event.regionId;
      });
    },
    selectedEvents: function selectedEvents() {
      var result = [];
      this.events.forEach(function (event, index) {
        if (event.isSelected) {
          result[index] = event;
        }
      });
      return result;
    }
  },

  validations: function validations() {
    return {
      event: {
        name: {},
        eventCode: {},
        startDate: {},
        endDate: {},
        regionId: {},
        type: {}
      },

      selectedEvents: {
        minLength: 1,
        $each: {
          eventCode: {
            unique: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__validators_noMatchinOccurrences__["a" /* default */])('eventCodeOccurrences', function (value, parentVm) {
              return {
                regionId: parentVm.regionId,
                eventCode: value.toLowerCase(),
                type: parentVm.type
              };
            })
          },

          discountedProducts: {
            $each: {
              unique: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__validators_noDuplicateOccurrences__["a" /* default */])(this.getCurrentDiscountOccurrences, this.getMatchingDiscountOccurrences, this.getDisplayableDiscountOccurrences)
            }
          },

          specialPromotions: {
            $each: {
              unique: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__validators_noDuplicateOccurrences__["a" /* default */])(this.getCurrentPromotionOccurrences, this.getMatchingPromotionOccurrences, this.getDisplayablePromotionOccurrences)
            }
          }
        }
      }
    };
  },


  components: {
    'event-form': __WEBPACK_IMPORTED_MODULE_2__EditEvent_EventForm_vue___default.a
  },

  methods: {
    cancel: function cancel() {
      this.$router.push('/');
    },
    combineEventAndRegion: function combineEventAndRegion(event, region) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, event, {
        id: null,
        region: region,
        regionId: region.storeRegionID,
        isSelected: false,
        discountedProducts: event.discountedProducts.map(function (discount) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, discount, {
            regionId: region.storeRegionID
          });
        }),
        specialPromotions: event.specialPromotions.map(function (promotion) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, promotion, {
            regionId: region.storeRegionID
          });
        })
      });
    },
    getCurrentDiscountOccurrences: function getCurrentDiscountOccurrences(discount) {
      return [{
        customerGroupId: discount.customerGroupId,
        startDate: discount.startDate,
        endDate: discount.endDate,
        id: discount.id,
        eventCode: this.event.eventCode
      }];
    },
    getCurrentPromotionOccurrences: function getCurrentPromotionOccurrences(promotion) {
      var _this4 = this;

      if (promotion.rewards.awardedProducts.length) {
        return promotion.rewards.awardedProducts.map(function (product) {
          return {
            customerGroupId: promotion.customerGroupId,
            startDate: promotion.startDate,
            endDate: promotion.endDate,
            id: product.productId,
            eventCode: _this4.event.eventCode
          };
        });
      } else {
        return promotion.requirements.purchasedProducts.map(function (product) {
          return {
            customerGroupId: promotion.customerGroupId,
            startDate: promotion.startDate,
            endDate: promotion.endDate,
            id: product.productId,
            eventCode: _this4.event.eventCode
          };
        });
      }
    },
    getDisplayableDiscountOccurrences: function getDisplayableDiscountOccurrences(discount) {
      var occurrences = this.getMatchingDiscountOccurrences(discount);
      return __WEBPACK_IMPORTED_MODULE_8_lodash_uniq___default()(occurrences.map(function (occurrence) {
        return occurrence.eventCode;
      })).join(', ');
    },
    getMatchingDiscountOccurrences: function getMatchingDiscountOccurrences(discount) {
      var occurrencesToCheck = this.getCurrentDiscountOccurrences(discount);
      var allOccurrences = this.allProductOccurrencesPerRegion[discount.regionId];

      var matchCheckFunction = function matchCheckFunction(occurrenceA, occurrenceB) {
        return occurrenceA.customerGroupId === occurrenceB.customerGroupId && occurrenceA.id === occurrenceB.id && occurrenceA.startDate <= occurrenceB.endDate && occurrenceA.endDate >= occurrenceB.startDate;
      };

      return occurrencesToCheck.reduce(function (result, occurenceToCheck) {
        return result.concat(allOccurrences.filter(function (occurence) {
          return matchCheckFunction(occurence, occurenceToCheck);
        }));
      }, []);
    },
    getDisplayablePromotionOccurrences: function getDisplayablePromotionOccurrences(promotion) {
      var occurrences = this.getMatchingPromotionOccurrences(promotion);
      return __WEBPACK_IMPORTED_MODULE_8_lodash_uniq___default()(occurrences.map(function (occurrence) {
        return occurrence.eventCode;
      })).join(', ');
    },
    getMatchingPromotionOccurrences: function getMatchingPromotionOccurrences(promotion) {
      var occurrencesToCheck = this.getCurrentPromotionOccurrences(promotion);
      var allOccurrences = this.allProductOccurrencesPerRegion[promotion.regionId];

      var matchCheckFunction = function matchCheckFunction(occurrenceA, occurrenceB) {
        return occurrenceA.customerGroupId === occurrenceB.customerGroupId && occurrenceA.id === occurrenceB.id && occurrenceA.startDate <= occurrenceB.endDate && occurrenceA.endDate >= occurrenceB.startDate;
      };

      return occurrencesToCheck.reduce(function (result, occurenceToCheck) {
        return result.concat(allOccurrences.filter(function (occurence) {
          return matchCheckFunction(occurence, occurenceToCheck);
        }));
      }, []);
    },
    load: function load() {
      var _this5 = this;

      this.loading = true;
      var eventId = this.$route.params.id;
      this.statuses = this.eventRepository.getStatuses();
      this.types = this.eventRepository.getTypes();

      return this.accountConfigRepository.getCustomerGroupIds().then(function (groupIds) {
        _this5.customerGroups = _this5.eventRepository.getCustomerGroups(groupIds);
        _this5.eventRepository.setMaxCustomerGroupId(groupIds.maxGroupId);
        _this5.eventProductRepository.setMaxCustomerGroupId(groupIds.maxGroupId);
        _this5.maxCustomerGroupId = groupIds.maxGroupId;
      }).then(function () {
        return _this5.eventRepository.getStoreRegions();
      }).then(function (regions) {
        _this5.regions = regions;
      }).then(function () {
        return _this5.eventRepository.getEvent(eventId);
      }).then(function (event) {
        _this5.event = event;
        _this5.events = _this5.otherRegions.map(function (region) {
          return _this5.combineEventAndRegion(event, region);
        });
      }).then(function () {
        _this5.loading = false;
      }).catch(function (error) {
        _this5.loading = false;
        _this5.$reportError(error);
      });
    },
    save: function save() {
      var _this6 = this;

      this.loading = true;

      var promises = [];

      this.selectedEvents.forEach(function (event) {
        promises.push(_this6.eventProductRepository.getProductOccurrences(event.regionId, event.startDate, event.endDate, event.id).then(function (productOccurrences) {
          _this6.productOccurrences[event.regionId] = productOccurrences;
        }));
      });

      promises.push(this.eventRepository.getEventCodeOccurrences().then(function (eventCodeOccurrences) {
        _this6.eventCodeOccurrences = eventCodeOccurrences;
      }));

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
        if (_this6.$v.$invalid) {
          _this6.$v.$touch();
          _this6.loading = false;
          return;
        }

        promises = _this6.selectedEvents.map(function (event) {
          return _this6.eventRepository.copyEvent(event);
        });

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
          _this6.$router.push('/');
        }).catch(function (error) {
          _this6.loading = false;
          _this6.$reportError(error);
        });
      });
    }
  },

  created: function created() {
    this.accountConfigRepository = new __WEBPACK_IMPORTED_MODULE_3__model_AccountConfigRepository__["a" /* default */](this.$api);
    this.eventRepository = new __WEBPACK_IMPORTED_MODULE_4__model_EventRepository__["a" /* default */](this.$api);
    this.eventProductRepository = new __WEBPACK_IMPORTED_MODULE_5__model_EventProductRepository__["a" /* default */](this.$api);
    this.load();
  }
};

/***/ }),

/***/ 1235:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AddPromotion_SpendXForDiscount_vue__ = __webpack_require__(1647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AddPromotion_SpendXForDiscount_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__AddPromotion_SpendXForDiscount_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AddPromotion_MultiBuy_vue__ = __webpack_require__(1646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AddPromotion_MultiBuy_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__AddPromotion_MultiBuy_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AddPromotion_BuyXForDiscount_vue__ = __webpack_require__(1644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AddPromotion_BuyXForDiscount_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__AddPromotion_BuyXForDiscount_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AddPromotion_BuyXGetYOff_vue__ = __webpack_require__(1645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AddPromotion_BuyXGetYOff_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__AddPromotion_BuyXGetYOff_vue__);





/* harmony default export */ __webpack_exports__["default"] = {
  name: 'AddPromotionPartialView',

  props: {
    value: Object,
    regionId: Number,
    maxCustomerGroupId: Number,
    shown: Boolean
  },

  data: function data() {
    return {
      loading: false,
      types: [{
        text: 'Spend $x and get y (PLU) Free or reduced price',
        value: 'SPEND_X_FOR_DISCOUNT'
      }, {
        text: 'Multi-buy',
        value: 'MULTI_BUY'
      }, {
        text: 'Buy x (PLU) and get y (PLU) reduced or Free',
        value: 'BUY_X_FOR_DISCOUNT'
      }, {
        text: 'Buy Item x and get y off',
        value: 'MULTIBUY_X_FOR_DISCOUNT'
      }],
      promotion: null,
      type: null
    };
  },

  components: {
    'spend-x-for-discount': __WEBPACK_IMPORTED_MODULE_0__AddPromotion_SpendXForDiscount_vue___default.a,
    'buy-x-for-discount': __WEBPACK_IMPORTED_MODULE_2__AddPromotion_BuyXForDiscount_vue___default.a,
    'multi-buy': __WEBPACK_IMPORTED_MODULE_1__AddPromotion_MultiBuy_vue___default.a,
    'buy-x-for-y-off': __WEBPACK_IMPORTED_MODULE_3__AddPromotion_BuyXGetYOff_vue___default.a
  },

  methods: {
    change: function change(promotion) {
      promotion.type = this.type;
      this.$emit('change', promotion);
      this.hide();
    },
    hide: function hide() {
      this.$emit('hide');

      if (!this.type) {
        this.$emit('focus-lost');
      }
    },
    hideType: function hideType() {
      this.type = null;
      this.hide();
    },
    reset: function reset() {
      this.$emit('focus-gained');

      if (this.value) {
        this.promotion = this.value;
        this.type = this.value.type;
      } else {
        this.promotion = null;
        this.type = null;
      }
    }
  }
};

/***/ }),

/***/ 1236:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProductSelect_vue__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProductSelect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ProductSelect_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__validators_requiredOneOfTwo__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProductList_vue__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProductList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ProductList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__validators_greaterOrEqualTo__ = __webpack_require__(56);






/* harmony default export */ __webpack_exports__["default"] = {
  name: 'BuyForDiscount',

  props: {
    value: Object,
    regionId: Number,
    maxCustomerGroupId: Number,
    shown: Boolean
  },

  data: function data() {
    return {
      tab: 0,
      promotion: {
        subsidyPercentageOfDiscount: null,
        rewardsSubsidy: null,
        page: null,
        oncePerDay: null,
        positionOnPage: null,
        requirements: {
          purchasedProducts: [],
          purchasedAmount: null
        },
        rewards: {
          rewardMoneyEarnedPerRedemption: null,
          redemptionLimit: null,
          sumOff: null,
          percentageOff: null,
          awardedAmount: null,
          awardedProducts: []
        }
      },
      purchasedProductSelectShown: false,
      awardedProductSelectShown: false
    };
  },


  computed: {
    name: function name() {
      var name = 'Buy ';
      name += this.promotion.requirements.purchasedAmount ? this.promotion.requirements.purchasedAmount : 'X';
      name += ' (PLU) and get ';
      name += this.promotion.rewards.awardedAmount ? this.promotion.rewards.awardedAmount : 'Y';
      name += ' for ';
      if (this.promotion.rewards.sumOff) {
        name += this.promotion.rewards.sumOff + ' CAD off';
      } else if (this.promotion.rewards.percentageOff) {
        name += this.promotion.rewards.percentageOff + '% off';
      } else {
        name += 'free or reduced price';
      }

      return name;
    },
    nameLat: function nameLat() {
      var name = 'Achetez ';
      name += this.promotion.requirements.purchasedAmount ? this.promotion.requirements.purchasedAmount : 'X';
      name += ' (PLU) et obtenez ';
      name += this.promotion.rewards.awardedAmount ? this.promotion.rewards.awardedAmount : 'Y';
      name += ' avec ';
      if (this.promotion.rewards.sumOff) {
        name += this.promotion.rewards.sumOff + ' CAD de rabais';
      } else if (this.promotion.rewards.percentageOff) {
        name += this.promotion.rewards.percentageOff + '% de rabais';
      } else {
        name += 'de rabais';
      }

      return name;
    },
    discountedPriceFormula: function discountedPriceFormula() {
      var _this = this;

      return function (basePrice) {
        if (_this.promotion.rewards.sumOff) {
          return basePrice - _this.promotion.rewards.sumOff;
        } else if (_this.promotion.rewards.percentageOff) {
          return basePrice - basePrice * _this.promotion.rewards.percentageOff / 100;
        } else {
          return basePrice;
        }
      };
    },
    customerMustBuyError: function customerMustBuyError() {
      return this.$v.promotion.requirements.purchasedAmount.$error || this.$v.promotion.requirements.purchasedProducts.$error;
    },
    customerWillGetError: function customerWillGetError() {
      return this.$v.promotion.rewards.sumOff.$error || this.$v.promotion.rewards.percentageOff.$error || this.$v.promotion.rewards.awardedAmount.$error || this.$v.promotion.rewards.awardedProducts.$error;
    },
    disablePercentageOff: function disablePercentageOff() {
      return this.promotion.type !== 'BUY_ITEMS_GET_PERCENTAGE_OFF_ITEMS' && typeof this.promotion.type !== 'undefined';
    },
    disableSumOff: function disableSumOff() {
      return this.promotion.type !== 'BUY_ITEMS_GET_SUM_OFF_ITEMS' && typeof this.promotion.type !== 'undefined';
    }
  },

  validations: {
    promotion: {
      subsidyPercentageOfDiscount: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      rewardsSubsidy: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      requirements: {
        purchasedProducts: {
          required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
        },
        purchasedAmount: {
          required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
        }
      },
      rewards: {
        redemptionLimit: {
          greater: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__validators_greaterOrEqualTo__["a" /* default */])('promotion.rewards.awardedAmount')
        },
        sumOff: {
          required: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__validators_requiredOneOfTwo__["a" /* default */])('promotion.rewards.percentageOff')
        },
        percentageOff: {
          required: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__validators_requiredOneOfTwo__["a" /* default */])('promotion.rewards.sumOff')
        },
        awardedAmount: {
          required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
        },
        awardedProducts: {
          required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
        }
      }
    }
  },

  components: {
    'product-select': __WEBPACK_IMPORTED_MODULE_0__ProductSelect_vue___default.a,
    'product-list': __WEBPACK_IMPORTED_MODULE_3__ProductList_vue___default.a
  },

  methods: {
    addAwardedProduct: function addAwardedProduct(product) {
      product.id = product.productID;
      product.plu = product.code;
      product.regularPrice = product.regionBasePrice;
      product.regularCustomerGroupPrice = product.regionCustomerGroupBasePrice;
      product.cost = product.regionCost;
      this.promotion.rewards.awardedProducts.push(product);
    },
    addPurchasedProduct: function addPurchasedProduct(product) {
      product.id = product.productID;
      product.plu = product.code;
      this.promotion.requirements.purchasedProducts.push(product);
    },
    hide: function hide(event) {
      if (this.purchasedProductSelectShown || this.awardedProductSelectShown) {
        event.preventDefault();
      } else {
        this.$emit('hide');
      }
    },
    removeAwardedProduct: function removeAwardedProduct(item) {
      this.promotion.rewards.awardedProducts = this.promotion.rewards.awardedProducts.filter(function (product) {
        if (item !== product) {
          return product;
        }
      });
    },
    removePurchasedProduct: function removePurchasedProduct(item) {
      this.promotion.requirements.purchasedProducts = this.promotion.requirements.purchasedProducts.filter(function (product) {
        if (item !== product) {
          return product;
        }
      });
    },
    reset: function reset() {
      this.tab = 0;
      this.$v.$reset();
      if (this.value) {
        this.promotion.customerGroupId = this.value.customerGroupId;
        this.promotion.subsidyPercentageOfDiscount = this.value.subsidyPercentageOfDiscount;
        this.promotion.rewardsSubsidy = this.value.rewardsSubsidy;
        this.promotion.customerGroupId = this.value.customerGroupId;
        this.promotion.oncePerDay = this.value.oncePerDay;
        this.promotion.requirements.purchasedAmount = this.value.requirements.purchasedAmount;
        this.promotion.requirements.purchasedProducts = this.value.requirements.purchasedProducts;
        this.promotion.rewards.rewardMoneyEarnedPerRedemption = this.value.rewards.rewardMoneyEarnedPerRedemption ? this.value.rewards.rewardMoneyEarnedPerRedemption : 0;
        this.promotion.rewards.sumOff = this.value.rewards.sumOff;
        this.promotion.rewards.percentageOff = this.value.rewards.percentageOff;
        this.promotion.rewards.awardedAmount = this.value.rewards.awardedAmount;
        this.promotion.rewards.awardedProducts = this.value.rewards.awardedProducts;
        this.promotion.rewards.redemptionLimit = this.value.rewards.redemptionLimit;
        this.promotion.type = this.value.type;
      } else {
        this.promotion = {
          customerGroupId: 0,
          subsidyPercentageOfDiscount: null,
          rewardsSubsidy: null,
          page: null,
          oncePerDay: 0,
          positionOnPage: null,
          requirements: {
            purchasedProducts: [],
            purchasedAmount: null
          },
          rewards: {
            rewardMoneyEarnedPerRedemption: null,
            redemptionLimit: null,
            sumOff: null,
            percentageOff: null,
            awardedAmount: null,
            awardedProducts: []
          }
        };
      }
    },
    savePromotion: function savePromotion() {
      if (this.$v.$invalid) {
        this.$v.$touch();
        return;
      }

      this.promotion.hasBeenEdited = true;
      this.promotion.name = this.name;
      this.promotion.nameLat = this.nameLat;
      this.$emit('change', this.promotion);
      this.hide();
    }
  }
};

/***/ }),

/***/ 1237:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProductSelect_vue__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProductSelect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ProductSelect_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__validators_requiredOneOfTwo__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProductList_vue__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProductList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ProductList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__validators_greaterOrEqualTo__ = __webpack_require__(56);






/* harmony default export */ __webpack_exports__["default"] = {
  name: 'BuyXGetYOff',

  props: {
    value: Object,
    regionId: Number,
    maxCustomerGroupId: Number,
    shown: Boolean
  },

  data: function data() {
    return {
      tab: 0,
      promotion: {
        targetMargin: null,
        rewardsSubsidy: null,
        page: null,
        oncePerDay: null,
        positionOnPage: null,
        requirements: {
          purchasedProducts: [],
          purchasedAmount: null
        },
        rewards: {
          rewardMoneyEarnedPerRedemption: null,
          redemptionLimit: null,
          salesRedemptionLimit: null,
          sumOff: null,
          percentageOff: null
        }
      },
      purchasedProductSelectShown: false
    };
  },


  computed: {
    name: function name() {
      var name = 'Buy ';
      name += this.promotion.requirements.purchasedAmount ? this.promotion.requirements.purchasedAmount : 'X';
      name += ' and get ';
      if (this.promotion.rewards.sumOff) {
        name += '$' + this.promotion.rewards.sumOff;
      } else if (this.promotion.rewards.percentageOff) {
        name += this.promotion.rewards.percentageOff + '%';
      } else {}

      name += ' off';

      return name;
    },
    nameLat: function nameLat() {
      return this.name;
    },
    discountedPriceFormula: function discountedPriceFormula() {
      var _this = this;

      return function (basePrice) {
        if (_this.promotion.rewards.sumOff) {
          return basePrice - _this.promotion.rewards.sumOff;
        } else if (_this.promotion.rewards.percentageOff) {
          return basePrice - basePrice * _this.promotion.rewards.percentageOff / 100;
        } else {
          return basePrice;
        }
      };
    },
    customerMustBuyError: function customerMustBuyError() {
      return this.$v.promotion.requirements.purchasedAmount.$error || this.$v.promotion.requirements.purchasedProducts.$error;
    },
    customerWillGetError: function customerWillGetError() {
      return this.$v.promotion.rewards.sumOff.$error || this.$v.promotion.rewards.percentageOff.$error;
    },
    disablePercentageOff: function disablePercentageOff() {
      return this.promotion.type !== 'MULTIBUY_GET_PERCENTAGE_OFF' && typeof this.promotion.type !== 'undefined';
    },
    disableSumOff: function disableSumOff() {
      return this.promotion.type !== 'MULTIBUY_GET_SUM_OFF' && typeof this.promotion.type !== 'undefined';
    }
  },

  validations: {
    promotion: {
      targetMargin: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      rewardsSubsidy: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      requirements: {
        purchasedProducts: {
          required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
        },
        purchasedAmount: {
          required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
        }
      },
      rewards: {
        redemptionLimit: {
          greater: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__validators_greaterOrEqualTo__["a" /* default */])('promotion.rewards.awardedAmount')
        },
        sumOff: {
          required: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__validators_requiredOneOfTwo__["a" /* default */])('promotion.rewards.percentageOff')
        },
        percentageOff: {
          required: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__validators_requiredOneOfTwo__["a" /* default */])('promotion.rewards.sumOff')
        }
      }
    }
  },

  components: {
    'product-select': __WEBPACK_IMPORTED_MODULE_0__ProductSelect_vue___default.a,
    'product-list': __WEBPACK_IMPORTED_MODULE_3__ProductList_vue___default.a
  },

  methods: {
    addPurchasedProduct: function addPurchasedProduct(product) {
      product.id = product.productID;
      product.plu = product.code;
      this.promotion.requirements.purchasedProducts.push(product);
    },
    hide: function hide(event) {
      if (this.purchasedProductSelectShown || this.awardedProductSelectShown) {
        event.preventDefault();
      } else {
        this.$emit('hide');
      }
    },
    removeAwardedProduct: function removeAwardedProduct(item) {
      this.promotion.rewards.awardedProducts = this.promotion.rewards.awardedProducts.filter(function (product) {
        if (item !== product) {
          return product;
        }
      });
    },
    removePurchasedProduct: function removePurchasedProduct(item) {
      this.promotion.requirements.purchasedProducts = this.promotion.requirements.purchasedProducts.filter(function (product) {
        if (item !== product) {
          return product;
        }
      });
    },
    reset: function reset() {
      this.tab = 0;
      this.$v.$reset();
      if (this.value) {
        this.promotion.customerGroupId = this.value.customerGroupId;
        this.promotion.targetMargin = this.value.targetMargin;
        this.promotion.rewardsSubsidy = this.value.rewardsSubsidy;
        this.promotion.oncePerDay = this.value.oncePerDay;
        this.promotion.customerGroupId = this.value.customerGroupId;
        this.promotion.requirements.purchasedAmount = this.value.requirements.purchasedAmount;
        this.promotion.requirements.purchasedProducts = this.value.requirements.purchasedProducts;
        this.promotion.rewards.rewardMoneyEarnedPerRedemption = this.value.rewards.rewardMoneyEarnedPerRedemption ? this.value.rewards.rewardMoneyEarnedPerRedemption : 0;
        this.promotion.rewards.sumOff = this.value.rewards.sumOff;
        this.promotion.rewards.percentageOff = this.value.rewards.percentageOff;
        this.promotion.type = this.value.type;
        this.promotion.rewards.redemptionLimit = this.value.rewards.redemptionLimit;
        this.promotion.rewards.salesRedemptionLimit = this.value.rewards.salesRedemptionLimit;
      } else {
        this.promotion = {
          customerGroupId: 0,
          targetMargin: null,
          rewardsSubsidy: null,
          page: null,
          oncePerDay: null,
          positionOnPage: null,
          requirements: {
            purchasedProducts: [],
            purchasedAmount: null
          },
          rewards: {
            rewardMoneyEarnedPerRedemption: null,
            redemptionLimit: null,
            salesRedemptionLimit: null,
            sumOff: null,
            percentageOff: null
          }
        };
      }
    },
    savePromotion: function savePromotion() {
      if (this.$v.$invalid) {
        this.$v.$touch();
        return;
      }

      this.promotion.hasBeenEdited = true;
      this.promotion.name = this.name;
      this.promotion.nameLat = this.nameLat;
      this.$emit('change', this.promotion);
      this.hide();
    }
  }
};

/***/ }),

/***/ 1238:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProductSelect_vue__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProductSelect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ProductSelect_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProductList_vue__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProductList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ProductList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__validators_greaterOrEqualTo__ = __webpack_require__(56);





/* harmony default export */ __webpack_exports__["default"] = {
  name: 'MultiBuy',

  props: {
    value: Object,
    regionId: Number,
    maxCustomerGroupId: Number,
    shown: Boolean
  },

  data: function data() {
    return {
      tab: 0,
      promotion: {
        targetMargin: null,
        page: null,
        oncePerDay: null,
        positionOnPage: null,
        customerGroupId: 0,
        requirements: {
          purchasedProducts: [],
          purchasedAmount: null
        },
        rewards: {
          specialUnitPrice: null,
          maxItemsWithSpecialUnitPrice: null
        }
      },
      purchasedProductSelectShown: false
    };
  },

  computed: {
    name: function name() {
      var name = 'Buy ';
      name += this.promotion.requirements.purchasedAmount ? this.promotion.requirements.purchasedAmount : 'X';
      name += ' up to ';
      name += this.promotion.rewards.maxItemsWithSpecialUnitPrice ? this.promotion.rewards.maxItemsWithSpecialUnitPrice : 'Y';
      name += ' (PLU) ';
      if (this.promotion.rewards.specialUnitPrice) {
        name += 'for ';
        name += this.promotion.rewards.specialUnitPrice + ' CAD';
      } else {
        name += ' for reduced price';
      }

      return name;
    },
    nameLat: function nameLat() {
      var name = 'Achetez ';
      name += this.promotion.requirements.purchasedAmount ? this.promotion.requirements.purchasedAmount : 'X';
      name += " jusqu'à ";
      name += this.promotion.rewards.maxItemsWithSpecialUnitPrice ? this.promotion.rewards.maxItemsWithSpecialUnitPrice : 'Y';
      name += ' (PLU) ';
      if (this.promotion.rewards.specialUnitPrice) {
        name += 'pour ';
        name += this.promotion.rewards.specialUnitPrice + ' CAD';
      } else {
        name += ' de rabais';
      }

      return name;
    },
    discountedPriceFormula: function discountedPriceFormula() {
      var _this = this;

      return function (basePrice) {
        return _this.promotion.rewards.specialUnitPrice ? _this.promotion.rewards.specialUnitPrice : 0;
      };
    },
    customerMustBuyError: function customerMustBuyError() {
      return this.$v.promotion.requirements.purchasedAmount.$error || this.$v.promotion.requirements.purchasedProducts.$error;
    },
    customerWillGetError: function customerWillGetError() {
      return this.$v.promotion.rewards.specialUnitPrice.$error;
    }
  },

  validations: {
    promotion: {
      requirements: {
        purchasedProducts: {
          required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
        },
        purchasedAmount: {
          required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
        }
      },
      rewards: {
        specialUnitPrice: {
          required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
        },
        maxItemsWithSpecialUnitPrice: {
          greater: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__validators_greaterOrEqualTo__["a" /* default */])('promotion.requirements.purchasedAmount')
        }
      }
    }
  },

  components: {
    'product-select': __WEBPACK_IMPORTED_MODULE_0__ProductSelect_vue___default.a,
    'product-list': __WEBPACK_IMPORTED_MODULE_2__ProductList_vue___default.a
  },

  methods: {
    addPurchasedProduct: function addPurchasedProduct(product) {
      product.id = product.productID;
      product.plu = product.code;
      product.regularPrice = product.regionBasePrice;
      product.regularCustomerGroupPrice = product.regionCustomerGroupBasePrice;
      product.cost = product.regionCost;
      this.promotion.requirements.purchasedProducts.push(product);
    },
    hide: function hide(event) {
      if (this.purchasedProductSelectShown) {
        event.preventDefault();
      } else {
        this.$emit('hide');
      }
    },
    removePurchasedProduct: function removePurchasedProduct(item) {
      this.promotion.requirements.purchasedProducts = this.promotion.requirements.purchasedProducts.filter(function (product) {
        if (item !== product) {
          return product;
        }
      });
    },
    reset: function reset() {
      this.tab = 0;
      this.$v.$reset();
      if (this.value) {
        this.promotion.customerGroupId = this.value.customerGroupId;
        this.promotion.targetMargin = this.value.targetMargin;
        this.promotion.oncePerDay = this.value.oncePerDay;
        this.promotion.requirements.purchasedAmount = this.value.requirements.purchasedAmount;
        this.promotion.requirements.purchasedProducts = this.value.requirements.purchasedProducts;
        this.promotion.rewards.specialUnitPrice = this.value.rewards.specialUnitPrice;
        this.promotion.rewards.maxItemsWithSpecialUnitPrice = this.value.rewards.maxItemsWithSpecialUnitPrice;
      } else {
        this.promotion = {
          customerGroupId: 0,
          targetMargin: null,
          page: null,
          oncePerDay: 0,
          positionOnPage: null,
          requirements: {
            purchasedProducts: [],
            purchasedAmount: null
          },
          rewards: {
            specialUnitPrice: null,
            maxItemsWithSpecialUnitPrice: null
          }
        };
      }
    },
    savePromotion: function savePromotion() {
      if (this.$v.$invalid) {
        this.$v.$touch();
        return;
      }

      this.promotion.hasBeenEdited = true;
      this.promotion.name = this.name;
      this.promotion.nameLat = this.nameLat;
      this.$emit('change', this.promotion);
      this.hide();
    }
  }
};

/***/ }),

/***/ 1239:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = {
  name: 'ProductList',

  props: {
    validator: Object,
    value: Array,
    customerGroupId: Number,
    discountedPriceFormula: Function,
    enableSubsidy: {
      type: Boolean,
      default: true
    },
    className: String
  },

  methods: {
    getDiscountedPrice: function getDiscountedPrice(product) {
      return this.discountedPriceFormula(this.getBasePrice(product));
    },
    getBasePrice: function getBasePrice(product) {
      return this.customerGroupId === 0 ? product.regularPrice : product.regularCustomerGroupPrice;
    },
    add: function add() {
      this.$emit('add');
    },
    remove: function remove(product) {
      this.$emit('remove', product);
    }
  }
};

/***/ }),

/***/ 1240:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProductSelect_vue__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProductSelect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ProductSelect_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__validators_requiredOneOfTwo__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProductList_vue__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProductList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ProductList_vue__);





/* harmony default export */ __webpack_exports__["default"] = {
  name: 'SpendXForDiscount',

  props: {
    value: Object,
    regionId: Number,
    maxCustomerGroupId: Number,
    shown: Boolean
  },

  data: function data() {
    return {
      tab: 0,
      promotion: {
        targetMargin: null,
        page: null,
        oncePerDay: null,
        positionOnPage: null,
        requirements: {
          purchaseTotalValue: null
        },
        rewards: {
          percentageOff: null,
          sumOff: null,
          rewardMoneyEarnedPerItem: null,
          awardedAmount: null,
          awardedProducts: []
        }
      },
      awardedProductSelectShown: false
    };
  },


  computed: {
    name: function name() {
      var name = 'Spend ';
      name += this.promotion.requirements.purchaseTotalValue ? this.promotion.requirements.purchaseTotalValue : 'X';
      name += ' CAD and get ';
      name += this.promotion.rewards.awardedAmount ? this.promotion.rewards.awardedAmount : 'Y';
      name += ' for ';
      if (this.promotion.rewards.sumOff) {
        name += this.promotion.rewards.sumOff + ' CAD off';
      } else if (this.promotion.rewards.percentageOff) {
        name += this.promotion.rewards.percentageOff + '% off';
      } else {
        name += 'free or reduced price';
      }

      return name;
    },
    nameLat: function nameLat() {
      var name = 'Dépensez ';
      name += this.promotion.requirements.purchaseTotalValue ? this.promotion.requirements.purchaseTotalValue : 'X';
      name += ' CAD et obtenez ';
      name += this.promotion.rewards.awardedAmount ? this.promotion.rewards.awardedAmount : 'Y';
      name += ' pour ';
      if (this.promotion.rewards.sumOff) {
        name += this.promotion.rewards.sumOff + ' CAD de rabais';
      } else if (this.promotion.rewards.percentageOff) {
        name += this.promotion.rewards.percentageOff + '10% de rabais';
      } else {
        name += 'de rabais';
      }

      return name;
    },
    discountedPriceFormula: function discountedPriceFormula() {
      var _this = this;

      return function (basePrice) {
        if (_this.promotion.rewards.sumOff) {
          return basePrice - _this.promotion.rewards.sumOff;
        } else if (_this.promotion.rewards.percentageOff) {
          return basePrice - basePrice * _this.promotion.rewards.percentageOff / 100;
        } else {
          return basePrice;
        }
      };
    },
    customerMustBuyError: function customerMustBuyError() {
      return this.$v.promotion.requirements.purchaseTotalValue.$error;
    },
    customerWillGetError: function customerWillGetError() {
      return this.$v.promotion.rewards.sumOff.$error || this.$v.promotion.rewards.percentageOff.$error || this.$v.promotion.rewards.awardedAmount.$error || this.$v.promotion.rewards.awardedProducts.$error;
    },
    disablePercentageOff: function disablePercentageOff() {
      return this.promotion.type !== 'SPEND_GET_PERCENTAGE_OFF_ITEMS' && typeof this.promotion.type !== 'undefined';
    },
    disableSumOff: function disableSumOff() {
      return this.promotion.type !== 'SPEND_GET_SUM_OFF_ITEMS' && typeof this.promotion.type !== 'undefined';
    }
  },

  validations: {
    promotion: {
      requirements: {
        purchaseTotalValue: {
          required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
        }
      },
      rewards: {
        percentageOff: {
          required: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__validators_requiredOneOfTwo__["a" /* default */])('promotion.rewards.sumOff')
        },
        sumOff: {
          required: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__validators_requiredOneOfTwo__["a" /* default */])('promotion.rewards.percentageOff')
        },
        awardedAmount: {
          required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
        },
        awardedProducts: {
          required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
        }
      }
    }
  },

  components: {
    'product-select': __WEBPACK_IMPORTED_MODULE_0__ProductSelect_vue___default.a,
    'product-list': __WEBPACK_IMPORTED_MODULE_3__ProductList_vue___default.a
  },
  methods: {
    showProductSelect: function showProductSelect() {
      this.awardedProductSelectShown = true;
    },
    addAwardedProduct: function addAwardedProduct(product) {
      product.id = product.productID;
      product.plu = product.code;
      product.regularPrice = product.regionBasePrice;
      product.regularCustomerGroupPrice = product.regionCustomerGroupBasePrice;
      product.cost = product.regionCost;
      this.promotion.rewards.awardedProducts.push(product);
    },
    hide: function hide(event) {
      if (this.awardedProductSelectShown) {
        event.preventDefault();
      } else {
        this.$emit('hide');
      }
    },
    removeAwardedProduct: function removeAwardedProduct(item) {
      this.promotion.rewards.awardedProducts = this.promotion.rewards.awardedProducts.filter(function (product) {
        if (item !== product) {
          return product;
        }
      });
    },
    reset: function reset() {
      this.tab = 0;
      this.$v.$reset();
      if (this.value) {
        this.promotion.customerGroupId = this.value.customerGroupId;
        this.promotion.targetMargin = this.value.targetMargin;
        this.promotion.oncePerDay = this.value.oncePerDay;
        this.promotion.requirements.purchaseTotalValue = this.value.requirements.purchaseTotalValue;
        this.promotion.rewards.sumOff = this.value.rewards.sumOff;
        this.promotion.rewards.percentageOff = this.value.rewards.percentageOff;
        this.promotion.rewards.rewardMoneyEarnedPerItem = this.value.rewards.rewardMoneyEarnedPerItem ? this.value.rewards.rewardMoneyEarnedPerItem : 0;
        this.promotion.rewards.awardedAmount = this.value.rewards.awardedAmount;
        this.promotion.rewards.awardedProducts = this.value.rewards.awardedProducts;
        this.promotion.type = this.value.type;
      } else {
        this.promotion = {
          customerGroupId: 0,
          targetMargin: null,
          page: null,
          oncePerDay: 0,
          positionOnPage: null,
          requirements: {
            purchaseTotalValue: null
          },
          rewards: {
            percentageOff: null,
            sumOff: null,
            rewardMoneyEarnedPerItem: null,
            awardedAmount: null,
            awardedProducts: []
          }
        };
      }
    },
    savePromotion: function savePromotion() {
      if (this.$v.$invalid) {
        this.$v.$touch();
        return;
      }
      this.promotion.hasBeenEdited = true;
      this.promotion.name = this.name;
      this.promotion.nameLat = this.nameLat;
      console.log("saving promotion", this.promotion);
      this.$emit('change', this.promotion);
      this.hide();
    }
  }
};

/***/ }),

/***/ 1241:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_EditableGridRow_vue__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_EditableGridRow_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_EditableGridRow_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_EditableGridCell_vue__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_EditableGridCell_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_EditableGridCell_vue__);



/* harmony default export */ __webpack_exports__["default"] = {
  name: 'DiscountedProductPartialView',

  props: {
    hideStartDate: {
      type: String
    },
    hideEndDate: {
      type: String
    },
    row: Number,
    activeRow: Number,
    activeColumn: Number,
    isBeingEdited: Boolean,
    discount: {
      type: Object,
      required: true
    },
    customerGroups: {
      type: Array,
      required: true
    },
    $v: {
      type: Object,
      required: true
    }
  },

  computed: {
    basePrice: function basePrice() {
      var regularPrice = this.discount.regularPrice;
      var regularCustomerGroupPrice = this.discount.regularCustomerGroupPrice;

      if (this.discount.customerGroupId === 0) {
        return regularPrice;
      } else {
        return regularCustomerGroupPrice;
      }
    },
    customerGroupName: function customerGroupName() {
      var _this = this;

      return this.customerGroups.reduce(function (result, customerGroup) {
        return customerGroup.value === _this.discount.customerGroupId ? customerGroup.text : result;
      }, '');
    },
    margin: function margin() {
      var salesPrice = parseFloat(this.discount.salesPrice);
      var cost = parseFloat(this.discount.cost);

      if (isNaN(cost) || isNaN(salesPrice)) {
        return 0;
      }

      if (salesPrice === 0) {
        return 0;
      }

      return (salesPrice - cost) / salesPrice * 100;
    },
    showDates: function showDates() {
      return this.hideStartDate !== this.discount.startDate || this.hideEndDate !== this.discount.endDate;
    }
  },

  watch: {
    discount: {
      deep: true,
      handler: function handler(val) {
        this.discount.hasBeenEdited = true;
      }
    }
  },

  components: {
    'editable-grid-row': __WEBPACK_IMPORTED_MODULE_0__components_EditableGridRow_vue___default.a,
    'editable-grid-cell': __WEBPACK_IMPORTED_MODULE_1__components_EditableGridCell_vue___default.a
  },

  methods: {
    deleteDiscount: function deleteDiscount() {
      this.$emit('delete-item', this.discount);
    },
    showProductSelect: function showProductSelect() {
      this.$emit('product-select', this.discount);
    }
  },

  created: function created() {
    var _this2 = this;

    this.$on('activated', function (data) {
      _this2.$parent.$emit('activated', data);
    });

    this.$on('edit', function (data) {
      _this2.$parent.$emit('edit', data);
    });
  }
};

/***/ }),

/***/ 1242:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_AccountConfigRepository__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_EventRepository__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_EventProductRepository__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EditEventItems_vue__ = __webpack_require__(1650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EditEventItems_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__EditEventItems_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__EventForm_vue__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__EventForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__EventForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__validators_greaterOrEqualTo__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__validators_inParentBounds__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__validators_noOverlapInSimilarSiblings__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__validators_noMatchinOccurrences__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__validators_noDuplicateOccurrences__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_uuid__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_uniq__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_uniq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_uniq__);
















/* harmony default export */ __webpack_exports__["default"] = {
  name: 'EditEvenView',

  data: function data() {
    return {
      loading: false,

      regions: [],
      types: [],
      customerGroups: [],
      eventCodeOccurrences: [],
      productOccurrences: [],
      maxCustomerGroupId: null,

      event: {
        id: null,
        eventCode: '',
        name: '',
        regionId: null,
        startDate: null,
        endDate: null,
        type: null,
        isLocked: false,
        isConfirmed: false,
        notes: null,
        discountedProducts: [],
        specialPromotions: [],
        deletedDiscountsAndPromotions: []
      },

      unconfirmationShown: false,
      confirmationShown: false
    };
  },


  computed: {
    currentProductOccurrences: function currentProductOccurrences() {
      var _this = this;

      var discountOccurrences = this.event.discountedProducts.reduce(function (result, discount) {
        return result.concat(_this.getCurrentDiscountOccurrences(discount));
      }, []);
      var promotionOccurrences = this.event.specialPromotions.reduce(function (result, promotion) {
        return result.concat(_this.getCurrentPromotionOccurrences(promotion));
      }, []);

      return discountOccurrences.concat(promotionOccurrences);
    },
    allProductOccurrences: function allProductOccurrences() {
      return this.productOccurrences.concat(this.currentProductOccurrences);
    }
  },

  validations: function validations() {
    return {
      event: {
        name: {
          required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"]
        },
        eventCode: {
          required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"],
          unique: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__validators_noMatchinOccurrences__["a" /* default */])('eventCodeOccurrences', function (value, parentVm) {
            return {
              regionId: parentVm.regionId,
              eventCode: value.toLowerCase(),
              type: parentVm.type
            };
          })
        },
        startDate: {
          required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"]
        },
        endDate: {
          required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"],
          greater: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__validators_greaterOrEqualTo__["a" /* default */])('startDate')
        },
        regionId: {
          required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"]
        },
        type: {
          required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"]
        },
        discountedProducts: {
          $each: {
            unique: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__validators_noDuplicateOccurrences__["a" /* default */])(this.getCurrentDiscountOccurrences, this.getMatchingDiscountOccurrences, this.getDisplayableDiscountOccurrences),
            startDate: {
              required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"],
              inBounds: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__validators_inParentBounds__["a" /* default */])('event.startDate', 'event.endDate'),
              noOverlap: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__validators_noOverlapInSimilarSiblings__["a" /* default */])('event.discountedProducts', 'startDate', 'endDate', function (discount1, discount2) {
                return discount1.id === discount2.id && discount1.customerGroupId === discount2.customerGroupId;
              })
            },
            endDate: {
              required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"],
              inBounds: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__validators_inParentBounds__["a" /* default */])('event.startDate', 'event.endDate'),
              greater: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__validators_greaterOrEqualTo__["a" /* default */])('startDate'),
              noOverlap: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__validators_noOverlapInSimilarSiblings__["a" /* default */])('event.discountedProducts', 'startDate', 'endDate', function (discount1, discount2) {
                return discount1.id === discount2.id && discount1.customerGroupId === discount2.customerGroupId;
              })
            },
            page: {
              required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"]
            },
            positionOnPage: {
              required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"]
            },
            salesPrice: {
              required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"]
            },
            customerGroupId: {
              required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"]
            }
          }
        },
        specialPromotions: {
          $each: {
            unique: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__validators_noDuplicateOccurrences__["a" /* default */])(this.getCurrentPromotionOccurrences, this.getMatchingPromotionOccurrences, this.getDisplayablePromotionOccurrences),
            name: {
              required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"]
            },
            startDate: {
              required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"],
              inBounds: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__validators_inParentBounds__["a" /* default */])('event.startDate', 'event.endDate')
            },
            endDate: {
              required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"],
              inBounds: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__validators_inParentBounds__["a" /* default */])('event.startDate', 'event.endDate'),
              greater: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__validators_greaterOrEqualTo__["a" /* default */])('startDate')
            },
            page: {
              required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"]
            },
            positionOnPage: {
              required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"]
            }
          }
        }
      }
    };
  },


  components: {
    'event-items': __WEBPACK_IMPORTED_MODULE_5__EditEventItems_vue___default.a,
    'event-form': __WEBPACK_IMPORTED_MODULE_6__EventForm_vue___default.a
  },

  methods: {
    cancel: function cancel() {
      this.$router.push('/');
    },
    getCurrentDiscountOccurrences: function getCurrentDiscountOccurrences(discount) {
      return [{
        customerGroupId: discount.customerGroupId,
        startDate: discount.startDate,
        endDate: discount.endDate,
        id: discount.id,
        eventCode: this.event.eventCode
      }];
    },
    getCurrentPromotionOccurrences: function getCurrentPromotionOccurrences(promotion) {
      var _this2 = this;

      if (promotion.rewards.awardedProducts.length > 0) {
        return promotion.rewards.awardedProducts.map(function (product) {
          return {
            customerGroupId: promotion.customerGroupId,
            startDate: promotion.startDate,
            endDate: promotion.endDate,
            id: product.productId || product.productID,
            eventCode: _this2.event.eventCode
          };
        });
      } else {
        return promotion.requirements.purchasedProducts.map(function (product) {
          return {
            customerGroupId: promotion.customerGroupId,
            startDate: promotion.startDate,
            endDate: promotion.endDate,
            id: product.productId || product.productID,
            eventCode: _this2.event.eventCode
          };
        });
      }
    },
    getDisplayableDiscountOccurrences: function getDisplayableDiscountOccurrences(discount) {
      var occurrences = this.getMatchingDiscountOccurrences(discount);
      return __WEBPACK_IMPORTED_MODULE_14_lodash_uniq___default()(occurrences.map(function (occurrence) {
        return occurrence.eventCode;
      })).join(', ');
    },
    getMatchingDiscountOccurrences: function getMatchingDiscountOccurrences(discount) {
      var occurrencesToCheck = this.getCurrentDiscountOccurrences(discount);
      var allOccurrences = this.allProductOccurrences;

      var matchCheckFunction = function matchCheckFunction(occurrenceA, occurrenceB) {
        return occurrenceA.customerGroupId === occurrenceB.customerGroupId && occurrenceA.id === occurrenceB.id && occurrenceA.startDate <= occurrenceB.endDate && occurrenceA.endDate >= occurrenceB.startDate;
      };

      return occurrencesToCheck.reduce(function (result, occurenceToCheck) {
        return result.concat(allOccurrences.filter(function (occurence) {
          return matchCheckFunction(occurence, occurenceToCheck);
        }));
      }, []);
    },
    getDisplayablePromotionOccurrences: function getDisplayablePromotionOccurrences(promotion) {
      var occurrences = this.getMatchingPromotionOccurrences(promotion);
      return __WEBPACK_IMPORTED_MODULE_14_lodash_uniq___default()(occurrences.map(function (occurrence) {
        return occurrence.eventCode;
      })).join(', ');
    },
    getMatchingPromotionOccurrences: function getMatchingPromotionOccurrences(promotion) {
      var occurrencesToCheck = this.getCurrentPromotionOccurrences(promotion);
      var allOccurrences = this.allProductOccurrences;

      var matchCheckFunction = function matchCheckFunction(occurrenceA, occurrenceB) {
        return occurrenceA.customerGroupId === occurrenceB.customerGroupId && occurrenceA.id === occurrenceB.id && occurrenceA.startDate <= occurrenceB.endDate && occurrenceA.endDate >= occurrenceB.startDate;
      };

      return occurrencesToCheck.reduce(function (result, occurenceToCheck) {
        return result.concat(allOccurrences.filter(function (occurence) {
          return matchCheckFunction(occurence, occurenceToCheck);
        }));
      }, []);
    },
    load: function load() {
      var _this3 = this;

      this.loading = true;
      var promises = [];
      var eventId = this.$route.params.id;

      return this.accountConfigRepository.getCustomerGroupIds().then(function (groupIds) {
        _this3.customerGroups = _this3.eventRepository.getCustomerGroups(groupIds);
        _this3.eventRepository.setMaxCustomerGroupId(groupIds.maxGroupId);
        _this3.eventProductRepository.setMaxCustomerGroupId(groupIds.maxGroupId);
        _this3.maxCustomerGroupId = groupIds.maxGroupId;
      }).then(function () {
        _this3.types = _this3.eventRepository.getTypes();
      }).then(function () {
        promises.push(_this3.eventRepository.getStoreRegions().then(function (regions) {
          _this3.regions = regions;
        }));

        promises.push(_this3.eventRepository.getEvent(eventId).then(function (event) {
          event.discountedProducts.map(function (discount) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(discount, {
              uuid: __WEBPACK_IMPORTED_MODULE_13_uuid___default.a.v4()
            });
          });
          event.specialPromotions.map(function (promotion) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(promotion, {
              uuid: __WEBPACK_IMPORTED_MODULE_13_uuid___default.a.v4()
            });
          });

          console.log('EditEvent parse');
          console.log(event);
          _this3.event = event;
        }));

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
          _this3.loading = false;
        });
      }).catch(function (error) {
        _this3.loading = false;
        _this3.$reportError(error);
      });

      console.log('EditEvent load');
    },
    save: function save() {
      var _this4 = this;

      this.loading = true;
      var eventId = this.$route.params.id;

      var promises = [];
      promises.push(this.eventProductRepository.getProductOccurrences(this.event.regionId, this.event.startDate, this.event.endDate, this.event.id).then(function (productOccurrences) {
        _this4.productOccurrences = productOccurrences;
      }));

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
        if (_this4.$v.$invalid) {
          _this4.$v.$touch();
          _this4.loading = false;
          return;
        }

        return _this4.eventRepository.saveEvent(_this4.event).then(function (_ref) {
          var errors = _ref.errors;

          if (typeof errors !== 'undefined' && errors.length > 0) {
            _this4.loading = false;
            _this4.$v.$touch();
          } else {
            _this4.$router.push('/');
          }
        }).catch(function (error) {
          _this4.loading = false;
          _this4.$reportError(error);
        });
      });
    },
    saveAndConfirm: function saveAndConfirm() {
      var _this5 = this;

      if (this.$v.$invalid) {
        this.$v.$touch();
        return;
      }
      this.loading = true;

      return this.eventRepository.saveEvent(this.event).then(function (_ref2) {
        var event = _ref2.event;
        return _this5.eventRepository.confirmEvent(_this5.event);
      }).then(function () {
        return _this5.$router.push('/');
      }).catch(function (error) {
        _this5.loading = false;
        _this5.$reportError(error);
      });
    },
    saveAndUnconfirm: function saveAndUnconfirm() {
      var _this6 = this;

      if (this.$v.$invalid) {
        this.$v.$touch();
        return;
      }
      this.loading = true;

      return this.eventRepository.saveEvent(this.event).then(function (_ref3) {
        var event = _ref3.event;
        return _this6.eventRepository.unconfirmEvent(_this6.event);
      }).then(function () {
        return _this6.$router.push('/');
      }).catch(function (error) {
        _this6.loading = false;
        _this6.$reportError(error);
      });
    }
  },

  created: function created() {
    this.accountConfigRepository = new __WEBPACK_IMPORTED_MODULE_2__model_AccountConfigRepository__["a" /* default */](this.$api);
    this.eventRepository = new __WEBPACK_IMPORTED_MODULE_3__model_EventRepository__["a" /* default */](this.$api);
    this.eventProductRepository = new __WEBPACK_IMPORTED_MODULE_4__model_EventProductRepository__["a" /* default */](this.$api);
    this.load();
  }
};

/***/ }),

/***/ 1243:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProductSelect_vue__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProductSelect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ProductSelect_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AddPromotion_vue__ = __webpack_require__(1643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AddPromotion_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__AddPromotion_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DiscountedProduct_vue__ = __webpack_require__(1648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DiscountedProduct_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__DiscountedProduct_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SpecialPromotionItem_vue__ = __webpack_require__(1651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SpecialPromotionItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__SpecialPromotionItem_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_EditableGrid_vue__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_EditableGrid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_EditableGrid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_uuid__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__model_EventProductRepository__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__transformers_EventAndProductCombiningTransformer__ = __webpack_require__(190);











/* harmony default export */ __webpack_exports__["default"] = {
  name: 'EditEventItemsView',

  props: {
    eventStartDate: {
      type: String
    },
    eventEndDate: {
      type: String
    },
    customerGroups: {
      type: Array,
      required: true
    },
    regionId: {
      type: Number
    },
    eventId: {
      type: String,
      required: true
    },
    maxCustomerGroupId: {
      type: Number
    },
    isEventConfirmed: {
      type: Boolean
    },
    discountedProducts: {
      type: Array
    },
    specialPromotions: {
      type: Array
    },
    deletedDiscountsAndPromotions: {
      type: Array
    },
    $v: {
      type: Object,
      required: true
    }
  },

  data: function data() {
    return {
      productBeingEdited: null,
      promotionBeingEdited: null,
      promotionBeingDeleted: null,

      productSelectShown: false,
      addPromotionShown: false,
      deletePromotionShow: false,

      gridFocused: true
    };
  },


  computed: {
    totalRows: function totalRows() {
      return this.discountedProducts.length + this.specialPromotions.length;
    }
  },

  components: {
    'product-select': __WEBPACK_IMPORTED_MODULE_2__ProductSelect_vue___default.a,
    'add-promotion': __WEBPACK_IMPORTED_MODULE_3__AddPromotion_vue___default.a,
    'discounted-product': __WEBPACK_IMPORTED_MODULE_4__DiscountedProduct_vue___default.a,
    'special-promotion': __WEBPACK_IMPORTED_MODULE_5__SpecialPromotionItem_vue___default.a,
    'editable-grid': __WEBPACK_IMPORTED_MODULE_6__components_EditableGrid_vue___default.a
  },

  methods: {
    addOrUpdateProduct: function addOrUpdateProduct(product) {
      var productToUpdate = void 0;

      if (this.productBeingEdited) {
        productToUpdate = this.productBeingEdited;
      } else {
        console.log("product--------------------------------------", this.customerGroups);
        var newProduct = {
          id: null,
          plu: null,
          name: null,
          customerGroupId: this.customerGroups[0].value,
          startDate: this.eventStartDate,
          endDate: this.eventEndDate,
          page: null,
          positionOnPage: null,
          regularPrice: null,
          regularCustomerGroupPrice: null,
          cost: null,
          salesPrice: null,
          targetMargin: null,
          rewardMoneyEarnedPerItem: null,
          hasBeenEdited: false,
          uuid: __WEBPACK_IMPORTED_MODULE_7_uuid___default.a.v4()
        };

        this.discountedProducts.push(newProduct);
        productToUpdate = this.discountedProducts[this.discountedProducts.length - 1];
      }

      var salesPrice = void 0;
      if (productToUpdate.customerGroupId === this.customerGroups[0].value) {
        salesPrice = product.regionBasePrice;
      } else {
        salesPrice = product.regionCustomerGroupBasePrice;
      }

      productToUpdate.id = product.productID;
      productToUpdate.plu = product.code;
      productToUpdate.name = product.name;
      productToUpdate.regularPrice = product.regionBasePrice;
      productToUpdate.regularCustomerGroupPrice = product.regionCustomerGroupBasePrice;
      productToUpdate.salesPrice = salesPrice;
      productToUpdate.cost = product.regionCost;
      productToUpdate.productId = product.id;
      productToUpdate.hasBeenEdited = product.hasBeenEdited;
    },
    addOrUpdatePromotion: function addOrUpdatePromotion(promotion) {

      console.log('promotion: ', promotion);
      var combiningTransformer = new __WEBPACK_IMPORTED_MODULE_9__transformers_EventAndProductCombiningTransformer__["a" /* default */]();

      var promotionToUpdate = void 0;
      if (this.promotionBeingEdited) {
        promotionToUpdate = this.promotionBeingEdited;
      } else {
        var newPromotion = {
          id: null,
          name: '',
          nameLat: '',
          type: null,
          startDate: this.eventStartDate,
          endDate: this.eventEndDate,
          customerGroupId: this.customerGroups[0].value,
          page: null,
          positionOnPage: null,
          targetMargin: null,
          oncePerDay: null,
          subsidyPercentageOfDiscount: null,
          rewardsSubsidy: 0,
          requirements: {
            purchaseTotalValue: null,
            purchasedAmount: null,
            purchasedProducts: []
          },
          rewards: {
            lowestPriceItemIsAwarded: null,
            redemptionLimit: null,
            salesRedemptionLimit: null,
            maxItemsWithSpecialUnitPrice: null,
            specialUnitPrice: null,
            rewardMoneyEarnedPerItem: null,
            rewardMoneyEarnedPerRedemption: null,
            awardedAmount: null,
            awardedProducts: [],
            sumOff: null,
            percentageOff: null
          },
          uuid: __WEBPACK_IMPORTED_MODULE_7_uuid___default.a.v4(),
          hasBeenEdited: false
        };
        this.specialPromotions.push(newPromotion);
        promotionToUpdate = this.specialPromotions[this.specialPromotions.length - 1];
      }
      var purchasedProducts = [];
      if (promotion.requirements.purchasedProducts) {
        purchasedProducts = promotion.requirements.purchasedProducts.map(function (product) {

          console.log('pre mapProductChanges: ', product);
          var ret = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, combiningTransformer.mapProductChanges(product));

          console.log('!!!!!!!!!!!!!!!!!!!!!!!!!!!!!adding');
          console.log(ret);

          return ret;
        });
        purchasedProducts.sort(function (product1, product2) {
          if (product1.plu < product2.plu) {
            return -1;
          } else if (product1.plu > product2.plu) {
            return 1;
          } else {
            return 0;
          }
        });
      }

      var awardedProducts = [];
      if (promotion.rewards.awardedProducts) {
        awardedProducts = promotion.rewards.awardedProducts.map(function (product) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, product);
        });
        awardedProducts.sort(function (product1, product2) {
          if (product1.plu < product2.plu) {
            return -1;
          } else if (product1.plu > product2.plu) {
            return 1;
          } else {
            return 0;
          }
        });
      }

      switch (promotion.type) {
        case 'SPEND_X_FOR_DISCOUNT':
        case 'SPEND_GET_SUM_OFF_ITEMS':
        case 'SPEND_GET_PERCENTAGE_OFF_ITEMS':
          promotionToUpdate.type = promotion.rewards.sumOff ? 'SPEND_GET_SUM_OFF_ITEMS' : 'SPEND_GET_PERCENTAGE_OFF_ITEMS';
          break;
        case 'MULTI_BUY':
          promotionToUpdate.type = 'BUY_ITEMS_FOR_SPECIAL_UNIT_PRICE';
          break;
        case 'BUY_X_FOR_DISCOUNT':
        case 'BUY_ITEMS_GET_SUM_OFF_ITEMS':
        case 'BUY_ITEMS_GET_PERCENTAGE_OFF_ITEMS':
          promotionToUpdate.type = promotion.rewards.sumOff ? 'BUY_ITEMS_GET_SUM_OFF_ITEMS' : 'BUY_ITEMS_GET_PERCENTAGE_OFF_ITEMS';
          break;
        case 'MULTIBUY_X_FOR_DISCOUNT':
        case 'MULTIBUY_GET_SUM_OFF':
        case 'MULTIBUY_GET_PERCENTAGE_OFF':
          promotionToUpdate.type = promotion.rewards.sumOff ? 'MULTIBUY_GET_SUM_OFF' : 'MULTIBUY_GET_PERCENTAGE_OFF';
          break;
        default:
          break;
      }

      promotionToUpdate.name = promotion.name;
      promotionToUpdate.nameLat = promotion.nameLat;
      promotionToUpdate.rewardsSubsidy = promotion.rewardsSubsidy;
      promotionToUpdate.oncePerDay = promotion.oncePerDay;
      promotionToUpdate.targetMargin = promotion.targetMargin;
      promotionToUpdate.subsidyPercentageOfDiscount = promotion.subsidyPercentageOfDiscount;
      promotionToUpdate.hasBeenEdited = promotion.hasBeenEdited;
      promotionToUpdate.requirements.purchasedAmount = promotion.requirements.purchasedAmount;
      promotionToUpdate.requirements.purchasedProducts = purchasedProducts;
      promotionToUpdate.requirements.purchaseTotalValue = promotion.requirements.purchaseTotalValue;

      promotionToUpdate.rewards.sumOff = promotion.rewards.sumOff;
      promotionToUpdate.rewards.percentageOff = promotion.rewards.percentageOff;
      promotionToUpdate.rewards.awardedAmount = promotion.rewards.awardedAmount;
      promotionToUpdate.rewards.awardedProducts = awardedProducts;
      promotionToUpdate.rewards.maxItemsWithSpecialUnitPrice = promotion.rewards.maxItemsWithSpecialUnitPrice;
      promotionToUpdate.rewards.specialUnitPrice = promotion.rewards.specialUnitPrice;
      promotionToUpdate.rewards.redemptionLimit = promotion.rewards.redemptionLimit;
      promotionToUpdate.rewards.salesRedemptionLimit = promotion.rewards.salesRedemptionLimit;

      if (promotion.rewards.rewardMoneyEarnedPerItem) {
        promotionToUpdate.rewards.rewardMoneyEarnedPerItem = promotion.rewards.rewardMoneyEarnedPerItem;
      } else {
        promotionToUpdate.rewards.rewardMoneyEarnedPerRedemption = promotion.rewards.rewardMoneyEarnedPerRedemption;
      }

      console.log('promotionToUpdate modificator');
      console.log(promotionToUpdate);
      if (promotionToUpdate.type === 'MULTIBUY_X_FOR_DISCOUNT' || promotionToUpdate.type === 'MULTIBUY_GET_PERCENTAGE_OFF' || promotionToUpdate.type === 'MULTIBUY_GET_SUM_OFF') {
        console.log('promotionToUpdate modificator inside');
        promotionToUpdate.rewards.sumOffMatchingItems = promotionToUpdate.rewards.sumOff ? promotionToUpdate.rewards.sumOff.valueOf() : promotionToUpdate.rewards.sumOffMatchingItem;

        promotionToUpdate.rewards.percentageOffMatchingItems = promotionToUpdate.rewards.percentageOff ? promotionToUpdate.rewards.percentageOff.valueOf() : promotionToUpdate.rewards.percentageOffMatchingItem;
      }
      console.log('promotionToUpdate modificator after');
      console.log(promotionToUpdate);
    },
    deleteDiscount: function deleteDiscount(item) {
      var _this = this;

      this.productBeingEdited = null;
      __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].nextTick(function () {
        _this.deletedDiscountsAndPromotions.push(item);
        _this.discountedProducts.splice(_this.discountedProducts.indexOf(item), 1);
      });
    },
    deletePromotion: function deletePromotion() {
      var _this2 = this;

      this.promotionBeingEdited = null;
      __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].nextTick(function () {
        _this2.specialPromotions.splice(_this2.specialPromotions.indexOf(_this2.promotionBeingDeleted), 1);
        _this2.deletedDiscountsAndPromotions.push(_this2.promotionBeingDeleted);
        _this2.promotionBeingDeleted = null;
      });
    },
    scrollItems: function scrollItems(event) {
      var elem = this.$refs.itemsTableWrapper;
      var scrollMultiplier = event.target.scrollLeft / (event.target.scrollWidth - event.target.offsetWidth);
      elem.scrollLeft = (elem.scrollWidth - elem.offsetWidth) * scrollMultiplier;
    },
    showProductSelect: function showProductSelect(item) {
      if (item) {
        this.productBeingEdited = item;
      } else {
        this.productBeingEdited = null;
      }
      this.productSelectShown = true;
    },
    showPromotion: function showPromotion(item) {
      if (item) {
        this.promotionBeingEdited = item;
      } else {
        this.promotionBeingEdited = null;
      }
      this.addPromotionShown = true;
    },
    showPromotionDelete: function showPromotionDelete(item) {
      this.promotionBeingDeleted = item;
      this.deletePromotionShow = true;
    }
  },
  created: function created() {
    this.eventProductRepository = new __WEBPACK_IMPORTED_MODULE_8__model_EventProductRepository__["a" /* default */](this.$api);
  }
};

/***/ }),

/***/ 1244:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = {
  name: 'EventFormPartialView',

  props: {
    value: {
      type: Object,
      required: true
    },
    regions: {
      type: Array,
      required: true
    },
    types: {
      type: Array,
      required: true
    },
    $v: {
      type: Object,
      required: true
    },
    disableType: {
      type: Boolean
    },
    disableRegion: {
      type: Boolean
    },
    disableStartAndEndDate: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    }
  },

  computed: {
    regionOptions: function regionOptions() {
      return this.regions.map(function (region) {
        return {
          text: region.name,
          value: region.storeRegionID
        };
      });
    }
  }
};

/***/ }),

/***/ 1245:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_AccountConfigRepository__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_ProductRepository__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SelectableGrid_vue__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SelectableGrid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_SelectableGrid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SelectableGridRow_vue__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SelectableGridRow_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_SelectableGridRow_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_SelectableGridCell_vue__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_SelectableGridCell_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_SelectableGridCell_vue__);








/* harmony default export */ __webpack_exports__["default"] = {
  name: 'ProductSelectPartialView',

  props: {
    id: String,
    regionId: {
      type: Number
    },
    maxCustomerGroupId: {
      type: Number
    },
    shown: Boolean,
    startDate: String,
    endDate: String
  },

  data: function data() {
    return {
      loading: false,
      searchDone: false,
      searchTerm: null,
      gridFocused: true,
      products: []
    };
  },


  watch: {
    maxCustomerGroupId: function maxCustomerGroupId() {
      this.productRepository.setMaxCustomerGroupId(this.maxCustomerGroupId);
    }
  },

  components: {
    'selectable-grid': __WEBPACK_IMPORTED_MODULE_3__components_SelectableGrid_vue___default.a,
    'selectable-grid-row': __WEBPACK_IMPORTED_MODULE_4__components_SelectableGridRow_vue___default.a,
    'selectable-grid-cell': __WEBPACK_IMPORTED_MODULE_5__components_SelectableGridCell_vue___default.a
  },

  methods: {
    fetchProducts: function fetchProducts() {
      var _this = this;

      this.products = [];
      this.loading = true;
      this.gridFocused = false;

      return this.productRepository.findProductWithBasePricesAndCost(this.searchTerm, this.regionId, this.startDate, this.endDate).then(function (products) {
        _this.products = products;
        _this.loading = false;
        _this.searchDone = true;
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].nextTick(function () {
          _this.gridFocused = true;
        });
      }).catch(function (error) {
        _this.loading = false;
        _this.$reportError(error);
      });
    },
    hide: function hide() {
      this.$emit('hide');
      this.$emit('focus-lost');
    },
    reset: function reset() {
      var _this2 = this;

      this.$emit('focus-gained');

      this.searchDone = false;
      this.searchTerm = '';
      this.products = [];
      setTimeout(function () {
        return _this2.$refs.searchTermContainer.childNodes[0].focus();
      }, 500);
    },
    selectProduct: function selectProduct(product) {
      this.$emit('change', product);
      this.reset();
    }
  },

  created: function created() {
    this.accountConfigRepository = new __WEBPACK_IMPORTED_MODULE_1__model_AccountConfigRepository__["a" /* default */](this.$api);
    this.productRepository = new __WEBPACK_IMPORTED_MODULE_2__model_ProductRepository__["a" /* default */](this.$api);
    this.productRepository.setMaxCustomerGroupId(this.maxCustomerGroupId);
  }
};

/***/ }),

/***/ 1246:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_EditableGridRow_vue__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_EditableGridRow_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_EditableGridRow_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_EditableGridCell_vue__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_EditableGridCell_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_EditableGridCell_vue__);



/* harmony default export */ __webpack_exports__["default"] = {
  name: 'SpecialPromotionPartialView',

  props: {
    hideStartDate: {
      type: String
    },
    hideEndDate: {
      type: String
    },
    row: Number,
    activeRow: Number,
    activeColumn: Number,
    isBeingEdited: Boolean,
    disableDelete: {
      type: Boolean
    },
    item: {
      type: Object,
      required: true
    },
    itemIndex: {
      type: Number,
      required: true
    },
    promotion: {
      type: Object,
      required: true
    },
    customerGroups: {
      type: Array,
      required: true
    },
    $v: {
      type: Object,
      required: true
    }
  },

  data: function data() {
    return {
      types: [{
        text: 'Buy x (PLU) and get y (PLU) reduced or Free',
        value: 'BUY_ITEMS_GET_PERCENTAGE_OFF_ITEMS'
      }, {
        text: 'Buy x (PLU) and get y (PLU) reduced or Free',
        value: 'BUY_ITEMS_GET_SUM_OFF_ITEMS'
      }, {
        text: 'Multi-buy',
        value: 'BUY_ITEMS_FOR_SPECIAL_UNIT_PRICE'
      }, {
        text: 'Spend x$ and get y (PLU) Free or reduced price (% off)',
        value: 'SPEND_GET_PERCENTAGE_OFF_ITEMS'
      }, {
        text: 'Spend x$ and get y (PLU) Free or reduced price (sum of)',
        value: 'SPEND_GET_SUM_OFF_ITEMS'
      }, {
        text: 'Item % off',
        value: 'MULTIBUY_GET_PERCENTAGE_OFF'
      }, {
        text: 'Item $ off',
        value: 'MULTIBUY_GET_SUM_OFF'
      }]
    };
  },


  computed: {
    basePrice: function basePrice() {
      console.log('basePrice');
      console.log(this.item);
      var regularPrice = this.item.regularPrice;
      var regularCustomerGroupPrice = this.item.regularCustomerGroupPrice;

      if (this.promotion.customerGroupId === 0) {
        return regularPrice;
      } else {
        return regularCustomerGroupPrice;
      }
    },
    customerGroupName: function customerGroupName() {
      var _this = this;

      return this.customerGroups.reduce(function (result, customerGroup) {
        return customerGroup.value === _this.promotion.customerGroupId ? customerGroup.text : result;
      }, '');
    },
    discountedPrice: function discountedPrice() {
      console.log('discountedPrice');
      console.log(this.item);
      console.log(this.promotion);
      if (this.promotion.rewards.sumOff) {
        return this.basePrice - this.promotion.rewards.sumOff;
      } else if (this.promotion.rewards.percentageOff) {
        return this.basePrice - this.basePrice * this.promotion.rewards.percentageOff / 100;
      }if (this.promotion.rewards.specialUnitPrice) {
        return this.promotion.rewards.specialUnitPrice;
      } else {
        return this.basePrice;
      }
    },
    margin: function margin() {
      var salesPrice = parseFloat(this.discountedPrice);
      var cost = parseFloat(this.item.cost);

      if (isNaN(cost) || isNaN(salesPrice)) {
        return 0;
      }

      if (salesPrice === 0) {
        return 0;
      }

      return (salesPrice - cost) / salesPrice * 100;
    },
    showDates: function showDates() {
      return this.hideStartDate !== this.promotion.startDate || this.hideEndDate !== this.promotion.endDate;
    },
    typeName: function typeName() {
      var _this2 = this;

      var type = this.types.find(function (type) {
        return type.value === _this2.promotion.type;
      });
      if (type) {
        return type.text;
      } else {
        return '';
      }
    }
  },

  watch: {
    promotion: {
      deep: true,
      handler: function handler(val) {
        this.promotion.hasBeenEdited = true;
      }
    }
  },

  components: {
    'editable-grid-row': __WEBPACK_IMPORTED_MODULE_0__components_EditableGridRow_vue___default.a,
    'editable-grid-cell': __WEBPACK_IMPORTED_MODULE_1__components_EditableGridCell_vue___default.a
  },

  methods: {
    deletePromotion: function deletePromotion() {
      this.$emit('delete-item', this.promotion);
    },
    showPromotion: function showPromotion() {
      this.$emit('show-promotion', this.promotion);
    }
  },

  created: function created() {
    var _this3 = this;

    this.$on('activated', function (data) {
      _this3.$parent.$emit('activated', data);
    });

    this.$on('edit', function (data) {
      _this3.$parent.$emit('edit', data);
    });
  }
};

/***/ }),

/***/ 1247:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_AccountConfigRepository__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_EventRepository__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EventListFilter_vue__ = __webpack_require__(1657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EventListFilter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__EventListFilter_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EventListItem_vue__ = __webpack_require__(1658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EventListItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__EventListItem_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_raven_js__ = __webpack_require__(1627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_raven_js__);







/* harmony default export */ __webpack_exports__["default"] = {
  name: 'EventListView',

  data: function data() {
    return {
      loading: false,

      regions: [],
      filterStatuses: [],
      statuses: [],
      types: [],

      events: [],
      eventsCount: 0,
      eventBeingDeleted: null,
      deleteConfirmShown: false,
      eventBeingLocked: null,
      lockConfirmShown: false,
      eventBeingUnlocked: null,
      unlockConfirmShown: false,

      paginate: ['events'],
      pagination: {
        'current_page': 1,
        'last_page': 1
      }
    };
  },


  computed: {
    itemCount: function itemCount() {
      return this.eventsCount;
    }
  },

  components: {
    'event-list-filter': __WEBPACK_IMPORTED_MODULE_3__EventListFilter_vue___default.a,
    'event-list-item': __WEBPACK_IMPORTED_MODULE_4__EventListItem_vue___default.a
  },

  methods: {
    addEvent: function addEvent() {
      this.$router.push('add-event');
    },
    getFilterParams: function getFilterParams() {
      var filter = this.$store.state.filter;

      filter.types = filter.type;
      return filter;
    },
    applyFilter: function applyFilter() {

      if (!this.$store.currentPage) {
        this.$store.currentPage = 1;
      }

      this.loadWithFilter();
    },
    deleteEvent: function deleteEvent() {
      var _this = this;

      var item = this.eventBeingDeleted;
      this.loading = true;

      return this.eventRepository.deleteEvent(item.id).then(function () {
        _this.loadWithFilter();

        _this.loading = false;
      }).catch(function (error) {
        _this.loading = false;
        _this.$reportError(error);
      });
    },
    confirmEventDelete: function confirmEventDelete(item) {
      this.eventBeingDeleted = item;
      this.deleteConfirmShown = true;
    },
    confirmEventLock: function confirmEventLock(item) {
      this.eventBeingLocked = item;
      this.lockConfirmShown = true;
    },
    confirmEventUnlock: function confirmEventUnlock(item) {
      this.eventBeingUnlocked = item;
      this.unlockConfirmShown = true;
    },
    copyEvent: function copyEvent(event) {
      this.$router.push('copy-event/' + event.id);
    },
    load: function load() {
      var _this2 = this;

      this.loading = true;
      var promises = [];

      this.filterStatuses = [{ text: '-- Any --', value: '' }].concat(this.eventRepository.getStatusesForFilter());

      this.statuses = this.eventRepository.getStatuses();

      this.types = [{ text: '-- Any --', value: '' }].concat(this.eventRepository.getTypes());

      promises.push(this.eventRepository.getStoreRegions().then(function (regions) {
        _this2.regions = regions;
      }));

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
        _this2.loadWithFilter();
      }).catch(function (error) {
        _this2.loading = false;
        _this2.$reportError(error);
      });
    },
    loadWithFilter: function loadWithFilter() {
      var _this3 = this;

      var promises = [];
      this.loading = true;

      if (typeof this.$store.currentPage === 'undefined') {
        this.$store.currentPage = 1;
      }

      promises.push(this.eventRepository.getEventsByPage(this.$store.currentPage, this.getFilterParams()).then(function (resp) {
        console.log("resp", resp);
        _this3.events = resp.records;
        _this3.eventsCount = resp.pagination.recordsTotal;
        _this3.pagination.current_page = _this3.$store.currentPage;
        _this3.pagination.last_page = resp.pagination.lastPage;
      }));

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
        _this3.loading = false;
      }).catch(function (error) {
        _this3.loading = false;
        _this3.$reportError(error);
      });
    },
    editEvent: function editEvent(event) {
      if (event.speaApiVersion) {
        this.$router.push('edit-event/' + event.id);
      }
    },
    lockEvent: function lockEvent() {
      var _this4 = this;

      this.loading = true;
      this.eventRepository.lockEvent(this.eventBeingLocked).then(function () {
        _this4.eventBeingLocked.isLocked = true;
        _this4.loading = false;
      }).catch(function (error) {
        _this4.loading = false;
        _this4.$reportError(error);
      });
    },
    multiCopyEvent: function multiCopyEvent(event) {
      this.$router.push('copy-event-to-regions/' + event.id);
    },
    unlockEvent: function unlockEvent() {
      var _this5 = this;

      this.loading = true;

      var message = '';
      message += 'Account ' + this.$store.state.clientCode;
      message += ' event ' + this.eventBeingUnlocked.code;
      message += ' unlocked by user ID ' + this.$store.state.userId;
      __WEBPACK_IMPORTED_MODULE_5_raven_js___default.a.captureMessage(message, { level: 'info' });

      this.eventRepository.unlockEvent(this.eventBeingUnlocked).then(function () {
        _this5.eventBeingUnlocked.isLocked = false;
        _this5.loading = false;
      }).catch(function (error) {
        _this5.loading = false;
        _this5.$reportError(error);
      });
    },
    viewEvent: function viewEvent(event) {
      if (event.speaApiVersion) {
        this.$router.push('view-event/' + event.id);
      }
    },
    changePage: function changePage() {
      this.$store.currentPage = this.pagination.current_page;
      this.loadWithFilter();
    },
    goToPage: function goToPage(pageNumber) {
      if (this.$refs.paginator) {
        this.$refs.paginator.goToPage(pageNumber);
      }
    }
  },

  created: function created() {
    this.accountConfigRepository = new __WEBPACK_IMPORTED_MODULE_1__model_AccountConfigRepository__["a" /* default */](this.$api);
    this.eventRepository = new __WEBPACK_IMPORTED_MODULE_2__model_EventRepository__["a" /* default */](this.$api);
    this.load();
  }
};

/***/ }),

/***/ 1248:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__validators_greaterOrEqualTo__ = __webpack_require__(56);


/* harmony default export */ __webpack_exports__["default"] = {
  name: 'EventListFilterPartialView',

  props: {
    regions: {
      type: Array,
      required: true
    },
    statuses: {
      type: Array,
      required: true
    },
    types: {
      type: Array,
      required: true
    }
  },

  data: function data() {
    return {
      beingReset: false,
      filter: {
        eventCode: '',
        startDateFrom: '',
        startDateTo: '',
        endDateFrom: '',
        endDateTo: '',
        regionId: '',
        status: '',
        types: ''
      }
    };
  },


  computed: {
    regionOptions: function regionOptions() {
      var options = [{
        text: '-- Any --',
        value: ''
      }];
      for (var i = 0; i < this.regions.length; i++) {
        var region = this.regions[i];
        options.push({
          text: region.name,
          value: region.storeRegionID
        });
      }

      return options;
    }
  },

  validations: {
    filter: {
      startDateTo: {
        greater: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__validators_greaterOrEqualTo__["a" /* default */])('startDateFrom')
      },
      endDateTo: {
        greater: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__validators_greaterOrEqualTo__["a" /* default */])('endDateFrom')
      }
    }
  },

  methods: {
    applyFilter: function applyFilter() {
      this.$v.$touch();
      this.$store.commit('setFilter', this.filter);
      this.$emit('apply');
    },
    resetFilter: function resetFilter() {
      var _this = this;

      this.beingReset = true;
      this.filter = {
        eventCode: '',
        startDateFrom: '',
        startDateTo: '',
        endDateFrom: '',
        endDateTo: '',
        regionId: '',
        status: '',
        types: ''
      };

      setTimeout(function () {
        _this.beingReset = false;
      }, 0);

      this.applyFilter();
    }
  },

  created: function created() {
    this.filter = this.$store.state.filter;
  }
};

/***/ }),

/***/ 1249:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = {
  name: 'EventListItemPartialView',

  props: {
    event: {
      type: Object,
      required: true
    },
    regions: {
      type: Array,
      required: true
    },
    statuses: {
      type: Array,
      required: true
    },
    types: {
      type: Array,
      required: true
    }
  },

  computed: {
    status: function status() {
      if (this.event.isLocked) {
        return 'LOCKED';
      } else if (this.event.isConfirmed) {
        return 'CONFIRMED';
      } else {
        return 'IN_PREPARATION';
      }
    },
    region: function region() {
      var _this = this;

      var matchingRegions = this.regions.filter(function (region) {
        return region.storeRegionID === _this.event.regionId;
      });
      if (matchingRegions[0]) {
        return matchingRegions[0];
      } else {
        return null;
      }
    },
    regionName: function regionName() {
      if (this.region) {
        return this.region.name;
      } else {
        return '';
      }
    },
    statusName: function statusName() {
      var _this2 = this;

      return this.statuses.reduce(function (result, status) {
        return status.value === _this2.status ? status.text : result;
      }, '');
    },
    typeName: function typeName() {
      var _this3 = this;

      return this.types.reduce(function (result, type) {
        return type.value === _this3.event.type ? type.text : result;
      }, '');
    }
  },

  methods: {
    copyEvent: function copyEvent() {
      this.$emit('copy', this.event);
    },
    deleteEvent: function deleteEvent() {
      this.$emit('delete', this.event);
    },
    lockEvent: function lockEvent() {
      this.$emit('lock', this.event);
    },
    multiCopyEvent: function multiCopyEvent() {
      this.$emit('multiCopy', this.event);
    },
    openEvent: function openEvent() {
      if (!this.event.isLocked) {
        this.$emit('edit', this.event);
      } else {
        this.$emit('view', this.event);
      }
    },
    unlockEvent: function unlockEvent() {
      this.$emit('unlock', this.event);
    }
  }
};

/***/ }),

/***/ 1250:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_SelectableGridRow_vue__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_SelectableGridRow_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_SelectableGridRow_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_SelectableGridCell_vue__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_SelectableGridCell_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_SelectableGridCell_vue__);



/* harmony default export */ __webpack_exports__["default"] = {
  name: 'DiscountedProductPartialView',

  props: {
    hideStartDate: {
      type: String
    },
    hideEndDate: {
      type: String
    },
    discount: {
      type: Object,
      required: true
    },
    customerGroups: {
      type: Array,
      required: true
    },
    row: Number,
    activeRow: Number
  },

  computed: {
    basePrice: function basePrice() {
      var regularPrice = this.discount.regularPrice;
      var regularCustomerGroupPrice = this.discount.regularCustomerGroupPrice;

      if (this.discount.customerGroupId === 0) {
        return regularPrice;
      } else {
        return regularCustomerGroupPrice;
      }
    },
    customerGroupName: function customerGroupName() {
      var _this = this;

      return this.customerGroups.reduce(function (result, customerGroup) {
        return customerGroup.value === _this.discount.customerGroupId ? customerGroup.text : result;
      }, '');
    },
    margin: function margin() {
      var salesPrice = parseFloat(this.discount.salesPrice);
      var cost = parseFloat(this.discount.cost);

      if (isNaN(cost) || isNaN(salesPrice)) {
        return 0;
      }

      if (salesPrice === 0) {
        return 0;
      }

      return (salesPrice - cost) / salesPrice * 100;
    },
    showDates: function showDates() {
      return this.hideStartDate !== this.discount.startDate || this.hideEndDate !== this.discount.endDate;
    }
  },

  components: {
    'selectable-grid-row': __WEBPACK_IMPORTED_MODULE_0__components_SelectableGridRow_vue___default.a,
    'selectable-grid-cell': __WEBPACK_IMPORTED_MODULE_1__components_SelectableGridCell_vue___default.a
  }
};

/***/ }),

/***/ 1251:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_SelectableGridRow_vue__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_SelectableGridRow_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_SelectableGridRow_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_SelectableGridCell_vue__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_SelectableGridCell_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_SelectableGridCell_vue__);



/* harmony default export */ __webpack_exports__["default"] = {
  name: 'SpecialPromotionItemPartialView',

  props: {
    hideStartDate: {
      type: String
    },
    hideEndDate: {
      type: String
    },
    row: Number,
    activeRow: Number,
    item: {
      type: Object,
      required: true
    },
    itemIndex: {
      type: Number,
      required: true
    },
    promotion: {
      type: Object,
      required: true
    },
    customerGroups: {
      type: Array,
      required: true
    }
  },

  data: function data() {
    return {
      types: [{
        text: 'Buy x (PLU) and get y (PLU) reduced or Free',
        value: 'BUY_ITEMS_GET_PERCENTAGE_OFF_ITEMS'
      }, {
        text: 'Buy x (PLU) and get y (PLU) reduced or Free',
        value: 'BUY_ITEMS_GET_SUM_OFF_ITEMS'
      }, {
        text: 'Multi-buy',
        value: 'BUY_ITEMS_FOR_SPECIAL_UNIT_PRICE'
      }, {
        text: 'Spend x$ and get y (PLU) Free or reduced price (% off)',
        value: 'SPEND_GET_PERCENTAGE_OFF_ITEMS'
      }, {
        text: 'Spend x$ and get y (PLU) Free or reduced price (sum of)',
        value: 'SPEND_GET_SUM_OFF_ITEMS'
      }, {
        text: 'Item % off',
        value: 'MULTIBUY_GET_PERCENTAGE_OFF'
      }, {
        text: 'Item $ off',
        value: 'MULTIBUY_GET_SUM_OFF'
      }]
    };
  },


  computed: {
    basePrice: function basePrice() {
      var regularPrice = this.item.regularPrice;
      var regularCustomerGroupPrice = this.item.regularCustomerGroupPrice;

      if (this.promotion.customerGroupId === 0) {
        return regularPrice;
      } else {
        return regularCustomerGroupPrice;
      }
    },
    customerGroupName: function customerGroupName() {
      var _this = this;

      return this.customerGroups.reduce(function (result, customerGroup) {
        return customerGroup.value === _this.promotion.customerGroupId ? customerGroup.text : result;
      }, '');
    },
    discountedPrice: function discountedPrice() {

      if (this.promotion.rewards.sumOff) {
        return this.basePrice - this.promotion.rewards.sumOff;
      } else if (this.promotion.rewards.percentageOff) {
        return this.basePrice - this.basePrice * this.promotion.rewards.percentageOff / 100;
      } else if (this.promotion.rewards.specialUnitPrice) {
        return this.promotion.rewards.specialUnitPrice;
      } else {
        return this.basePrice;
      }
    },
    margin: function margin() {
      var salesPrice = parseFloat(this.discountedPrice);
      var cost = parseFloat(this.item.cost);

      if (isNaN(cost) || isNaN(salesPrice)) {
        return 0;
      }

      if (salesPrice === 0) {
        return 0;
      }

      return (salesPrice - cost) / salesPrice * 100;
    },
    showDates: function showDates() {
      return this.hideStartDate !== this.promotion.startDate || this.hideEndDate !== this.promotion.endDate;
    },
    typeName: function typeName() {
      var _this2 = this;

      var type = this.types.find(function (type) {
        return type.value === _this2.promotion.type;
      });
      if (type) {
        return type.text;
      } else {
        return '';
      }
    }
  },

  components: {
    'selectable-grid-row': __WEBPACK_IMPORTED_MODULE_0__components_SelectableGridRow_vue___default.a,
    'selectable-grid-cell': __WEBPACK_IMPORTED_MODULE_1__components_SelectableGridCell_vue___default.a
  },

  methods: {
    showPromotion: function showPromotion() {
      this.$emit('show-promotion', this.promotion);
    }
  }
};

/***/ }),

/***/ 1252:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_EventRepository__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_AccountConfigRepository__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EditEvent_EventForm_vue__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EditEvent_EventForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__EditEvent_EventForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ViewEventItems_vue__ = __webpack_require__(1662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ViewEventItems_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ViewEventItems_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_uuid__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_uuid__);








/* harmony default export */ __webpack_exports__["default"] = {
  name: 'ViewEventView',

  data: function data() {
    return {
      loading: false,

      regions: [],
      types: [],
      customerGroups: [],

      event: {
        id: null,
        eventCode: '',
        name: '',
        regionId: null,
        startDate: null,
        endDate: null,
        type: null,
        isConfirmed: false,
        isLocked: false,
        notes: null,
        discountedProducts: [],
        specialPromotions: []
      }
    };
  },


  validations: {
    event: {
      name: {},
      eventCode: {},
      startDate: {},
      endDate: {},
      regionId: {},
      type: {}
    }
  },

  components: {
    'event-form': __WEBPACK_IMPORTED_MODULE_4__EditEvent_EventForm_vue___default.a,
    'event-items': __WEBPACK_IMPORTED_MODULE_5__ViewEventItems_vue___default.a
  },

  methods: {
    back: function back() {
      this.$router.push('/');
    },
    load: function load() {
      var _this = this;

      this.loading = true;
      var promises = [];
      var eventId = this.$route.params.id;

      return this.accountConfigRepository.getCustomerGroupIds().then(function (groupIds) {
        _this.customerGroups = _this.eventRepository.getCustomerGroups(groupIds);
        _this.eventRepository.setMaxCustomerGroupId(groupIds.maxGroupId);
      }).then(function () {
        _this.types = _this.eventRepository.getTypes();
      }).then(function () {
        promises.push(_this.eventRepository.getEvent(eventId).then(function (event) {
          event.discountedProducts.map(function (discount) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(discount, {
              uuid: __WEBPACK_IMPORTED_MODULE_6_uuid___default.a.v4()
            });
          });
          event.specialPromotions.map(function (promotion) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(promotion, {
              uuid: __WEBPACK_IMPORTED_MODULE_6_uuid___default.a.v4()
            });
          });
          _this.event = event;
        }));

        promises.push(_this.eventRepository.getStoreRegions().then(function (regions) {
          _this.regions = regions;
        }));

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
          _this.loading = false;
        });
      }).catch(function (error) {
        _this.loading = false;
        _this.$reportError(error);
      });
    }
  },

  created: function created() {
    this.accountConfigRepository = new __WEBPACK_IMPORTED_MODULE_3__model_AccountConfigRepository__["a" /* default */](this.$api);
    this.eventRepository = new __WEBPACK_IMPORTED_MODULE_2__model_EventRepository__["a" /* default */](this.$api);
    this.load();
  }
};

/***/ }),

/***/ 1253:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ViewPromotion_vue__ = __webpack_require__(1663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ViewPromotion_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ViewPromotion_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DiscountedProduct_vue__ = __webpack_require__(1659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DiscountedProduct_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__DiscountedProduct_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SpecialPromotionItem_vue__ = __webpack_require__(1660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SpecialPromotionItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__SpecialPromotionItem_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SelectableGrid_vue__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SelectableGrid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_SelectableGrid_vue__);





/* harmony default export */ __webpack_exports__["default"] = {
  name: 'ViewEventItemsView',

  props: {
    eventStartDate: {
      type: String
    },
    eventEndDate: {
      type: String
    },
    customerGroups: {
      type: Array,
      required: true
    },
    discountedProducts: {
      type: Array
    },
    specialPromotions: {
      type: Array
    }
  },

  data: function data() {
    return {
      promotionBeingViewed: null,
      viewPromotionShown: false
    };
  },


  computed: {
    totalRows: function totalRows() {
      return this.discountedProducts.length + this.specialPromotions.length;
    }
  },

  components: {
    'view-promotion': __WEBPACK_IMPORTED_MODULE_0__ViewPromotion_vue___default.a,
    'discounted-product': __WEBPACK_IMPORTED_MODULE_1__DiscountedProduct_vue___default.a,
    'special-promotion': __WEBPACK_IMPORTED_MODULE_2__SpecialPromotionItem_vue___default.a,
    'selectable-grid': __WEBPACK_IMPORTED_MODULE_3__components_SelectableGrid_vue___default.a
  },

  methods: {
    scrollItems: function scrollItems(event) {
      var elem = this.$refs.itemsTableWrapper;
      var scrollMultiplier = event.target.scrollLeft / (event.target.scrollWidth - event.target.offsetWidth);
      elem.scrollLeft = (elem.scrollWidth - elem.offsetWidth) * scrollMultiplier;
    },
    showPromotion: function showPromotion(item) {

      this.promotionBeingViewed = item;
      this.viewPromotionShown = true;
    }
  }
};

/***/ }),

/***/ 1254:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ViewPromotion_SpendXForDiscount_vue__ = __webpack_require__(1667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ViewPromotion_SpendXForDiscount_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ViewPromotion_SpendXForDiscount_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ViewPromotion_MultiBuy_vue__ = __webpack_require__(1666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ViewPromotion_MultiBuy_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ViewPromotion_MultiBuy_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ViewPromotion_BuyXForDiscount_vue__ = __webpack_require__(1664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ViewPromotion_BuyXForDiscount_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ViewPromotion_BuyXForDiscount_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ViewPromotion_BuyXGetYOff_vue__ = __webpack_require__(1665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ViewPromotion_BuyXGetYOff_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ViewPromotion_BuyXGetYOff_vue__);




/* harmony default export */ __webpack_exports__["default"] = {
  name: 'ViewPromotionPartialView',

  props: {
    value: {},
    regionId: {},
    shown: Boolean
  },

  data: function data() {
    return {
      loading: false,
      type: null,
      promotion: null
    };
  },


  components: {
    'spend-x-for-discount': __WEBPACK_IMPORTED_MODULE_0__ViewPromotion_SpendXForDiscount_vue___default.a,
    'buy-x-for-discount': __WEBPACK_IMPORTED_MODULE_2__ViewPromotion_BuyXForDiscount_vue___default.a,
    'multi-buy': __WEBPACK_IMPORTED_MODULE_1__ViewPromotion_MultiBuy_vue___default.a,
    'buy-x-for-y-off': __WEBPACK_IMPORTED_MODULE_3__ViewPromotion_BuyXGetYOff_vue___default.a
  },

  methods: {
    reset: function reset() {
      if (this.value) {
        this.promotion = this.value;
        this.type = this.value.type;
        this.hide();
      }
    },
    hide: function hide() {
      this.$emit('hide');
    }
  }
};

/***/ }),

/***/ 1255:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProductList_vue__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProductList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ProductList_vue__);


/* harmony default export */ __webpack_exports__["default"] = {
  name: 'BuyForDiscount',

  props: {
    value: {},
    shown: Boolean
  },

  data: function data() {
    return {
      tab: 0,
      promotion: {
        subsidyPercentageOfDiscount: null,
        rewardsSubsidy: null,
        page: null,
        oncePerDay: null,
        positionOnPage: null,
        requirements: {
          purchasedProducts: [],
          purchasedAmount: null
        },
        rewards: {
          rewardMoneyEarnedPerRedemption: null,
          redemptionLimit: null,
          sumOff: null,
          percentageOff: null,
          awardedAmount: null,
          awardedProducts: []
        }
      }
    };
  },


  computed: {
    name: function name() {
      var name = 'Buy ';
      name += this.promotion.requirements.purchasedAmount ? this.promotion.requirements.purchasedAmount : 'X';
      name += ' (PLU) and get ';
      name += this.promotion.rewards.awardedAmount ? this.promotion.rewards.awardedAmount : 'Y';
      name += ' for ';
      if (this.promotion.rewards.sumOff) {
        name += this.promotion.rewards.sumOff + ' CAD off';
      } else if (this.promotion.rewards.percentageOff) {
        name += this.promotion.rewards.percentageOff + '% off';
      } else {
        name += 'free or reduced price';
      }

      return name;
    },
    discountedPriceFormula: function discountedPriceFormula() {
      var _this = this;

      return function (basePrice) {
        if (_this.promotion.rewards.sumOff) {
          return basePrice - _this.promotion.rewards.sumOff;
        } else if (_this.promotion.rewards.percentageOff) {
          return basePrice - basePrice * _this.promotion.rewards.percentageOff / 100;
        } else {
          return basePrice;
        }
      };
    }
  },

  components: {
    'product-list': __WEBPACK_IMPORTED_MODULE_0__ProductList_vue___default.a
  },

  methods: {
    reset: function reset() {
      if (this.value) {
        this.promotion.customerGroupId = this.value.customerGroupId;
        this.promotion.subsidyPercentageOfDiscount = this.value.subsidyPercentageOfDiscount;
        this.promotion.rewardsSubsidy = this.value.rewardsSubsidy;
        this.promotion.oncePerDay = this.value.oncePerDay;
        this.promotion.requirements.purchasedAmount = this.value.requirements.purchasedAmount;
        this.promotion.requirements.purchasedProducts = this.value.requirements.purchasedProducts;
        this.promotion.rewards.rewardMoneyEarnedPerRedemption = this.value.rewards.rewardMoneyEarnedPerRedemption;
        this.promotion.rewards.sumOff = this.value.rewards.sumOff;
        this.promotion.rewards.percentageOff = this.value.rewards.percentageOff;
        this.promotion.rewards.awardedAmount = this.value.rewards.awardedAmount;
        this.promotion.rewards.awardedProducts = this.value.rewards.awardedProducts;
        this.promotion.rewards.redemptionLimit = this.value.rewards.redemptionLimit;
      }
    }
  }
};

/***/ }),

/***/ 1256:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProductList_vue__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProductList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ProductList_vue__);


/* harmony default export */ __webpack_exports__["default"] = {
  name: 'BuyXGetYOff',

  props: {
    value: {},
    shown: Boolean
  },

  data: function data() {
    return {
      tab: 0,
      promotion: {
        targetMargin: null,
        rewardsSubsidy: null,
        page: null,
        oncePerDay: null,
        positionOnPage: null,
        requirements: {
          purchasedProducts: [],
          purchasedAmount: null
        },
        rewards: {
          redemptionLimit: null,
          salesRedemptionLimit: null,
          rewardMoneyEarnedPerRedemption: null,
          sumOff: null,
          percentageOff: null
        }
      }
    };
  },


  computed: {
    name: function name() {
      var name = 'Buy ';
      name += this.promotion.requirements.purchasedAmount ? this.promotion.requirements.purchasedAmount : 'X';
      name += ' and get Y';
      name += ' for ';
      if (this.promotion.rewards.sumOff) {
        name += this.promotion.rewards.sumOff + '$ off';
      } else if (this.promotion.rewards.percentageOff) {
        name += this.promotion.rewards.percentageOff + '% off';
      } else {}

      return name;
    },
    discountedPriceFormula: function discountedPriceFormula() {
      var _this = this;

      return function (basePrice) {
        if (_this.promotion.rewards.sumOff) {
          return basePrice - _this.promotion.rewards.sumOff;
        } else if (_this.promotion.rewards.percentageOff) {
          return basePrice - basePrice * _this.promotion.rewards.percentageOff / 100;
        } else {
          return basePrice;
        }
      };
    }
  },

  components: {
    'product-list': __WEBPACK_IMPORTED_MODULE_0__ProductList_vue___default.a
  },

  methods: {
    reset: function reset() {
      if (this.value) {
        this.promotion.customerGroupId = this.value.customerGroupId;
        this.promotion.targetMargin = this.value.targetMargin;
        this.promotion.rewardsSubsidy = this.value.rewardsSubsidy;
        this.promotion.oncePerDay = this.value.oncePerDay;
        this.promotion.requirements.purchasedAmount = this.value.requirements.purchasedAmount;
        this.promotion.requirements.purchasedProducts = this.value.requirements.purchasedProducts;
        this.promotion.rewards.rewardMoneyEarnedPerRedemption = this.value.rewards.rewardMoneyEarnedPerRedemption;
        this.promotion.rewards.sumOff = this.value.rewards.sumOff;
        this.promotion.rewards.percentageOff = this.value.rewards.percentageOff;
        this.promotion.rewards.redemptionLimit = this.value.rewards.redemptionLimit;
        this.promotion.rewards.salesRedemptionLimit = this.value.rewards.salesRedemptionLimit;
      }
    }
  }
};

/***/ }),

/***/ 1257:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProductList_vue__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProductList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ProductList_vue__);


/* harmony default export */ __webpack_exports__["default"] = {
  name: 'MultiBuy',

  props: {
    value: {},
    shown: Boolean
  },

  data: function data() {
    return {
      tab: 0,
      promotion: {
        targetMargin: null,
        page: null,
        oncePerDay: null,
        positionOnPage: null,
        requirements: {
          purchasedProducts: [],
          purchasedAmount: null
        },
        rewards: {
          specialUnitPrice: null,
          maxItemsWithSpecialUnitPrice: null
        }
      }
    };
  },


  computed: {
    name: function name() {
      var name = 'Buy ';
      name += this.promotion.requirements.purchasedAmount ? this.promotion.requirements.purchasedAmount : 'X';
      name += ' up to ';
      name += this.promotion.rewards.maxItemsWithSpecialUnitPrice ? this.promotion.rewards.maxItemsWithSpecialUnitPrice : 'Y';
      name += ' (PLU) ';
      if (this.promotion.rewards.specialUnitPrice) {
        name += 'for ';
        name += this.promotion.rewards.specialUnitPrice + ' CAD';
      } else {
        name += ' for reduced price';
      }

      return name;
    },
    discountedPriceFormula: function discountedPriceFormula() {
      var _this = this;

      return function (basePrice) {
        return _this.promotion.rewards.specialUnitPrice ? _this.promotion.rewards.specialUnitPrice : 0;
      };
    }
  },

  components: {
    'product-list': __WEBPACK_IMPORTED_MODULE_0__ProductList_vue___default.a
  },

  methods: {
    reset: function reset() {
      if (this.value) {
        this.promotion.customerGroupId = this.value.customerGroupId;
        this.promotion.targetMargin = this.value.targetMargin;
        this.promotion.oncePerDay = this.value.oncePerDay;
        this.promotion.requirements.purchasedAmount = this.value.requirements.purchasedAmount;
        this.promotion.requirements.purchasedProducts = this.value.requirements.purchasedProducts;
        this.promotion.rewards.specialUnitPrice = this.value.rewards.specialUnitPrice;
        this.promotion.rewards.maxItemsWithSpecialUnitPrice = this.value.rewards.maxItemsWithSpecialUnitPrice;
      }
    }
  }
};

/***/ }),

/***/ 1258:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = {
  name: 'ProductList',

  props: {
    value: Array,
    customerGroupId: Number,
    discountedPriceFormula: Function,
    enableSubsidy: {
      type: Boolean,
      default: true
    }
  },

  methods: {
    getDiscountedPrice: function getDiscountedPrice(product) {
      return this.discountedPriceFormula(this.getBasePrice(product));
    },
    getBasePrice: function getBasePrice(product) {
      return this.customerGroupId === 0 ? product.regularPrice : product.regularCustomerGroupPrice;
    }
  }
};

/***/ }),

/***/ 1259:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProductList_vue__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProductList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ProductList_vue__);


/* harmony default export */ __webpack_exports__["default"] = {
  name: 'SpendXForDiscount',

  props: {
    value: {},
    shown: Boolean
  },

  data: function data() {
    return {
      tab: 0,
      promotion: {
        targetMargin: null,
        page: null,
        oncePerDay: null,
        positionOnPage: null,
        requirements: {
          purchaseTotalValue: null
        },
        rewards: {
          percentageOff: null,
          sumOff: null,
          rewardMoneyEarnedPerItem: null,
          awardedAmount: null,
          awardedProducts: []
        }
      }
    };
  },


  computed: {
    name: function name() {
      var name = 'Spend ';
      name += this.promotion.requirements.purchaseTotalValue ? this.promotion.requirements.purchaseTotalValue : 'X';
      name += ' CAD and get ';
      name += this.promotion.rewards.awardedAmount ? this.promotion.rewards.awardedAmount : 'Y';
      name += ' for ';
      if (this.promotion.rewards.sumOff) {
        name += this.promotion.rewards.sumOff + ' CAD off';
      } else if (this.promotion.rewards.percentageOff) {
        name += this.promotion.rewards.percentageOff + '% off';
      } else {
        name += 'free or reduced price';
      }

      return name;
    },
    discountedPriceFormula: function discountedPriceFormula() {
      var _this = this;

      return function (basePrice) {
        if (_this.promotion.rewards.sumOff) {
          return basePrice - _this.promotion.rewards.sumOff;
        } else if (_this.promotion.rewards.percentageOff) {
          return basePrice - basePrice * _this.promotion.rewards.percentageOff / 100;
        } else {
          return basePrice;
        }
      };
    }
  },

  components: {
    'product-list': __WEBPACK_IMPORTED_MODULE_0__ProductList_vue___default.a
  },

  methods: {
    reset: function reset() {
      if (this.value) {
        this.promotion.customerGroupId = this.value.customerGroupId;
        this.promotion.targetMargin = this.value.targetMargin;
        this.promotion.oncePerDay = this.value.oncePerDay;
        this.promotion.requirements.purchaseTotalValue = this.value.requirements.purchaseTotalValue;
        this.promotion.rewards.sumOff = this.value.rewards.sumOff;
        this.promotion.rewards.rewardMoneyEarnedPerItem = this.value.rewards.rewardMoneyEarnedPerItem;
        this.promotion.rewards.percentageOff = this.value.rewards.percentageOff;
        this.promotion.rewards.awardedAmount = this.value.rewards.awardedAmount;
        this.promotion.rewards.awardedProducts = this.value.rewards.awardedProducts;
      }
    }
  }
};

/***/ }),

/***/ 127:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1517)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(1210),
  /* template */
  __webpack_require__(1675),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 128:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(1211),
  /* template */
  __webpack_require__(1698),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(1239),
  /* template */
  __webpack_require__(1707),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 130:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(1258),
  /* template */
  __webpack_require__(1668),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 132:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate__);


/* harmony default export */ __webpack_exports__["a"] = function (occurrencesToCheckFunction, matchingOccurrencesFunction, displayableMatchesFunction) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate__["withParams"])({
    type: 'noDuplicateOccurrences',
    matches: displayableMatchesFunction }, function (value) {
    var ret = occurrencesToCheckFunction(value).length === matchingOccurrencesFunction(value).length;

    return ret;
  });
};

/***/ }),

/***/ 133:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);


/* harmony default export */ __webpack_exports__["a"] = function (otherFieldPath) {
  return function (value) {
    var otherValue = __WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(this, otherFieldPath);
    var currentValue = value;

    if (otherValue && currentValue) {
      return false;
    } else if (!otherValue && !currentValue) {
      return false;
    } else {
      return true;
    }
  };
};

/***/ }),

/***/ 1515:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1516:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1517:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1518:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1519:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1520:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1521:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1522:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1523:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1524:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1525:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1526:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1527:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1528:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1529:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1530:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1531:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1619:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 264,
	"./af.js": 264,
	"./ar": 271,
	"./ar-dz": 265,
	"./ar-dz.js": 265,
	"./ar-kw": 266,
	"./ar-kw.js": 266,
	"./ar-ly": 267,
	"./ar-ly.js": 267,
	"./ar-ma": 268,
	"./ar-ma.js": 268,
	"./ar-sa": 269,
	"./ar-sa.js": 269,
	"./ar-tn": 270,
	"./ar-tn.js": 270,
	"./ar.js": 271,
	"./az": 272,
	"./az.js": 272,
	"./be": 273,
	"./be.js": 273,
	"./bg": 274,
	"./bg.js": 274,
	"./bn": 275,
	"./bn.js": 275,
	"./bo": 276,
	"./bo.js": 276,
	"./br": 277,
	"./br.js": 277,
	"./bs": 278,
	"./bs.js": 278,
	"./ca": 279,
	"./ca.js": 279,
	"./cs": 280,
	"./cs.js": 280,
	"./cv": 281,
	"./cv.js": 281,
	"./cy": 282,
	"./cy.js": 282,
	"./da": 283,
	"./da.js": 283,
	"./de": 286,
	"./de-at": 284,
	"./de-at.js": 284,
	"./de-ch": 285,
	"./de-ch.js": 285,
	"./de.js": 286,
	"./dv": 287,
	"./dv.js": 287,
	"./el": 288,
	"./el.js": 288,
	"./en-au": 289,
	"./en-au.js": 289,
	"./en-ca": 290,
	"./en-ca.js": 290,
	"./en-gb": 291,
	"./en-gb.js": 291,
	"./en-ie": 292,
	"./en-ie.js": 292,
	"./en-nz": 293,
	"./en-nz.js": 293,
	"./eo": 294,
	"./eo.js": 294,
	"./es": 296,
	"./es-do": 295,
	"./es-do.js": 295,
	"./es.js": 296,
	"./et": 297,
	"./et.js": 297,
	"./eu": 298,
	"./eu.js": 298,
	"./fa": 299,
	"./fa.js": 299,
	"./fi": 300,
	"./fi.js": 300,
	"./fo": 301,
	"./fo.js": 301,
	"./fr": 304,
	"./fr-ca": 302,
	"./fr-ca.js": 302,
	"./fr-ch": 303,
	"./fr-ch.js": 303,
	"./fr.js": 304,
	"./fy": 305,
	"./fy.js": 305,
	"./gd": 306,
	"./gd.js": 306,
	"./gl": 307,
	"./gl.js": 307,
	"./gom-latn": 308,
	"./gom-latn.js": 308,
	"./he": 309,
	"./he.js": 309,
	"./hi": 310,
	"./hi.js": 310,
	"./hr": 311,
	"./hr.js": 311,
	"./hu": 312,
	"./hu.js": 312,
	"./hy-am": 313,
	"./hy-am.js": 313,
	"./id": 314,
	"./id.js": 314,
	"./is": 315,
	"./is.js": 315,
	"./it": 316,
	"./it.js": 316,
	"./ja": 317,
	"./ja.js": 317,
	"./jv": 318,
	"./jv.js": 318,
	"./ka": 319,
	"./ka.js": 319,
	"./kk": 320,
	"./kk.js": 320,
	"./km": 321,
	"./km.js": 321,
	"./kn": 322,
	"./kn.js": 322,
	"./ko": 323,
	"./ko.js": 323,
	"./ky": 324,
	"./ky.js": 324,
	"./lb": 325,
	"./lb.js": 325,
	"./lo": 326,
	"./lo.js": 326,
	"./lt": 327,
	"./lt.js": 327,
	"./lv": 328,
	"./lv.js": 328,
	"./me": 329,
	"./me.js": 329,
	"./mi": 330,
	"./mi.js": 330,
	"./mk": 331,
	"./mk.js": 331,
	"./ml": 332,
	"./ml.js": 332,
	"./mr": 333,
	"./mr.js": 333,
	"./ms": 335,
	"./ms-my": 334,
	"./ms-my.js": 334,
	"./ms.js": 335,
	"./my": 336,
	"./my.js": 336,
	"./nb": 337,
	"./nb.js": 337,
	"./ne": 338,
	"./ne.js": 338,
	"./nl": 340,
	"./nl-be": 339,
	"./nl-be.js": 339,
	"./nl.js": 340,
	"./nn": 341,
	"./nn.js": 341,
	"./pa-in": 342,
	"./pa-in.js": 342,
	"./pl": 343,
	"./pl.js": 343,
	"./pt": 345,
	"./pt-br": 344,
	"./pt-br.js": 344,
	"./pt.js": 345,
	"./ro": 346,
	"./ro.js": 346,
	"./ru": 347,
	"./ru.js": 347,
	"./sd": 348,
	"./sd.js": 348,
	"./se": 349,
	"./se.js": 349,
	"./si": 350,
	"./si.js": 350,
	"./sk": 351,
	"./sk.js": 351,
	"./sl": 352,
	"./sl.js": 352,
	"./sq": 353,
	"./sq.js": 353,
	"./sr": 355,
	"./sr-cyrl": 354,
	"./sr-cyrl.js": 354,
	"./sr.js": 355,
	"./ss": 356,
	"./ss.js": 356,
	"./sv": 357,
	"./sv.js": 357,
	"./sw": 358,
	"./sw.js": 358,
	"./ta": 359,
	"./ta.js": 359,
	"./te": 360,
	"./te.js": 360,
	"./tet": 361,
	"./tet.js": 361,
	"./th": 362,
	"./th.js": 362,
	"./tl-ph": 363,
	"./tl-ph.js": 363,
	"./tlh": 364,
	"./tlh.js": 364,
	"./tr": 365,
	"./tr.js": 365,
	"./tzl": 366,
	"./tzl.js": 366,
	"./tzm": 368,
	"./tzm-latn": 367,
	"./tzm-latn.js": 367,
	"./tzm.js": 368,
	"./uk": 369,
	"./uk.js": 369,
	"./ur": 370,
	"./ur.js": 370,
	"./uz": 372,
	"./uz-latn": 371,
	"./uz-latn.js": 371,
	"./uz.js": 372,
	"./vi": 373,
	"./vi.js": 373,
	"./x-pseudo": 374,
	"./x-pseudo.js": 374,
	"./yo": 375,
	"./yo.js": 375,
	"./zh-cn": 376,
	"./zh-cn.js": 376,
	"./zh-hk": 377,
	"./zh-hk.js": 377,
	"./zh-tw": 378,
	"./zh-tw.js": 378
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1619;


/***/ }),

/***/ 1635:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1520)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(1212),
  /* template */
  __webpack_require__(1682),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1636:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1525)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(1213),
  /* template */
  __webpack_require__(1692),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1637:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(1229),
  /* template */
  __webpack_require__(1702),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1638:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(1230),
  /* template */
  __webpack_require__(1674),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1639:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1518)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(1231),
  /* template */
  __webpack_require__(1676),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1640:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(1232),
  /* template */
  __webpack_require__(1677),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1641:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(1233),
  /* template */
  __webpack_require__(1697),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1642:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1528)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(1234),
  /* template */
  __webpack_require__(1706),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1643:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(1235),
  /* template */
  __webpack_require__(1689),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1644:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1530)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(1236),
  /* template */
  __webpack_require__(1710),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1645:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1521)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(1237),
  /* template */
  __webpack_require__(1683),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1646:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1531)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(1238),
  /* template */
  __webpack_require__(1711),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1647:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1522)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(1240),
  /* template */
  __webpack_require__(1684),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1648:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(1241),
  /* template */
  __webpack_require__(1712),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1649:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(1242),
  /* template */
  __webpack_require__(1699),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1650:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1516)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(1243),
  /* template */
  __webpack_require__(1673),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1651:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(1246),
  /* template */
  __webpack_require__(1693),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1652:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  null,
  /* template */
  __webpack_require__(1671),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1653:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  null,
  /* template */
  __webpack_require__(1687),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1654:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  null,
  /* template */
  __webpack_require__(1703),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1655:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  null,
  /* template */
  __webpack_require__(1685),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1656:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1523)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(1247),
  /* template */
  __webpack_require__(1686),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1657:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(1248),
  /* template */
  __webpack_require__(1695),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1658:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1524)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(1249),
  /* template */
  __webpack_require__(1691),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1659:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(1250),
  /* template */
  __webpack_require__(1672),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1660:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(1251),
  /* template */
  __webpack_require__(1669),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1661:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(1252),
  /* template */
  __webpack_require__(1690),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1662:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1519)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(1253),
  /* template */
  __webpack_require__(1679),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1663:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(1254),
  /* template */
  __webpack_require__(1681),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1664:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(1255),
  /* template */
  __webpack_require__(1688),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1665:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(1256),
  /* template */
  __webpack_require__(1705),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1666:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(1257),
  /* template */
  __webpack_require__(1678),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1667:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(1259),
  /* template */
  __webpack_require__(1680),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1668:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-form-fieldset', {
    attrs: {
      "label": "from a list of"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("PLU")]), _vm._v(" "), _c('th', [_vm._v("Product")]), _vm._v(" "), (_vm.enableSubsidy) ? _c('th', [_vm._v("Regular price")]) : _vm._e(), _vm._v(" "), (_vm.enableSubsidy) ? _c('th', [_vm._v("Sales price")]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.value), function(product) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(product.plu))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(product.name))]), _vm._v(" "), (_vm.enableSubsidy) ? _c('td', [_vm._v(_vm._s(_vm.getBasePrice(product)))]) : _vm._e(), _vm._v(" "), (_vm.enableSubsidy) ? _c('td', [_vm._v(_vm._s(_vm._f("rounded")(_vm.getDiscountedPrice(product))))]) : _vm._e()])
  }))])])])])
},staticRenderFns: []}

/***/ }),

/***/ 1669:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('selectable-grid-row', {
    attrs: {
      "activeRow": _vm.activeRow
    },
    on: {
      "select": _vm.showPromotion
    }
  }, [_c('selectable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "active-row": _vm.activeRow
    }
  }, [_vm._v("\n    " + _vm._s(_vm.item.plu) + "\n  ")]), _vm._v(" "), _c('selectable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "active-row": _vm.activeRow
    }
  }, [_vm._v("\n    " + _vm._s(_vm._f("fixedLength")(_vm.item.name, 20)) + "\n  ")]), _vm._v(" "), _c('selectable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "active-row": _vm.activeRow
    }
  }, [_vm._v("\n    " + _vm._s(_vm._f("fixedLength")(_vm.typeName, 30)) + "\n  ")]), _vm._v(" "), _c('selectable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "active-row": _vm.activeRow
    }
  }, [_vm._v("\n    " + _vm._s(_vm.customerGroupName) + "\n  ")]), _vm._v(" "), _c('selectable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "active-row": _vm.activeRow
    }
  }, [(_vm.showDates) ? _c('span', [_vm._v("\n      " + _vm._s(_vm._f("formatDate")(_vm.promotion.startDate)) + "\n    ")]) : _vm._e()]), _vm._v(" "), _c('selectable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "active-row": _vm.activeRow
    }
  }, [(_vm.showDates) ? _c('span', [_vm._v("\n      " + _vm._s(_vm._f("formatDate")(_vm.promotion.endDate)) + "\n    ")]) : _vm._e()]), _vm._v(" "), _c('selectable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "active-row": _vm.activeRow
    }
  }, [_vm._v("\n    " + _vm._s(_vm.promotion.page) + "\n  ")]), _vm._v(" "), _c('selectable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "active-row": _vm.activeRow
    }
  }, [_vm._v("\n    " + _vm._s(_vm.promotion.positionOnPage) + "\n  ")]), _vm._v(" "), _c('selectable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "active-row": _vm.activeRow
    }
  }, [_vm._v("\n    " + _vm._s(_vm._f("formatPrice")(_vm.basePrice)) + "\n  ")]), _vm._v(" "), _c('selectable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "active-row": _vm.activeRow
    }
  }, [_vm._v("\n    " + _vm._s(_vm._f("formatPrice")(_vm.item.cost)) + "\n  ")]), _vm._v(" "), _c('selectable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "active-row": _vm.activeRow
    }
  }, [_vm._v("\n    " + _vm._s(_vm._f("formatPrice")(_vm._f("rounded")(_vm.discountedPrice))) + "\n  ")]), _vm._v(" "), _c('selectable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "active-row": _vm.activeRow
    }
  }, [_vm._v("\n    " + _vm._s(_vm._f("rounded")(_vm.margin)) + "%\n  ")]), _vm._v(" "), _c('selectable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "active-row": _vm.activeRow
    }
  }, [_vm._v("\n    " + _vm._s(_vm.promotion.targetMargin)), (_vm.promotion.targetMargin) ? _c('span', [_vm._v("%")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('selectable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "active-row": _vm.activeRow
    }
  }, [_vm._v("\n    " + _vm._s(_vm.promotion.rewards.rewardMoneyEarnedPerItem || _vm.promotion.rewards.rewardMoneyEarnedPerRedemption || '-') + "\n  ")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1670:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    class: {
      'has-danger': _vm.$v.event.name.$error
    },
    attrs: {
      "label": "Event name"
    }
  }, [_c('b-form-input', {
    staticClass: "name",
    attrs: {
      "type": "text",
      "disabled": _vm.disabled
    },
    on: {
      "input": function($event) {
        _vm.$v.event.name.$touch()
      }
    },
    model: {
      value: (_vm.value.name),
      callback: function($$v) {
        _vm.value.name = $$v
      },
      expression: "value.name"
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.event.name.hasOwnProperty('required') && !_vm.$v.event.name.required),
      expression: "$v.event.name.hasOwnProperty('required') && !$v.event.name.required"
    }],
    staticClass: "EventFormPartialView__error"
  }, [_vm._v("\n            Event name required\n          ")])], 1), _vm._v(" "), _c('b-form-fieldset', {
    class: {
      'has-danger': _vm.$v.event.eventCode.$error
    },
    attrs: {
      "label": "Event code"
    }
  }, [_c('b-form-input', {
    staticClass: "code",
    attrs: {
      "type": "text",
      "disabled": _vm.disabled
    },
    on: {
      "input": function($event) {
        _vm.$v.event.eventCode.$touch()
      }
    },
    model: {
      value: (_vm.value.eventCode),
      callback: function($$v) {
        _vm.value.eventCode = $$v
      },
      expression: "value.eventCode"
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.event.eventCode.hasOwnProperty('required') && !_vm.$v.event.eventCode.required),
      expression: "$v.event.eventCode.hasOwnProperty('required') && !$v.event.eventCode.required"
    }],
    staticClass: "EventFormPartialView__error"
  }, [_vm._v("\n            Event code required\n          ")]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.event.eventCode.hasOwnProperty('unique') && !_vm.$v.event.eventCode.unique),
      expression: "$v.event.eventCode.hasOwnProperty('unique') && !$v.event.eventCode.unique"
    }],
    staticClass: "EventFormPartialView__error"
  }, [_vm._v("\n            Event code is not unique in selected region\n          ")])], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Date"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!(_vm.disableStartAndEndDate || _vm.disabled)),
      expression: "!(disableStartAndEndDate || disabled)"
    }],
    staticClass: "col-6",
    class: {
      'has-danger': _vm.$v.event.startDate.$error
    }
  }, [_c('flatpickr', {
    staticClass: "form-control",
    attrs: {
      "config": Object.assign({}, _vm.fpOptions, {
        altInputClass: 'form-control startDate'
      })
    },
    on: {
      "input": function($event) {
        _vm.$v.event.startDate.$touch()
      }
    },
    model: {
      value: (_vm.value.startDate),
      callback: function($$v) {
        _vm.value.startDate = $$v
      },
      expression: "value.startDate"
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.event.startDate.hasOwnProperty('required') && !_vm.$v.event.startDate.required),
      expression: "$v.event.startDate.hasOwnProperty('required') && !$v.event.startDate.required"
    }],
    staticClass: "EventFormPartialView__error"
  }, [_vm._v("\n                Start date required\n              ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.disableStartAndEndDate || _vm.disabled),
      expression: "disableStartAndEndDate || disabled"
    }],
    staticClass: "col-6"
  }, [_c('b-form-input', {
    attrs: {
      "disabled": "",
      "value": _vm._f("formatDate")(_vm.value.startDate)
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!(_vm.disableStartAndEndDate || _vm.disabled)),
      expression: "!(disableStartAndEndDate || disabled)"
    }],
    staticClass: "col-6",
    class: {
      'has-danger': _vm.$v.event.endDate.$error
    }
  }, [_c('flatpickr', {
    staticClass: "form-control",
    attrs: {
      "config": Object.assign({}, _vm.fpOptions, {
        altInputClass: 'form-control endDate'
      })
    },
    on: {
      "input": function($event) {
        _vm.$v.event.endDate.$touch()
      }
    },
    model: {
      value: (_vm.value.endDate),
      callback: function($$v) {
        _vm.value.endDate = $$v
      },
      expression: "value.endDate"
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.event.endDate.hasOwnProperty('required') && !_vm.$v.event.endDate.required),
      expression: "$v.event.endDate.hasOwnProperty('required') && !$v.event.endDate.required"
    }],
    staticClass: "EventFormPartialView__error"
  }, [_vm._v("\n                End date required\n              ")]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.event.endDate.hasOwnProperty('greater') && !_vm.$v.event.endDate.greater),
      expression: "$v.event.endDate.hasOwnProperty('greater') && !$v.event.endDate.greater"
    }],
    staticClass: "EventFormPartialView__error"
  }, [_vm._v("\n                End is earlier than start\n              ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.disableStartAndEndDate || _vm.disabled),
      expression: "disableStartAndEndDate || disabled"
    }],
    staticClass: "col-6"
  }, [_c('b-form-input', {
    attrs: {
      "disabled": "",
      "value": _vm._f("formatDate")(_vm.value.endDate)
    }
  })], 1)])]), _vm._v(" "), _c('b-form-fieldset', {
    class: {
      'has-danger': _vm.$v.event.regionId.$error
    },
    attrs: {
      "label": "Region"
    }
  }, [_c('b-form-select', {
    staticClass: "col-12 regionId",
    attrs: {
      "options": _vm.regionOptions,
      "disabled": _vm.disableRegion || _vm.disabled
    },
    on: {
      "input": function($event) {
        _vm.$v.event.regionId.$touch()
      }
    },
    model: {
      value: (_vm.value.regionId),
      callback: function($$v) {
        _vm.value.regionId = $$v
      },
      expression: "value.regionId"
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.event.regionId.hasOwnProperty('required') && !_vm.$v.event.regionId.required),
      expression: "$v.event.regionId.hasOwnProperty('required') && !$v.event.regionId.required"
    }],
    staticClass: "EventFormPartialView__error"
  }, [_vm._v("\n            Region required\n          ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    class: {
      'has-danger': _vm.$v.event.type.$error
    },
    attrs: {
      "label": "Type"
    }
  }, [_c('b-form-select', {
    staticClass: "col-12 type",
    attrs: {
      "options": _vm.types,
      "disabled": _vm.disableType || _vm.disabled
    },
    on: {
      "input": function($event) {
        _vm.$v.event.type.$touch()
      }
    },
    model: {
      value: (_vm.value.type),
      callback: function($$v) {
        _vm.value.type = $$v
      },
      expression: "value.type"
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.event.type.hasOwnProperty('required') && !_vm.$v.event.type.required),
      expression: "$v.event.type.hasOwnProperty('required') && !$v.event.type.required"
    }],
    staticClass: "EventFormPartialView__error"
  }, [_vm._v("\n            Type required\n          ")])], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Notes"
    }
  }, [_c('b-form-input', {
    staticStyle: {
      "height": "220px"
    },
    attrs: {
      "type": "text",
      "textarea": "",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.value.notes),
      callback: function($$v) {
        _vm.value.notes = $$v
      },
      expression: "value.notes"
    }
  })], 1)], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 1671:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('h1', [_vm._v("This paged does not exist.")]), _vm._v(" "), _c('p', [_vm._v("Please check the following:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Make sure you opened this page by navigating to ERPLY backoffice.")]), _vm._v(" "), _c('li', [_vm._v("Make sure the user you are logged in with has administrator privileges.")]), _vm._v(" "), _c('li', [_vm._v("If you have kept the browser window opened for long time, then please refresh.")])])])
}]}

/***/ }),

/***/ 1672:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('selectable-grid-row', {
    attrs: {
      "activeRow": _vm.activeRow
    }
  }, [_c('selectable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "active-row": _vm.activeRow
    }
  }, [_vm._v("\n    " + _vm._s(_vm._f("fixedLength")(_vm.discount.plu, 10)) + "\n  ")]), _vm._v(" "), _c('selectable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "active-row": _vm.activeRow
    }
  }, [_vm._v("\n    " + _vm._s(_vm._f("fixedLength")(_vm.discount.name, 15)) + "\n  ")]), _vm._v(" "), _c('selectable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "active-row": _vm.activeRow
    }
  }, [_vm._v("\n    Discount\n  ")]), _vm._v(" "), _c('selectable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "active-row": _vm.activeRow
    }
  }, [_vm._v("\n    " + _vm._s(_vm.customerGroupName) + "\n  ")]), _vm._v(" "), _c('selectable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "active-row": _vm.activeRow
    }
  }, [(_vm.showDates) ? _c('span', [_vm._v("\n      " + _vm._s(_vm._f("formatDate")(_vm.discount.startDate)) + "\n    ")]) : _vm._e()]), _vm._v(" "), _c('selectable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "active-row": _vm.activeRow
    }
  }, [(_vm.showDates) ? _c('span', [_vm._v("\n      " + _vm._s(_vm._f("formatDate")(_vm.discount.endDate)) + "\n    ")]) : _vm._e()]), _vm._v(" "), _c('selectable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "active-row": _vm.activeRow
    }
  }, [_vm._v("\n    " + _vm._s(_vm.discount.page) + "\n  ")]), _vm._v(" "), _c('selectable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "active-row": _vm.activeRow
    }
  }, [_vm._v("\n    " + _vm._s(_vm.discount.positionOnPage) + "\n  ")]), _vm._v(" "), _c('selectable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "active-row": _vm.activeRow
    }
  }, [_vm._v("\n    " + _vm._s(_vm.basePrice) + "\n  ")]), _vm._v(" "), _c('selectable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "active-row": _vm.activeRow
    }
  }, [_vm._v("\n    " + _vm._s(_vm.discount.cost) + "\n  ")]), _vm._v(" "), _c('selectable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "active-row": _vm.activeRow
    }
  }, [_vm._v("\n    " + _vm._s(_vm.discount.salesPrice) + "\n  ")]), _vm._v(" "), _c('selectable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "active-row": _vm.activeRow
    }
  }, [_vm._v("\n    " + _vm._s(_vm._f("rounded")(_vm.margin)) + "%\n  ")]), _vm._v(" "), _c('selectable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "active-row": _vm.activeRow
    }
  }, [_vm._v("\n    " + _vm._s(_vm.discount.targetMargin)), (_vm.discount.targetMargin) ? _c('span', [_vm._v("%")]) : _vm._e()]), _vm._v(" "), _c('selectable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "active-row": _vm.activeRow
    }
  }, [_vm._v("\n    " + _vm._s(_vm.discount.rewardMoneyEarnedPerItem) + "\n  ")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1673:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "EditEventItems"
  }, [_c('div', {
    staticClass: "row text-right",
    staticStyle: {
      "margin-top": "30px",
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showProductSelect(null)
      }
    }
  }, [_vm._v("Add discounted product\n        ")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showPromotion(null)
      }
    }
  }, [_vm._v("Add special promotion\n        ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    ref: "itemsTableWrapper",
    staticClass: "EditEventItems__tableWrapper"
  }, [_c('editable-grid', {
    attrs: {
      "rows": _vm.totalRows,
      "columns": 16,
      "focused": _vm.gridFocused
    },
    scopedSlots: _vm._u([
      ["default", function(grid) {
        return [_vm._l((_vm.discountedProducts), function(discount, index) {
          return _c('discounted-product', {
            key: discount.uuid,
            attrs: {
              "discount": discount,
              "hideStartDate": _vm.eventStartDate,
              "hideEndDate": _vm.eventEndDate,
              "customer-groups": _vm.customerGroups,
              "row": index,
              "active-row": grid.activeRow,
              "active-column": grid.activeColumn,
              "is-being-edited": grid.isBeingEdited,
              "$v": _vm.$v.discountedProducts.$each[index]
            },
            on: {
              "product-select": _vm.showProductSelect,
              "delete-item": _vm.deleteDiscount
            }
          })
        }), _vm._v(" "), _vm._l((_vm.specialPromotions), function(promotion, index) {
          return [(promotion.type == 'BUY_ITEMS_FOR_SPECIAL_UNIT_PRICE' || promotion.type == 'MULTIBUY_GET_PERCENTAGE_OFF' || promotion.type == 'MULTIBUY_GET_SUM_OFF') ? _vm._l((promotion.requirements.purchasedProducts), function(item, itemIndex) {
            return _c('special-promotion', {
              key: promotion.uuid + '_' + item.plu,
              attrs: {
                "promotion": promotion,
                "item": item,
                "itemIndex": itemIndex,
                "hideStartDate": _vm.eventStartDate,
                "hideEndDate": _vm.eventEndDate,
                "disableDelete": _vm.isEventConfirmed,
                "customer-groups": _vm.customerGroups,
                "row": _vm.discountedProducts.length + index,
                "active-row": grid.activeRow,
                "active-column": grid.activeColumn,
                "is-being-edited": grid.isBeingEdited,
                "$v": _vm.$v.specialPromotions.$each[index]
              },
              on: {
                "show-promotion": _vm.showPromotion,
                "delete-item": _vm.showPromotionDelete
              }
            })
          }) : _vm._l((promotion.rewards.awardedProducts), function(item, itemIndex) {
            return _c('special-promotion', {
              key: promotion.uuid + '_' + item.plu,
              attrs: {
                "promotion": promotion,
                "item": item,
                "itemIndex": itemIndex,
                "hideStartDate": _vm.eventStartDate,
                "hideEndDate": _vm.eventEndDate,
                "disableDelete": _vm.isEventConfirmed,
                "customer-groups": _vm.customerGroups,
                "row": _vm.discountedProducts.length + index,
                "active-row": grid.activeRow,
                "active-column": grid.activeColumn,
                "is-being-edited": grid.isBeingEdited,
                "$v": _vm.$v.specialPromotions.$each[index]
              },
              on: {
                "show-promotion": _vm.showPromotion,
                "delete-item": _vm.showPromotionDelete
              }
            })
          })]
        })]
      }]
    ])
  }, [_c('th', {
    slot: "header"
  }, [_vm._v("\n            PLU\n          ")]), _vm._v(" "), _c('th', {
    slot: "header"
  }, [_vm._v("\n            Product\n          ")]), _vm._v(" "), _c('th', {
    slot: "header"
  }, [_vm._v("\n            Type\n          ")]), _vm._v(" "), _c('th', {
    staticClass: "EditEventItems_column--width-4",
    slot: "header"
  }, [_vm._v("\n            Customer Group\n          ")]), _vm._v(" "), _c('th', {
    staticClass: "EditEventItems_column--width-3",
    slot: "header"
  }, [_vm._v("\n            Start date\n          ")]), _vm._v(" "), _c('th', {
    staticClass: "EditEventItems_column--width-3",
    slot: "header"
  }, [_vm._v("\n            End date\n          ")]), _vm._v(" "), _c('th', {
    staticClass: "EditEventItems_column--width-2",
    slot: "header"
  }, [_vm._v("\n            Page\n          ")]), _vm._v(" "), _c('th', {
    staticClass: "EditEventItems_column--width-2",
    slot: "header"
  }, [_vm._v("\n            Position\n          ")]), _vm._v(" "), _c('th', {
    staticClass: "EditEventItems_column--width-3",
    slot: "header"
  }, [_vm._v("\n            Regular price\n          ")]), _vm._v(" "), _c('th', {
    staticClass: "EditEventItems_column--width-2",
    slot: "header"
  }, [_vm._v("\n            Cost\n          ")]), _vm._v(" "), _c('th', {
    staticClass: "EditEventItems_column--width-3",
    slot: "header"
  }, [_vm._v("\n            Sales price\n          ")]), _vm._v(" "), _c('th', {
    staticClass: "EditEventItems_column--width-2",
    slot: "header"
  }, [_vm._v("\n            Margin\n          ")]), _vm._v(" "), _c('th', {
    staticClass: "EditEventItems_column--width-3",
    slot: "header"
  }, [_vm._v("\n            Target margin\n          ")]), _vm._v(" "), _c('th', {
    staticClass: "EditEventItems_column--width-4",
    slot: "header"
  }, [_vm._v("\n            Reward money earned\n          ")]), _vm._v(" "), _c('th', {
    slot: "header"
  })])], 1)]), _vm._v(" "), (_vm.totalRows === 0) ? _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v("\n        No discounts or promotions added yet\n      ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row text-right",
    staticStyle: {
      "margin-top": "30px",
      "margin-bottom": "40px"
    }
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showProductSelect(null)
      }
    }
  }, [_vm._v("Add discounted product\n        ")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showPromotion(null)
      }
    }
  }, [_vm._v("Add special promotion\n        ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "EditEventItems__scroller",
    attrs: {
      "id": "EditEventItems__scroller"
    },
    on: {
      "scroll": _vm.scrollItems
    }
  }, [_c('div', [_vm._v(" ")])]), _vm._v(" "), _c('product-select', {
    attrs: {
      "shown": _vm.productSelectShown,
      "regionId": _vm.regionId,
      "maxCustomerGroupId": _vm.maxCustomerGroupId,
      "startDate": _vm.eventStartDate,
      "endDate": _vm.eventEndDate
    },
    on: {
      "hide": function($event) {
        _vm.productSelectShown = false
      },
      "change": _vm.addOrUpdateProduct,
      "focus-gained": function($event) {
        _vm.gridFocused = false
      },
      "focus-lost": function($event) {
        _vm.gridFocused = true
      }
    }
  }), _vm._v(" "), _c('add-promotion', {
    attrs: {
      "value": _vm.promotionBeingEdited,
      "shown": _vm.addPromotionShown,
      "regionId": _vm.regionId,
      "maxCustomerGroupId": _vm.maxCustomerGroupId
    },
    on: {
      "hide": function($event) {
        _vm.addPromotionShown = false
      },
      "change": _vm.addOrUpdatePromotion,
      "focus-gained": function($event) {
        _vm.gridFocused = false
      },
      "focus-lost": function($event) {
        _vm.gridFocused = true
      }
    }
  }), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "promotion_delete_modal",
      "title": "Are your sure?",
      "ok-title": "Delete"
    },
    on: {
      "ok": _vm.deletePromotion
    },
    model: {
      value: (_vm.deletePromotionShow),
      callback: function($$v) {
        _vm.deletePromotionShow = $$v
      },
      expression: "deletePromotionShow"
    }
  }, [_vm._v("\n      Are you sure you want to delete the whole promotion? Use the promotion edit dialog to remove individual PLUs.\n    ")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1674:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "30px",
      "margin-bottom": "20px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-6 text-right"
  }, [(_vm.step === 0) ? _c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("Next")]) : _vm._e(), _vm._v(" "), (_vm.step === 1) ? _c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('b-button', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")])], 1)]), _vm._v(" "), _c('b-alert', {
    attrs: {
      "variant": "danger",
      "show": _vm.$v.$error
    }
  }, [_vm._v("\n    Please check that all fields are correct. Incorrect values are highlighted.\n  ")]), _vm._v(" "), _c('event-form', {
    attrs: {
      "regions": _vm.regions,
      "types": _vm.types,
      "$v": _vm.$v,
      "disableType": true,
      "disabled": _vm.step !== 0
    },
    model: {
      value: (_vm.event),
      callback: function($$v) {
        _vm.event = $$v
      },
      expression: "event"
    }
  }), _vm._v(" "), (_vm.step === 1) ? [_c('event-items', {
    attrs: {
      "discounted-products": _vm.event.discountedProducts,
      "special-promotions": _vm.event.specialPromotions,
      "event-start-date": _vm.event.startDate,
      "event-end-date": _vm.event.endDate,
      "customer-groups": _vm.customerGroups,
      "$v": _vm.$v.event
    }
  })] : _vm._e(), _vm._v(" "), _c('loading', {
    attrs: {
      "show": _vm.loading
    }
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('h1', [_vm._v("\n        Copy special price event\n      ")])])
}]}

/***/ }),

/***/ 1675:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "EditableGridCell",
    class: {
      'active': _vm.isActive,
      'is-editable': _vm.isEditable,
      'has-danger': _vm.hasDanger,
      'has-padding': _vm.hasPadding
    }
  }, [_c('a', {
    ref: "cell",
    class: {
      'not-being-edited': !_vm.isBeingEdited || !_vm.isActive
    },
    attrs: {
      "href": "#"
    },
    on: {
      "focus": _vm.activate,
      "click": function($event) {
        $event.preventDefault();
      },
      "dblclick": function($event) {
        $event.preventDefault();
        _vm.toggleEdit($event)
      },
      "keydown": function($event) {
        $event.stopPropagation();
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.toggleEdit($event)
      }
    }
  }, [(_vm.isEditable && _vm.isBeingEdited && _vm.isActive) ? _vm._t("edit") : _vm._t("view"), _vm._v(" "), _vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 1676:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "CopyEventItems"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    ref: "itemsTableWrapper",
    staticClass: "CopyEventItems__tableWrapper"
  }, [_c('editable-grid', {
    attrs: {
      "rows": _vm.totalRows,
      "columns": 14,
      "focused": _vm.gridFocused
    },
    scopedSlots: _vm._u([
      ["default", function(grid) {
        return [_vm._l((_vm.discountedProducts), function(discount, index) {
          return _c('discounted-product', {
            key: discount.uuid,
            attrs: {
              "discount": discount,
              "hideStartDate": _vm.eventStartDate,
              "hideEndDate": _vm.eventEndDate,
              "customer-groups": _vm.customerGroups,
              "row": index,
              "active-row": grid.activeRow,
              "active-column": grid.activeColumn,
              "is-being-edited": grid.isBeingEdited,
              "$v": _vm.$v.discountedProducts.$each[index]
            }
          })
        }), _vm._v(" "), _vm._l((_vm.specialPromotions), function(promotion, index) {
          return [(promotion.type == 'BUY_ITEMS_FOR_SPECIAL_UNIT_PRICE' || promotion.type == 'MULTIBUY_GET_PERCENTAGE_OFF' || promotion.type == 'MULTIBUY_GET_SUM_OFF') ? _vm._l((promotion.requirements.purchasedProducts), function(item, itemIndex) {
            return _c('special-promotion', {
              key: promotion.uuid + '_' + item.plu,
              attrs: {
                "promotion": promotion,
                "item": item,
                "itemIndex": itemIndex,
                "hideStartDate": _vm.eventStartDate,
                "hideEndDate": _vm.eventEndDate,
                "customer-groups": _vm.customerGroups,
                "row": _vm.discountedProducts.length + index,
                "active-row": grid.activeRow,
                "active-column": grid.activeColumn,
                "is-being-edited": grid.isBeingEdited,
                "$v": _vm.$v.specialPromotions.$each[index]
              }
            })
          }) : _vm._l((promotion.rewards.awardedProducts), function(item, itemIndex) {
            return _c('special-promotion', {
              key: promotion.uuid + '_' + item.plu,
              attrs: {
                "promotion": promotion,
                "item": item,
                "itemIndex": itemIndex,
                "hideStartDate": _vm.eventStartDate,
                "hideEndDate": _vm.eventEndDate,
                "customer-groups": _vm.customerGroups,
                "row": _vm.discountedProducts.length + index,
                "active-row": grid.activeRow,
                "active-column": grid.activeColumn,
                "is-being-edited": grid.isBeingEdited,
                "$v": _vm.$v.specialPromotions.$each[index]
              }
            })
          })]
        })]
      }]
    ])
  }, [_c('th', {
    slot: "header"
  }, [_vm._v("\n                PLU\n              ")]), _vm._v(" "), _c('th', {
    slot: "header"
  }, [_vm._v("\n                Product\n              ")]), _vm._v(" "), _c('th', {
    slot: "header"
  }, [_vm._v("\n                Type\n              ")]), _vm._v(" "), _c('th', {
    staticClass: "CopyEventItems_column--width-4",
    slot: "header"
  }, [_vm._v("\n                Customer Group\n              ")]), _vm._v(" "), _c('th', {
    staticClass: "CopyEventItems_column--width-3",
    slot: "header"
  }, [_vm._v("\n                Start date\n              ")]), _vm._v(" "), _c('th', {
    staticClass: "CopyEventItems_column--width-3",
    slot: "header"
  }, [_vm._v("\n                End date\n              ")]), _vm._v(" "), _c('th', {
    staticClass: "CopyEventItems_column--width-2",
    slot: "header"
  }, [_vm._v("\n                Page\n              ")]), _vm._v(" "), _c('th', {
    staticClass: "CopyEventItems_column--width-2",
    slot: "header"
  }, [_vm._v("\n                Position\n              ")]), _vm._v(" "), _c('th', {
    staticClass: "CopyEventItems_column--width-3",
    slot: "header"
  }, [_vm._v("\n                Regular price\n              ")]), _vm._v(" "), _c('th', {
    staticClass: "CopyEventItems_column--width-2",
    slot: "header"
  }, [_vm._v("\n                Cost\n              ")]), _vm._v(" "), _c('th', {
    staticClass: "CopyEventItems_column--width-3",
    slot: "header"
  }, [_vm._v("\n                Sales price\n              ")]), _vm._v(" "), _c('th', {
    staticClass: "CopyEventItems_column--width-2",
    slot: "header"
  }, [_vm._v("\n                Margin\n              ")]), _vm._v(" "), _c('th', {
    staticClass: "CopyEventItems_column--width-3",
    slot: "header"
  }, [_vm._v("\n                Target margin\n              ")]), _vm._v(" "), _c('th', {
    staticClass: "CopyEventItems_column--width-4",
    slot: "header"
  }, [_vm._v("\n                Reward money earned\n              ")])])], 1)]), _vm._v(" "), (_vm.totalRows === 0) ? _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v("\n        No discounts or promotions added yet\n      ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "CopyEventItems__scroller",
    attrs: {
      "id": "CopyEventItems__scroller"
    },
    on: {
      "scroll": _vm.scrollItems
    }
  }, [_c('div', [_vm._v(" ")])])])
},staticRenderFns: []}

/***/ }),

/***/ 1677:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('editable-grid-row', {
    class: {
      error: _vm.$v.$error
    },
    attrs: {
      "activeRow": _vm.activeRow
    }
  }, [_c('editable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "column": 0,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "is-editable": false,
      "has-danger": !_vm.$v.unique && _vm.$v.$error
    }
  }, [_c('span', {
    attrs: {
      "id": 'uuid' + _vm.discount.uuid
    },
    slot: "view"
  }, [_vm._v("\n      " + _vm._s(_vm._f("fixedLength")(_vm.discount.plu, 10)) + "\n    ")]), _vm._v(" "), (!_vm.$v.unique && _vm.$v.$error) ? _c('b-tooltip', {
    attrs: {
      "target": 'uuid' + _vm.discount.uuid,
      "placement": "right"
    }
  }, [_vm._v("\n      Product already has an overlapping discount or promotion set in following events:\n      "), _c('strong', [_vm._v(_vm._s(_vm.$v.$params.unique.matches(_vm.discount)))]), _vm._v("."), _c('br'), _c('br'), _vm._v("\n      Try selecting another product, changing customer group or picking different date range.\n    ")]) : _vm._e()], 1), _vm._v(" "), _c('editable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "column": 1,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "is-editable": false
    }
  }, [_c('span', {
    slot: "view"
  }, [_vm._v("\n      " + _vm._s(_vm._f("fixedLength")(_vm.discount.name, 15)) + "\n    ")])]), _vm._v(" "), _c('editable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "column": 2,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "is-editable": false
    }
  }, [_c('span', {
    slot: "view"
  }, [_vm._v("\n      Discount\n    ")])]), _vm._v(" "), _c('editable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "column": 3,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "is-editable": false
    }
  }, [_c('span', {
    slot: "view"
  }, [_vm._v("\n      " + _vm._s(_vm.customerGroupName) + "\n    ")])]), _vm._v(" "), _c('editable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "column": 4,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "is-editable": _vm.discount.isCustomDate,
      "has-danger": _vm.$v.startDate.$error
    }
  }, [_c('span', {
    slot: "edit"
  }, [_c('flatpickr', {
    attrs: {
      "config": Object.assign({}, _vm.fpOptions, {
        altInputClass: 'form-control startDate'
      })
    },
    on: {
      "input": function($event) {
        _vm.$v.startDate.$touch()
      }
    },
    model: {
      value: (_vm.discount.startDate),
      callback: function($$v) {
        _vm.discount.startDate = $$v
      },
      expression: "discount.startDate"
    }
  })], 1), _vm._v(" "), (_vm.showDates) ? _c('span', {
    slot: "view"
  }, [_vm._v("\n      " + _vm._s(_vm._f("formatDate")(_vm.discount.startDate)) + "\n    ")]) : _vm._e()]), _vm._v(" "), _c('editable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "column": 5,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "is-editable": _vm.discount.isCustomDate,
      "has-danger": _vm.$v.endDate.$error
    }
  }, [_c('span', {
    slot: "edit"
  }, [_c('flatpickr', {
    attrs: {
      "config": Object.assign({}, _vm.fpOptions, {
        altInputClass: 'form-control endDate'
      })
    },
    on: {
      "input": function($event) {
        _vm.$v.endDate.$touch()
      }
    },
    model: {
      value: (_vm.discount.endDate),
      callback: function($$v) {
        _vm.discount.endDate = $$v
      },
      expression: "discount.endDate"
    }
  })], 1), _vm._v(" "), (_vm.showDates) ? _c('span', {
    slot: "view"
  }, [_vm._v("\n      " + _vm._s(_vm._f("formatDate")(_vm.discount.endDate)) + "\n    ")]) : _vm._e()]), _vm._v(" "), _c('editable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "column": 6,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "is-editable": false
    }
  }, [_c('span', {
    slot: "view"
  }, [_vm._v("\n      " + _vm._s(_vm.discount.page) + "\n    ")])]), _vm._v(" "), _c('editable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "column": 7,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "is-editable": false
    }
  }, [_c('span', {
    slot: "view"
  }, [_vm._v("\n      " + _vm._s(_vm.discount.positionOnPage) + "\n    ")])]), _vm._v(" "), _c('editable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "column": 9,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "is-editable": false
    }
  }, [_c('span', {
    slot: "view"
  }, [_vm._v("\n      " + _vm._s(_vm.basePrice) + "\n    ")])]), _vm._v(" "), _c('editable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "column": 9,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "is-editable": false
    }
  }, [_c('span', {
    slot: "view"
  }, [_vm._v("\n      " + _vm._s(_vm.discount.cost) + "\n    ")])]), _vm._v(" "), _c('editable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "column": 10,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "is-editable": false
    }
  }, [_c('span', {
    slot: "view"
  }, [_vm._v("\n      " + _vm._s(_vm.discount.salesPrice) + "\n    ")])]), _vm._v(" "), _c('editable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "column": 11,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "is-editable": false
    }
  }, [_c('span', {
    slot: "view"
  }, [_vm._v("\n      " + _vm._s(_vm._f("rounded")(_vm.margin)) + "%\n    ")])]), _vm._v(" "), _c('editable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "column": 12,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "is-editable": false
    }
  }, [_c('span', {
    slot: "view"
  }, [_vm._v("\n      " + _vm._s(_vm.discount.targetMargin)), (_vm.discount.targetMargin) ? _c('span', [_vm._v("%")]) : _vm._e()])]), _vm._v(" "), _c('editable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "column": 13,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "is-editable": false
    }
  }, [_c('span', {
    slot: "view"
  }, [_vm._v("\n      " + _vm._s(_vm.discount.rewardMoneyEarnedPerItem) + "\n    ")])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1678:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "MultiBuy"
  }, [_c('b-modal', {
    attrs: {
      "hide-footer": "",
      "size": "lg",
      "visible": _vm.shown
    },
    on: {
      "hide": function($event) {
        _vm.$emit('hide')
      },
      "shown": _vm.reset
    }
  }, [_c('div', {
    staticClass: "w-100",
    slot: "modal-title"
  }, [_c('strong', [_vm._v(_vm._s(_vm.name))])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('ul', {
    staticClass: "nav nav-tabs card-header-tabs"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    class: {
      active: _vm.tab == 0
    },
    on: {
      "click": function($event) {
        _vm.tab = 0
      }
    }
  }, [_vm._v("Customer must buy")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    class: {
      active: _vm.tab == 1
    },
    on: {
      "click": function($event) {
        _vm.tab = 1
      }
    }
  }, [_vm._v("Customer will get")])])])]), _vm._v(" "), (_vm.tab === 0) ? _c('div', {
    staticClass: "card-body"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "at least"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": "items"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "step": "1",
      "rows": 1,
      "disabled": ""
    },
    model: {
      value: (_vm.promotion.requirements.purchasedAmount),
      callback: function($$v) {
        _vm.promotion.requirements.purchasedAmount = $$v
      },
      expression: "promotion.requirements.purchasedAmount"
    }
  })], 1)], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": ""
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-5"
  }, [_vm._v("\n              once per day:\n              "), _c('b-form-checkbox', {
    staticClass: "oncePerDay",
    attrs: {
      "size": "lg",
      "value": "1",
      "unchecked-value": "0",
      "switch": ""
    },
    model: {
      value: (_vm.promotion.oncePerDay),
      callback: function($$v) {
        _vm.promotion.oncePerDay = $$v
      },
      expression: "promotion.oncePerDay"
    }
  })], 1)])]), _vm._v(" "), _c('product-list', {
    attrs: {
      "value": _vm.promotion.requirements.purchasedProducts,
      "customerGroupId": _vm.promotion.customerGroupId,
      "discountedPriceFormula": _vm.discountedPriceFormula
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.tab === 1) ? _c('div', {
    staticClass: "card-body"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "with price"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": "CAD"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "step": "any",
      "rows": 1,
      "disabled": ""
    },
    model: {
      value: (_vm.promotion.rewards.specialUnitPrice),
      callback: function($$v) {
        _vm.promotion.rewards.specialUnitPrice = _vm._n($$v)
      },
      expression: "promotion.rewards.specialUnitPrice"
    }
  })], 1)], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "and target margin"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": "%"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "step": "any",
      "rows": 1,
      "disabled": ""
    },
    model: {
      value: (_vm.promotion.targetMargin),
      callback: function($$v) {
        _vm.promotion.targetMargin = _vm._n($$v)
      },
      expression: "promotion.targetMargin"
    }
  })], 1)], 1)], 1) : _vm._e()])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1679:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ViewEventItems"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    ref: "itemsTableWrapper",
    staticClass: "ViewEventItems__tableWrapper"
  }, [_c('selectable-grid', {
    attrs: {
      "rows": _vm.totalRows,
      "columns": 14
    },
    scopedSlots: _vm._u([
      ["default", function(grid) {
        return [_vm._l((_vm.discountedProducts), function(discount, index) {
          return _c('discounted-product', {
            key: discount.uuid,
            attrs: {
              "discount": discount,
              "hideStartDate": _vm.eventStartDate,
              "hideEndDate": _vm.eventEndDate,
              "customer-groups": _vm.customerGroups,
              "row": index,
              "active-row": grid.activeRow
            }
          })
        }), _vm._v(" "), _vm._l((_vm.specialPromotions), function(promotion, index) {
          return [(promotion.type == 'BUY_ITEMS_FOR_SPECIAL_UNIT_PRICE' || promotion.type == 'MULTIBUY_GET_PERCENTAGE_OFF' || promotion.type == 'MULTIBUY_GET_SUM_OFF') ? _vm._l((promotion.requirements.purchasedProducts), function(item, itemIndex) {
            return _c('special-promotion', {
              key: promotion.uuid + '_' + item.plu,
              attrs: {
                "promotion": promotion,
                "item": item,
                "itemIndex": itemIndex,
                "hideStartDate": _vm.eventStartDate,
                "hideEndDate": _vm.eventEndDate,
                "customer-groups": _vm.customerGroups,
                "row": _vm.discountedProducts.length + index,
                "active-row": grid.activeRow
              },
              on: {
                "show-promotion": _vm.showPromotion
              }
            })
          }) : _vm._l((promotion.rewards.awardedProducts), function(item, itemIndex) {
            return _c('special-promotion', {
              key: promotion.uuid + '_' + item.plu,
              attrs: {
                "promotion": promotion,
                "item": item,
                "itemIndex": itemIndex,
                "hideStartDate": _vm.eventStartDate,
                "hideEndDate": _vm.eventEndDate,
                "customer-groups": _vm.customerGroups,
                "row": _vm.discountedProducts.length + index,
                "active-row": grid.activeRow
              },
              on: {
                "show-promotion": _vm.showPromotion
              }
            })
          })]
        })]
      }]
    ])
  }, [_c('th', {
    slot: "header"
  }, [_vm._v("\n              PLU\n            ")]), _vm._v(" "), _c('th', {
    slot: "header"
  }, [_vm._v("\n              Product\n            ")]), _vm._v(" "), _c('th', {
    slot: "header"
  }, [_vm._v("\n              Type\n            ")]), _vm._v(" "), _c('th', {
    staticClass: "ViewEventItems_column--width-4",
    slot: "header"
  }, [_vm._v("\n              Customer Group\n            ")]), _vm._v(" "), _c('th', {
    staticClass: "ViewEventItems_column--width-3",
    slot: "header"
  }, [_vm._v("\n              Start date\n            ")]), _vm._v(" "), _c('th', {
    staticClass: "ViewEventItems_column--width-3",
    slot: "header"
  }, [_vm._v("\n              End date\n            ")]), _vm._v(" "), _c('th', {
    staticClass: "ViewEventItems_column--width-2",
    slot: "header"
  }, [_vm._v("\n              Page\n            ")]), _vm._v(" "), _c('th', {
    staticClass: "ViewEventItems_column--width-2",
    slot: "header"
  }, [_vm._v("\n              Position\n            ")]), _vm._v(" "), _c('th', {
    staticClass: "ViewEventItems_column--width-3",
    slot: "header"
  }, [_vm._v("\n              Regular price\n            ")]), _vm._v(" "), _c('th', {
    staticClass: "ViewEventItems_column--width-2",
    slot: "header"
  }, [_vm._v("\n              Cost\n            ")]), _vm._v(" "), _c('th', {
    staticClass: "ViewEventItems_column--width-3",
    slot: "header"
  }, [_vm._v("\n              Sales price\n            ")]), _vm._v(" "), _c('th', {
    staticClass: "ViewEventItems_column--width-2",
    slot: "header"
  }, [_vm._v("\n              Margin\n            ")]), _vm._v(" "), _c('th', {
    staticClass: "ViewEventItems_column--width-3",
    slot: "header"
  }, [_vm._v("\n              Target margin\n            ")]), _vm._v(" "), _c('th', {
    staticClass: "ViewEventItems_column--width-4",
    slot: "header"
  }, [_vm._v("\n              Reward money earned\n            ")])])], 1)]), _vm._v(" "), (_vm.totalRows === 0) ? _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v("\n        No discounts or promotions added yet\n      ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ViewEventItems__scroller",
    attrs: {
      "id": "ViewEventItems__scroller"
    },
    on: {
      "scroll": _vm.scrollItems
    }
  }, [_c('div', [_vm._v(" ")])]), _vm._v(" "), _c('view-promotion', {
    attrs: {
      "value": _vm.promotionBeingViewed,
      "shown": _vm.viewPromotionShown
    },
    on: {
      "hide": function($event) {
        _vm.viewPromotionShown = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1680:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "SpendXForDiscount"
  }, [_c('b-modal', {
    attrs: {
      "hide-footer": "",
      "size": "lg",
      "visible": _vm.shown
    },
    on: {
      "hide": function($event) {
        _vm.$emit('hide')
      },
      "shown": _vm.reset
    }
  }, [_c('div', {
    staticClass: "w-100",
    slot: "modal-title"
  }, [_c('strong', [_vm._v(_vm._s(_vm.name))])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('ul', {
    staticClass: "nav nav-tabs card-header-tabs"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    class: {
      active: _vm.tab == 0
    },
    on: {
      "click": function($event) {
        _vm.tab = 0
      }
    }
  }, [_vm._v("\n                The customer must make a purchase\n              ")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    class: {
      active: _vm.tab == 1
    },
    on: {
      "click": function($event) {
        _vm.tab = 1
      }
    }
  }, [_vm._v("\n                Customer will get\n              ")])])])]), _vm._v(" "), (_vm.tab === 0) ? _c('div', {
    staticClass: "card-body"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "with a total value of"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": " CAD"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "step": "any",
      "rows": 1,
      "disabled": ""
    },
    model: {
      value: (_vm.promotion.requirements.purchaseTotalValue),
      callback: function($$v) {
        _vm.promotion.requirements.purchaseTotalValue = $$v
      },
      expression: "promotion.requirements.purchaseTotalValue"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.tab === 1) ? _c('div', {
    staticClass: "card-body"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "reward money"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": "CAD"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "step": "any",
      "rows": 1,
      "disabled": ""
    },
    model: {
      value: (_vm.promotion.rewards.rewardMoneyEarnedPerItem),
      callback: function($$v) {
        _vm.promotion.rewards.rewardMoneyEarnedPerItem = $$v
      },
      expression: "promotion.rewards.rewardMoneyEarnedPerItem"
    }
  })], 1)], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "margin % target"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": "%"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "step": "any",
      "rows": 1,
      "disabled": ""
    },
    model: {
      value: (_vm.promotion.targetMargin),
      callback: function($$v) {
        _vm.promotion.targetMargin = $$v
      },
      expression: "promotion.targetMargin"
    }
  })], 1)], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "for"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-5"
  }, [_c('b-input-group', {
    attrs: {
      "right": "CAD"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "step": "any",
      "rows": 1,
      "disabled": ""
    },
    model: {
      value: (_vm.promotion.rewards.sumOff),
      callback: function($$v) {
        _vm.promotion.rewards.sumOff = $$v
      },
      expression: "promotion.rewards.sumOff"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-2 text-center"
  }, [_vm._v("or")]), _vm._v(" "), _c('div', {
    staticClass: "col-5"
  }, [_c('b-input-group', {
    attrs: {
      "right": "%"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "step": "any",
      "rows": 1,
      "disabled": ""
    },
    model: {
      value: (_vm.promotion.rewards.percentageOff),
      callback: function($$v) {
        _vm.promotion.rewards.percentageOff = $$v
      },
      expression: "promotion.rewards.percentageOff"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "off of"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": "items"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "step": "any",
      "rows": 1,
      "disabled": ""
    },
    model: {
      value: (_vm.promotion.rewards.awardedAmount),
      callback: function($$v) {
        _vm.promotion.rewards.awardedAmount = $$v
      },
      expression: "promotion.rewards.awardedAmount"
    }
  })], 1)], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": ""
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-5"
  }, [_vm._v("\n                once per day:\n                "), _c('b-form-checkbox', {
    staticClass: "oncePerDay",
    attrs: {
      "size": "lg",
      "value": "1",
      "unchecked-value": "0",
      "switch": ""
    },
    model: {
      value: (_vm.promotion.oncePerDay),
      callback: function($$v) {
        _vm.promotion.oncePerDay = $$v
      },
      expression: "promotion.oncePerDay"
    }
  })], 1)])]), _vm._v(" "), _c('product-list', {
    attrs: {
      "value": _vm.promotion.rewards.awardedProducts,
      "customerGroupId": _vm.promotion.customerGroupId,
      "discountedPriceFormula": _vm.discountedPriceFormula
    }
  })], 1) : _vm._e()])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1681:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-modal', {
    attrs: {
      "hide-footer": "",
      "size": "lg",
      "visible": _vm.shown
    },
    on: {
      "hide": _vm.hide,
      "shown": _vm.reset
    }
  }), _vm._v(" "), _c('spend-x-for-discount', {
    attrs: {
      "shown": _vm.type === 'SPEND_X_FOR_DISCOUNT' || _vm.type === 'SPEND_GET_PERCENTAGE_OFF_ITEMS' || _vm.type === 'SPEND_GET_SUM_OFF_ITEMS',
      "value": _vm.promotion
    },
    on: {
      "hide": function($event) {
        _vm.type = null
      }
    }
  }), _vm._v(" "), _c('multi-buy', {
    attrs: {
      "shown": _vm.type === 'MULTI_BUY' || _vm.type === 'BUY_ITEMS_FOR_SPECIAL_UNIT_PRICE',
      "value": _vm.promotion
    },
    on: {
      "hide": function($event) {
        _vm.type = null
      }
    }
  }), _vm._v(" "), _c('buy-x-for-discount', {
    attrs: {
      "shown": _vm.type === 'BUY_X_FOR_DISCOUNT' || _vm.type === 'BUY_ITEMS_GET_SUM_OFF_ITEMS' || _vm.type === 'BUY_ITEMS_GET_PERCENTAGE_OFF_ITEMS',
      "value": _vm.promotion
    },
    on: {
      "hide": function($event) {
        _vm.type = null
      }
    }
  }), _vm._v(" "), _c('buy-x-for-y-off', {
    attrs: {
      "shown": _vm.type === 'MULTIBUY_X_FOR_DISCOUNT' || _vm.type === 'MULTIBUY_GET_SUM_OFF' || _vm.type === 'MULTIBUY_GET_PERCENTAGE_OFF',
      "value": _vm.promotion
    },
    on: {
      "hide": function($event) {
        _vm.type = null
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1682:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "LoadingIndicator"
  }, [_vm._v("Loading…")]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 1683:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "BuyXForDiscount"
  }, [_c('b-modal', {
    attrs: {
      "size": "lg",
      "visible": _vm.shown,
      "no-enforce-focus": ""
    },
    on: {
      "hide": _vm.hide,
      "shown": _vm.reset
    }
  }, [_c('div', {
    staticClass: "w-100",
    slot: "modal-title"
  }, [_c('strong', [_vm._v(_vm._s(_vm.name))])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('ul', {
    staticClass: "nav nav-tabs card-header-tabs"
  }, [_c('li', {
    staticClass: "nav-item",
    class: {
      'has-danger': _vm.customerMustBuyError
    }
  }, [_c('a', {
    staticClass: "nav-link tab-0",
    class: {
      active: _vm.tab == 0
    },
    on: {
      "click": function($event) {
        _vm.tab = 0
      }
    }
  }, [_vm._v("Customer must buy")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    class: {
      'has-danger': _vm.customerWillGetError
    }
  }, [_c('a', {
    staticClass: "nav-link tab-1",
    class: {
      active: _vm.tab == 1
    },
    on: {
      "click": function($event) {
        _vm.tab = 1
      }
    }
  }, [_vm._v("Customer will get")])])])]), _vm._v(" "), (_vm.tab === 0) ? _c('div', {
    staticClass: "card-body"
  }, [_c('b-form-fieldset', {
    class: {
      'has-danger': _vm.$v.promotion.requirements.purchasedAmount.$error
    },
    attrs: {
      "label": "at least"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": "items"
    }
  }, [_c('b-form-input', {
    staticClass: "purchasedAmount",
    attrs: {
      "type": "number",
      "min": "0",
      "step": "1",
      "rows": 1
    },
    on: {
      "input": function($event) {
        _vm.$v.promotion.requirements.purchasedAmount.$touch()
      }
    },
    model: {
      value: (_vm.promotion.requirements.purchasedAmount),
      callback: function($$v) {
        _vm.promotion.requirements.purchasedAmount = _vm._n($$v)
      },
      expression: "promotion.requirements.purchasedAmount"
    }
  })], 1), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.promotion.requirements.purchasedAmount.required),
      expression: "!$v.promotion.requirements.purchasedAmount.required"
    }],
    staticClass: "BuyXFroDiscountPartialView__error"
  }, [_vm._v("\n            Required\n          ")])], 1), _vm._v(" "), _c('b-form-fieldset', {
    class: {
      'has-danger': _vm.$v.promotion.rewards.redemptionLimit.$error
    },
    attrs: {
      "label": "up to "
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": "items"
    }
  }, [_c('b-form-input', {
    staticClass: "redemptionLimit",
    attrs: {
      "type": "number",
      "min": "0",
      "step": "any",
      "rows": 1
    },
    on: {
      "input": function($event) {
        _vm.$v.promotion.rewards.redemptionLimit.$touch()
      }
    },
    model: {
      value: (_vm.promotion.rewards.redemptionLimit),
      callback: function($$v) {
        _vm.promotion.rewards.redemptionLimit = _vm._n($$v)
      },
      expression: "promotion.rewards.redemptionLimit"
    }
  })], 1), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.promotion.rewards.redemptionLimit.greater),
      expression: "!$v.promotion.rewards.redemptionLimit.greater"
    }],
    staticClass: "BuyXFroDiscountPartialView__error"
  }, [_vm._v("\n            Redemption limit has to be at least equal to the amount of awarded products\n          ")])], 1), _vm._v(" "), _c('product-list', {
    attrs: {
      "enableSubsidy": false,
      "class-name": "BuyXForDiscount_purchasedProducts",
      "validator": _vm.$v.promotion.requirements.purchasedProducts
    },
    on: {
      "add": function($event) {
        _vm.purchasedProductSelectShown = true
      },
      "remove": _vm.removePurchasedProduct
    },
    model: {
      value: (_vm.promotion.requirements.purchasedProducts),
      callback: function($$v) {
        _vm.promotion.requirements.purchasedProducts = $$v
      },
      expression: "promotion.requirements.purchasedProducts"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.tab === 1) ? _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-5"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "reward money"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": "CAD"
    }
  }, [_c('b-form-input', {
    staticClass: "rewardMoneyEarned",
    attrs: {
      "type": "number",
      "min": "0",
      "step": "any",
      "rows": 1
    },
    model: {
      value: (_vm.promotion.rewards.rewardMoneyEarnedPerRedemption),
      callback: function($$v) {
        _vm.promotion.rewards.rewardMoneyEarnedPerRedemption = _vm._n($$v)
      },
      expression: "promotion.rewards.rewardMoneyEarnedPerRedemption"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-2 text-center my-4 pt-3"
  }, [_vm._v("\n            and\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "col-5"
  }, [_c('b-form-fieldset', {
    class: {
      'has-danger': _vm.$v.promotion.rewardsSubsidy.$error
    },
    attrs: {
      "label": "rewards subsidy"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": "CAD"
    }
  }, [_c('b-form-input', {
    staticClass: "rewardsSubsidy",
    attrs: {
      "type": "number",
      "min": "0",
      "step": "any",
      "rows": 1
    },
    on: {
      "input": function($event) {
        _vm.$v.promotion.rewardsSubsidy.$touch()
      }
    },
    model: {
      value: (_vm.promotion.rewardsSubsidy),
      callback: function($$v) {
        _vm.promotion.rewardsSubsidy = _vm._n($$v)
      },
      expression: "promotion.rewardsSubsidy"
    }
  })], 1), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.promotion.rewardsSubsidy.required),
      expression: "!$v.promotion.rewardsSubsidy.required"
    }],
    staticClass: "BuyXFroDiscountPartialView__error"
  }, [_vm._v("\n                Required\n              ")])], 1)], 1)]), _vm._v(" "), _c('b-form-fieldset', {
    class: {
      'has-danger': _vm.$v.promotion.targetMargin.$error
    },
    attrs: {
      "label": "target margin"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": "%"
    }
  }, [_c('b-form-input', {
    staticClass: "targetMargin",
    attrs: {
      "type": "number",
      "min": "0",
      "step": "any",
      "rows": 1
    },
    on: {
      "input": function($event) {
        _vm.$v.promotion.targetMargin.$touch()
      }
    },
    model: {
      value: (_vm.promotion.targetMargin),
      callback: function($$v) {
        _vm.promotion.targetMargin = _vm._n($$v)
      },
      expression: "promotion.targetMargin"
    }
  })], 1), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.promotion.targetMargin.required),
      expression: "!$v.promotion.targetMargin.required"
    }],
    staticClass: "SpendXForDiscountPartialView__error"
  }, [_vm._v("\n            Required\n          ")])], 1), _vm._v(" "), _c('b-form-fieldset', {
    class: {
      'has-danger': _vm.$v.promotion.rewards.sumOff.$error || _vm.$v.promotion.rewards.percentageOff.$error
    },
    attrs: {
      "label": "for"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-5"
  }, [_c('b-input-group', {
    attrs: {
      "right": "CAD"
    }
  }, [_c('b-form-input', {
    staticClass: "sumOff",
    attrs: {
      "type": "number",
      "min": "0",
      "step": "any",
      "rows": 1,
      "disabled": _vm.disableSumOff
    },
    on: {
      "input": function($event) {
        _vm.$v.promotion.rewards.sumOff.$touch()
      }
    },
    model: {
      value: (_vm.promotion.rewards.sumOff),
      callback: function($$v) {
        _vm.promotion.rewards.sumOff = _vm._n($$v)
      },
      expression: "promotion.rewards.sumOff"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-2 text-center"
  }, [_vm._v("or")]), _vm._v(" "), _c('div', {
    staticClass: "col-5"
  }, [_c('b-input-group', {
    attrs: {
      "right": "%"
    }
  }, [_c('b-form-input', {
    staticClass: "percentageOff",
    attrs: {
      "type": "number",
      "min": "0",
      "step": "any",
      "rows": 1,
      "disabled": _vm.disablePercentageOff
    },
    on: {
      "input": function($event) {
        _vm.$v.promotion.rewards.percentageOff.$touch()
      }
    },
    model: {
      value: (_vm.promotion.rewards.percentageOff),
      callback: function($$v) {
        _vm.promotion.rewards.percentageOff = _vm._n($$v)
      },
      expression: "promotion.rewards.percentageOff"
    }
  })], 1)], 1)]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.promotion.rewards.sumOff.required || !_vm.$v.promotion.rewards.percentageOff.required),
      expression: "!$v.promotion.rewards.sumOff.required || !$v.promotion.rewards.percentageOff.required"
    }],
    staticClass: "BuyXFroDiscountPartialView__error"
  }, [_vm._v("\n            Fill one or the other\n          ")])]), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "from"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-5"
  }, [_c('b-input-group', {
    attrs: {
      "right": "times"
    }
  }, [_c('b-form-input', {
    staticClass: "salesRedemptionLimit",
    attrs: {
      "type": "number",
      "min": "0",
      "step": "any",
      "rows": 1
    },
    model: {
      value: (_vm.promotion.rewards.salesRedemptionLimit),
      callback: function($$v) {
        _vm.promotion.rewards.salesRedemptionLimit = _vm._n($$v)
      },
      expression: "promotion.rewards.salesRedemptionLimit"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-2 text-center"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-5"
  }, [_vm._v("\n              once per day:\n              "), _c('b-form-checkbox', {
    staticClass: "oncePerDay",
    attrs: {
      "size": "lg",
      "value": "1",
      "unchecked-value": "0",
      "switch": ""
    },
    model: {
      value: (_vm.promotion.oncePerDay),
      callback: function($$v) {
        _vm.promotion.oncePerDay = $$v
      },
      expression: "promotion.oncePerDay"
    }
  })], 1)]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.promotion.rewards.redemptionLimit == ''),
      expression: "promotion.rewards.redemptionLimit == ''"
    }],
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n            Fill redemption limit limit first\n          ")])])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "w-100",
    slot: "modal-footer"
  }, [_c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.savePromotion()
      }
    }
  }, [_vm._v("Done")])], 1)]), _vm._v(" "), _c('product-select', {
    attrs: {
      "shown": _vm.purchasedProductSelectShown,
      "regionId": _vm.regionId,
      "maxCustomerGroupId": _vm.maxCustomerGroupId
    },
    on: {
      "hide": function($event) {
        _vm.purchasedProductSelectShown = false
      },
      "change": _vm.addPurchasedProduct
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1684:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "SpendXForDiscount"
  }, [_c('b-modal', {
    attrs: {
      "size": "lg",
      "visible": _vm.shown,
      "no-enforce-focus": ""
    },
    on: {
      "hide": _vm.hide,
      "shown": _vm.reset
    }
  }, [_c('div', {
    staticClass: "w-100",
    slot: "modal-title"
  }, [_c('strong', [_vm._v(_vm._s(_vm.name))])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('ul', {
    staticClass: "nav nav-tabs card-header-tabs"
  }, [_c('li', {
    staticClass: "nav-item",
    class: {
      'has-danger': _vm.customerMustBuyError
    }
  }, [_c('a', {
    staticClass: "nav-link tab-0",
    class: {
      active: _vm.tab == 0
    },
    on: {
      "click": function($event) {
        _vm.tab = 0
      }
    }
  }, [_vm._v("\n                The customer must make a purchase\n              ")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    class: {
      'has-danger': _vm.customerWillGetError
    }
  }, [_c('a', {
    staticClass: "nav-link tab-1",
    class: {
      active: _vm.tab == 1
    },
    on: {
      "click": function($event) {
        _vm.tab = 1
      }
    }
  }, [_vm._v("\n                Customer will get\n              ")])])])]), _vm._v(" "), (_vm.tab === 0) ? _c('div', {
    staticClass: "card-body"
  }, [_c('b-form-fieldset', {
    class: {
      'has-danger': _vm.$v.promotion.requirements.purchaseTotalValue.$error
    },
    attrs: {
      "label": "with a total value of"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": " CAD"
    }
  }, [_c('b-form-input', {
    staticClass: "purchaseTotalValue",
    attrs: {
      "type": "number",
      "min": "0",
      "step": "any",
      "rows": 1
    },
    on: {
      "input": function($event) {
        _vm.$v.promotion.requirements.purchaseTotalValue.$touch()
      }
    },
    model: {
      value: (_vm.promotion.requirements.purchaseTotalValue),
      callback: function($$v) {
        _vm.promotion.requirements.purchaseTotalValue = _vm._n($$v)
      },
      expression: "promotion.requirements.purchaseTotalValue"
    }
  })], 1), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.promotion.requirements.purchaseTotalValue.required),
      expression: "!$v.promotion.requirements.purchaseTotalValue.required"
    }],
    staticClass: "SpendXForDiscountPartialView__error"
  }, [_vm._v("\n              Required\n            ")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.tab === 1) ? _c('div', {
    staticClass: "card-body"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "reward money"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": "CAD"
    }
  }, [_c('b-form-input', {
    staticClass: "rewardMoneyEarned",
    attrs: {
      "type": "number",
      "min": "0",
      "step": "any",
      "rows": 1
    },
    model: {
      value: (_vm.promotion.rewards.rewardMoneyEarnedPerItem),
      callback: function($$v) {
        _vm.promotion.rewards.rewardMoneyEarnedPerItem = _vm._n($$v)
      },
      expression: "promotion.rewards.rewardMoneyEarnedPerItem"
    }
  })], 1)], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "margin % target"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": "%"
    }
  }, [_c('b-form-input', {
    staticClass: "targetMargin",
    attrs: {
      "type": "number",
      "min": "0",
      "step": "any",
      "rows": 1
    },
    model: {
      value: (_vm.promotion.targetMargin),
      callback: function($$v) {
        _vm.promotion.targetMargin = _vm._n($$v)
      },
      expression: "promotion.targetMargin"
    }
  })], 1)], 1), _vm._v(" "), _c('b-form-fieldset', {
    class: {
      'has-danger': _vm.$v.promotion.rewards.sumOff.$error || _vm.$v.promotion.rewards.percentageOff.$error
    },
    attrs: {
      "label": "for"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-5"
  }, [_c('b-input-group', {
    attrs: {
      "right": "CAD"
    }
  }, [_c('b-form-input', {
    staticClass: "sumOff",
    attrs: {
      "type": "number",
      "min": "0",
      "step": "any",
      "rows": 1,
      "disabled": _vm.disableSumOff
    },
    on: {
      "input": function($event) {
        _vm.$v.promotion.rewards.sumOff.$touch()
      }
    },
    model: {
      value: (_vm.promotion.rewards.sumOff),
      callback: function($$v) {
        _vm.promotion.rewards.sumOff = _vm._n($$v)
      },
      expression: "promotion.rewards.sumOff"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-2 text-center"
  }, [_vm._v("or")]), _vm._v(" "), _c('div', {
    staticClass: "col-5"
  }, [_c('b-input-group', {
    attrs: {
      "right": "%"
    }
  }, [_c('b-form-input', {
    staticClass: "percentageOff",
    attrs: {
      "type": "number",
      "min": "0",
      "step": "any",
      "rows": 1,
      "disabled": _vm.disablePercentageOff
    },
    on: {
      "input": function($event) {
        _vm.$v.promotion.rewards.percentageOff.$touch()
      }
    },
    model: {
      value: (_vm.promotion.rewards.percentageOff),
      callback: function($$v) {
        _vm.promotion.rewards.percentageOff = _vm._n($$v)
      },
      expression: "promotion.rewards.percentageOff"
    }
  })], 1)], 1)]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.promotion.rewards.sumOff.required || !_vm.$v.promotion.rewards.percentageOff.required),
      expression: "!$v.promotion.rewards.sumOff.required || !$v.promotion.rewards.percentageOff.required"
    }],
    staticClass: "SpendXForDiscountPartialView__error"
  }, [_vm._v("\n\t\t  \tFill one or the other\n\t\t    ")])]), _vm._v(" "), _c('b-form-fieldset', {
    class: {
      'has-danger': _vm.$v.promotion.rewards.awardedAmount.$error
    },
    attrs: {
      "label": "off of"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": "items"
    }
  }, [_c('b-form-input', {
    staticClass: "awardedAmount",
    attrs: {
      "type": "number",
      "min": "0",
      "step": "any",
      "rows": 1
    },
    on: {
      "input": function($event) {
        _vm.$v.promotion.rewards.awardedAmount.$touch()
      }
    },
    model: {
      value: (_vm.promotion.rewards.awardedAmount),
      callback: function($$v) {
        _vm.promotion.rewards.awardedAmount = _vm._n($$v)
      },
      expression: "promotion.rewards.awardedAmount"
    }
  })], 1), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.promotion.rewards.awardedAmount.required),
      expression: "!$v.promotion.rewards.awardedAmount.required"
    }],
    staticClass: "SpendXForDiscountPartialView__error"
  }, [_vm._v("\n              Required\n            ")])], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": ""
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-5"
  }, [_vm._v("\n                once per day:\n                "), _c('b-form-checkbox', {
    staticClass: "oncePerDay",
    attrs: {
      "size": "lg",
      "value": "1",
      "unchecked-value": "0",
      "switch": ""
    },
    model: {
      value: (_vm.promotion.oncePerDay),
      callback: function($$v) {
        _vm.promotion.oncePerDay = $$v
      },
      expression: "promotion.oncePerDay"
    }
  })], 1)])]), _vm._v(" "), _c('product-list', {
    attrs: {
      "customerGroupId": _vm.promotion.customerGroupId,
      "discountedPriceFormula": _vm.discountedPriceFormula,
      "class-name": "SpendXForDiscount_awardedProducts",
      "validator": _vm.$v.promotion.rewards.awardedProducts
    },
    on: {
      "add": _vm.showProductSelect,
      "remove": _vm.removeAwardedProduct
    },
    model: {
      value: (_vm.promotion.rewards.awardedProducts),
      callback: function($$v) {
        _vm.promotion.rewards.awardedProducts = $$v
      },
      expression: "promotion.rewards.awardedProducts"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "w-100",
    slot: "modal-footer"
  }, [_c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.savePromotion()
      }
    }
  }, [_vm._v("Done")])], 1)]), _vm._v(" "), (_vm.awardedProductSelectShown) ? _c('product-select', {
    attrs: {
      "shown": _vm.awardedProductSelectShown,
      "regionId": _vm.regionId,
      "maxCustomerGroupId": _vm.maxCustomerGroupId
    },
    on: {
      "hide": function($event) {
        _vm.awardedProductSelectShown = false
      },
      "change": _vm.addAwardedProduct
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1685:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('h1', [_vm._v("Temporarily not able to connect to ERPLY")]), _vm._v(" "), _c('p', [_vm._v("This is most likely caused by maintenance or reaching the API usage limit. The normal operations should be\n    restored withing one hour. If you keep seeing this message for more than few hours, then please\n    contact ERPLY support.\n  ")])])
}]}

/***/ }),

/***/ 1686:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('event-list-filter', {
    attrs: {
      "regions": _vm.regions,
      "types": _vm.types,
      "statuses": _vm.filterStatuses
    },
    on: {
      "apply": _vm.applyFilter
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "30px",
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    staticClass: "col"
  }, [_c('h1', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._v("\n        Special price events\n        "), _c('span', {
    staticClass: "badge badge-pill badge-secondary"
  }, [_vm._v(_vm._s(_vm.itemCount))])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.addEvent
    }
  }, [_vm._v("New")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col event-list"
  }, [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Region")]), _vm._v(" "), _c('th', [_vm._v("\n            Start date\n            "), _c('icon', {
    attrs: {
      "name": "sort-desc"
    }
  })], 1), _vm._v(" "), _c('th', [_vm._v("End date")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', {
    staticStyle: {
      "display": "contents"
    }
  }, [_vm._l((_vm.events), function(event) {
    return _c('event-list-item', {
      key: event.id,
      attrs: {
        "event": event,
        "regions": _vm.regions,
        "types": _vm.types,
        "statuses": _vm.statuses
      },
      on: {
        "delete": _vm.confirmEventDelete,
        "edit": _vm.editEvent,
        "view": _vm.viewEvent,
        "multiCopy": _vm.multiCopyEvent,
        "copy": _vm.copyEvent,
        "lock": _vm.confirmEventLock,
        "unlock": _vm.confirmEventUnlock
      }
    })
  }), _vm._v(" "), (_vm.events.length === 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v("There are currently no events")])]) : _vm._e()], 2)]), _vm._v(" "), (_vm.pagination.last_page > 1) ? _c('pagination', {
    attrs: {
      "pagination": _vm.pagination,
      "offset": 10
    },
    on: {
      "paginate": function($event) {
        _vm.changePage()
      }
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "delete_modal",
      "title": "Are your sure?",
      "ok-title": "Delete"
    },
    on: {
      "ok": _vm.deleteEvent
    },
    model: {
      value: (_vm.deleteConfirmShown),
      callback: function($$v) {
        _vm.deleteConfirmShown = $$v
      },
      expression: "deleteConfirmShown"
    }
  }, [_vm._v("\n    By deleting event all price lists and campaigns will also be deleted\n  ")]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "unlock_modal",
      "title": "Are your sure?",
      "ok-title": "Unlock"
    },
    on: {
      "ok": _vm.unlockEvent
    },
    model: {
      value: (_vm.unlockConfirmShown),
      callback: function($$v) {
        _vm.unlockConfirmShown = $$v
      },
      expression: "unlockConfirmShown"
    }
  }, [_vm._v("\n    This ​ ​will ​ unlock ​ ​the ​ ​promotion, ​ ​are ​ ​you ​ ​sure to ​ unlock ​ ​the ​ ​promotion?\n  ")]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "lock_modal",
      "title": "Are your sure?",
      "ok-title": "Lock"
    },
    on: {
      "ok": _vm.lockEvent
    },
    model: {
      value: (_vm.lockConfirmShown),
      callback: function($$v) {
        _vm.lockConfirmShown = $$v
      },
      expression: "lockConfirmShown"
    }
  }, [_vm._v("\n    This ​ ​will ​ lock ​ ​the ​ ​promotion, ​ ​are ​ ​you ​ ​sure to ​ lock ​ ​the ​ ​promotion?\n  ")]), _vm._v(" "), _c('loading', {
    attrs: {
      "show": _vm.loading
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1687:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('h1', [_vm._v("We were not able to validate your access rights.")]), _vm._v(" "), _c('p', [_vm._v("Please check the following:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Make sure you opened this page by navigating to ERPLY backoffice.")]), _vm._v(" "), _c('li', [_vm._v("Make sure the user you are logged in with has administrator privileges.")]), _vm._v(" "), _c('li', [_vm._v("If you have kept the browser window opened for long time, then please refresh.")])])])
}]}

/***/ }),

/***/ 1688:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "BuyForDiscount"
  }, [_c('b-modal', {
    attrs: {
      "hide-footer": "",
      "size": "lg",
      "visible": _vm.shown
    },
    on: {
      "hide": function($event) {
        _vm.$emit('hide')
      },
      "shown": _vm.reset
    }
  }, [_c('div', {
    staticClass: "w-100",
    slot: "modal-title"
  }, [_c('strong', [_vm._v(_vm._s(_vm.name))])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('ul', {
    staticClass: "nav nav-tabs card-header-tabs"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    class: {
      active: _vm.tab == 0
    },
    on: {
      "click": function($event) {
        _vm.tab = 0
      }
    }
  }, [_vm._v("Customer must buy")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    class: {
      active: _vm.tab == 1
    },
    on: {
      "click": function($event) {
        _vm.tab = 1
      }
    }
  }, [_vm._v("Customer will get")])])])]), _vm._v(" "), (_vm.tab === 0) ? _c('div', {
    staticClass: "card-body"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "at least"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": "items"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "step": "1",
      "rows": 1,
      "disabled": ""
    },
    model: {
      value: (_vm.promotion.requirements.purchasedAmount),
      callback: function($$v) {
        _vm.promotion.requirements.purchasedAmount = $$v
      },
      expression: "promotion.requirements.purchasedAmount"
    }
  })], 1)], 1), _vm._v(" "), _c('product-list', {
    attrs: {
      "value": _vm.promotion.requirements.purchasedProducts,
      "enableSubsidy": false
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.tab === 1) ? _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-5"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "reward money"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": "CAD"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "step": "any",
      "rows": 1,
      "disabled": ""
    },
    model: {
      value: (_vm.promotion.rewards.rewardMoneyEarnedPerRedemption),
      callback: function($$v) {
        _vm.promotion.rewards.rewardMoneyEarnedPerRedemption = _vm._n($$v)
      },
      expression: "promotion.rewards.rewardMoneyEarnedPerRedemption"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-2 text-center my-4 pt-3"
  }, [_vm._v("\n\t  \t\t\t\tand\n\t  \t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "col-5"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "rewards subsidy"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": "CAD"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "step": "any",
      "rows": 1,
      "disabled": ""
    },
    model: {
      value: (_vm.promotion.rewardsSubsidy),
      callback: function($$v) {
        _vm.promotion.rewardsSubsidy = _vm._n($$v)
      },
      expression: "promotion.rewardsSubsidy"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "subsidy percentage of discount"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": "%"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "step": "any",
      "rows": 1,
      "disabled": ""
    },
    model: {
      value: (_vm.promotion.subsidyPercentageOfDiscount),
      callback: function($$v) {
        _vm.promotion.subsidyPercentageOfDiscount = _vm._n($$v)
      },
      expression: "promotion.subsidyPercentageOfDiscount"
    }
  })], 1)], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "for"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-5"
  }, [_c('b-input-group', {
    attrs: {
      "right": "CAD"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "step": "any",
      "rows": 1,
      "disabled": ""
    },
    model: {
      value: (_vm.promotion.rewards.sumOff),
      callback: function($$v) {
        _vm.promotion.rewards.sumOff = $$v
      },
      expression: "promotion.rewards.sumOff"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-2 text-center"
  }, [_vm._v("or")]), _vm._v(" "), _c('div', {
    staticClass: "col-5"
  }, [_c('b-input-group', {
    attrs: {
      "right": "%"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "step": "any",
      "rows": 1,
      "disabled": ""
    },
    model: {
      value: (_vm.promotion.rewards.percentageOff),
      callback: function($$v) {
        _vm.promotion.rewards.percentageOff = $$v
      },
      expression: "promotion.rewards.percentageOff"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "off of"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": "items"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "step": "any",
      "rows": 1,
      "disabled": ""
    },
    model: {
      value: (_vm.promotion.rewards.awardedAmount),
      callback: function($$v) {
        _vm.promotion.rewards.awardedAmount = $$v
      },
      expression: "promotion.rewards.awardedAmount"
    }
  })], 1)], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "up to"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": "items"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "step": "any",
      "rows": 1,
      "disabled": ""
    },
    model: {
      value: (_vm.promotion.rewards.redemptionLimit),
      callback: function($$v) {
        _vm.promotion.rewards.redemptionLimit = $$v
      },
      expression: "promotion.rewards.redemptionLimit"
    }
  })], 1)], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": ""
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-5"
  }, [_vm._v("\n                once per day:\n                "), _c('b-form-checkbox', {
    staticClass: "oncePerDay",
    attrs: {
      "size": "lg",
      "value": "1",
      "unchecked-value": "0",
      "switch": ""
    },
    model: {
      value: (_vm.promotion.oncePerDay),
      callback: function($$v) {
        _vm.promotion.oncePerDay = $$v
      },
      expression: "promotion.oncePerDay"
    }
  })], 1)])]), _vm._v(" "), _c('product-list', {
    attrs: {
      "value": _vm.promotion.rewards.awardedProducts,
      "customerGroupId": _vm.promotion.customerGroupId,
      "discountedPriceFormula": _vm.discountedPriceFormula
    }
  })], 1) : _vm._e()])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1689:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-modal', {
    attrs: {
      "title": "Add promotion",
      "hide-footer": "",
      "size": "lg",
      "visible": _vm.shown
    },
    on: {
      "hide": _vm.hide,
      "shown": _vm.reset
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col",
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_c('p', [_c('strong', [_vm._v("Select promotion type")])]), _vm._v(" "), _c('b-form-radio-group', {
    attrs: {
      "options": _vm.types,
      "stacked": true
    },
    on: {
      "change": _vm.hide
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  })], 1)])]), _vm._v(" "), _c('spend-x-for-discount', {
    attrs: {
      "shown": _vm.type === 'SPEND_X_FOR_DISCOUNT' || _vm.type === 'SPEND_GET_PERCENTAGE_OFF_ITEMS' || _vm.type === 'SPEND_GET_SUM_OFF_ITEMS',
      "value": _vm.promotion,
      "regionId": _vm.regionId,
      "maxCustomerGroupId": _vm.maxCustomerGroupId
    },
    on: {
      "hide": _vm.hideType,
      "change": _vm.change
    }
  }), _vm._v(" "), _c('multi-buy', {
    attrs: {
      "shown": _vm.type === 'MULTI_BUY' || _vm.type === 'BUY_ITEMS_FOR_SPECIAL_UNIT_PRICE',
      "value": _vm.promotion,
      "regionId": _vm.regionId,
      "maxCustomerGroupId": _vm.maxCustomerGroupId
    },
    on: {
      "hide": _vm.hideType,
      "change": _vm.change
    }
  }), _vm._v(" "), _c('buy-x-for-discount', {
    attrs: {
      "shown": _vm.type === 'BUY_X_FOR_DISCOUNT' || _vm.type === 'BUY_ITEMS_GET_SUM_OFF_ITEMS' || _vm.type === 'BUY_ITEMS_GET_PERCENTAGE_OFF_ITEMS',
      "value": _vm.promotion,
      "regionId": _vm.regionId,
      "maxCustomerGroupId": _vm.maxCustomerGroupId
    },
    on: {
      "hide": _vm.hideType,
      "change": _vm.change
    }
  }), _vm._v(" "), _c('buy-x-for-y-off', {
    attrs: {
      "shown": _vm.type === 'MULTIBUY_X_FOR_DISCOUNT' || _vm.type === 'MULTIBUY_GET_SUM_OFF' || _vm.type === 'MULTIBUY_GET_PERCENTAGE_OFF',
      "value": _vm.promotion,
      "regionId": _vm.regionId,
      "maxCustomerGroupId": _vm.maxCustomerGroupId
    },
    on: {
      "hide": _vm.hideType,
      "change": _vm.change
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1690:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "30px",
      "margin-bottom": "20px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-6 text-right"
  }, [_c('b-button', {
    on: {
      "click": _vm.back
    }
  }, [_vm._v("Back")])], 1)]), _vm._v(" "), _c('event-form', {
    attrs: {
      "regions": _vm.regions,
      "types": _vm.types,
      "$v": _vm.$v,
      "disabled": true
    },
    model: {
      value: (_vm.event),
      callback: function($$v) {
        _vm.event = $$v
      },
      expression: "event"
    }
  }), _vm._v(" "), _c('event-items', {
    attrs: {
      "discounted-products": _vm.event.discountedProducts,
      "special-promotions": _vm.event.specialPromotions,
      "event-start-date": _vm.event.startDate,
      "event-end-date": _vm.event.endDate,
      "customer-groups": _vm.customerGroups
    }
  }), _vm._v(" "), _c('loading', {
    attrs: {
      "show": _vm.loading
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('h1', [_vm._v("\n        Special price event\n      ")])])
}]}

/***/ }),

/***/ 1691:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "EventListItemPartialView",
    on: {
      "click": _vm.openEvent
    }
  }, [_c('td', [_vm._v(_vm._s(_vm.event.name))]), _vm._v(" "), _c('td', [_vm._v("\n    " + _vm._s(_vm.regionName) + "\n  ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatDate")(_vm.event.startDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatDate")(_vm.event.endDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.typeName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.statusName))]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_c('b-button', {
    staticClass: "multiCopy",
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.multiCopyEvent($event)
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "copy"
    }
  }), _vm._v(" "), _c('icon', {
    attrs: {
      "name": "arrow-right"
    }
  }), _vm._v(" "), _c('icon', {
    attrs: {
      "name": "map-marker"
    }
  })], 1), _vm._v(" "), _c('b-button', {
    staticClass: "copy",
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.copyEvent($event)
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "copy"
    }
  })], 1), _vm._v(" "), _c('b-button', {
    staticClass: "delete",
    attrs: {
      "variant": "secondary",
      "disabled": _vm.event.isLocked || _vm.event.isConfirmed
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.deleteEvent($event)
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "close"
    }
  })], 1), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.event.isLocked),
      expression: "!event.isLocked"
    }],
    staticClass: "lock",
    staticStyle: {
      "width": "40px"
    },
    attrs: {
      "variant": "secondary",
      "disabled": !_vm.event.isConfirmed
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.lockEvent($event)
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "unlock"
    }
  })], 1), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.event.isLocked),
      expression: "event.isLocked"
    }],
    staticClass: "unlock",
    staticStyle: {
      "width": "40px"
    },
    attrs: {
      "variant": "secondary",
      "disabled": !_vm.event.isConfirmed
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.unlockEvent($event)
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "lock"
    }
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1692:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pagination is-centered is-rounded",
    attrs: {
      "role": "navigation",
      "aria-label": "pagination"
    }
  }, [_c('ul', {
    staticClass: "pagination-links"
  }, [_c('li', [_c('a', {
    staticClass: "pagination-previous",
    attrs: {
      "disabled": _vm.pagination.current_page <= 1
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changePage(1)
      }
    }
  }, [_vm._v("First page")]), _vm._v(" "), _c('a', {
    staticClass: "pagination-previous",
    attrs: {
      "disabled": _vm.pagination.current_page <= 1
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changePage(_vm.pagination.current_page - 1)
      }
    }
  }, [_vm._v("Previous")])]), _vm._v(" "), _vm._l((_vm.pages), function(page) {
    return _c('li', [_c('a', {
      staticClass: "pagination-link number",
      class: _vm.isCurrentPage(page) ? 'is-current active' : '',
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.changePage(page)
        }
      }
    }, [_vm._v(_vm._s(page))])])
  }), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "pagination-next",
    attrs: {
      "disabled": _vm.pagination.current_page >= _vm.pagination.last_page
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changePage(_vm.pagination.current_page + 1)
      }
    }
  }, [_vm._v("Next page")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "pagination-next",
    attrs: {
      "disabled": _vm.pagination.current_page >= _vm.pagination.last_page
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changePage(_vm.pagination.last_page)
      }
    }
  }, [_vm._v("Last page")])])], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 1693:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('editable-grid-row', {
    class: {
      error: _vm.$v.$error
    },
    attrs: {
      "activeRow": _vm.activeRow
    }
  }, [_c('editable-grid-cell', {
    staticClass: "plu",
    attrs: {
      "row": _vm.row,
      "column": 0,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "has-danger": !_vm.$v.unique && _vm.$v.$error
    }
  }, [_c('span', {
    attrs: {
      "id": 'uuid' + _vm.promotion.uuid + '_' + _vm.itemIndex
    },
    slot: "edit"
  }, [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "value": _vm.item.plu,
      "disabled": true,
      "type": "text"
    }
  }), _vm._v(" "), _c('b-input-group-button', [_c('b-button', {
    on: {
      "click": _vm.showPromotion
    }
  }, [_c('icon', {
    attrs: {
      "name": "pencil"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('span', {
    attrs: {
      "id": 'uuid' + _vm.promotion.uuid + '_' + _vm.itemIndex
    },
    slot: "view"
  }, [_vm._v("\n        " + _vm._s(_vm.item.plu) + "\n      ")]), _vm._v(" "), (!_vm.$v.unique && _vm.$v.$error) ? _c('b-tooltip', {
    attrs: {
      "target": 'uuid' + _vm.promotion.uuid + '_' + _vm.itemIndex,
      "placement": "right"
    }
  }, [_vm._v("\n        Some of the products already have an overlapping discount or promotion set in following events:\n        "), _c('strong', [_vm._v(_vm._s(_vm.$v.$params.unique.matches(_vm.promotion)))]), _vm._v("."), _c('br'), _c('br'), _vm._v("\n        Try selecting different products, changing customer group or picking different date range.\n      ")]) : _vm._e()], 1), _vm._v(" "), _c('editable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "column": 1,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited
    }
  }, [_c('span', {
    slot: "edit"
  }, [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "value": _vm.item.name,
      "disabled": true,
      "type": "text"
    }
  }), _vm._v(" "), _c('b-input-group-button', [_c('b-button', {
    on: {
      "click": _vm.showPromotion
    }
  }, [_c('icon', {
    attrs: {
      "name": "pencil"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('span', {
    slot: "view"
  }, [_vm._v("\n    \t" + _vm._s(_vm._f("fixedLength")(_vm.item.name, 20)) + "\n      ")])]), _vm._v(" "), _c('editable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "column": 2,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "is-editable": false
    }
  }, [_c('span', {
    slot: "view"
  }, [_vm._v("\n        " + _vm._s(_vm._f("fixedLength")(_vm.typeName, 30)) + "\n      ")])]), _vm._v(" "), _c('editable-grid-cell', {
    staticClass: "customerGroupId",
    attrs: {
      "row": _vm.row,
      "column": 3,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited
    }
  }, [_c('span', {
    slot: "edit"
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.customerGroups
    },
    model: {
      value: (_vm.promotion.customerGroupId),
      callback: function($$v) {
        _vm.promotion.customerGroupId = $$v
      },
      expression: "promotion.customerGroupId"
    }
  })], 1), _vm._v(" "), _c('span', {
    slot: "view"
  }, [_vm._v("\n        " + _vm._s(_vm.customerGroupName) + "\n      ")])]), _vm._v(" "), _c('editable-grid-cell', {
    staticClass: "startDate",
    attrs: {
      "row": _vm.row,
      "column": 4,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "has-danger": _vm.$v.startDate.$error
    }
  }, [_c('span', {
    slot: "edit"
  }, [_c('flatpickr', {
    attrs: {
      "config": _vm.fpOptions
    },
    on: {
      "input": function($event) {
        _vm.$v.startDate.$touch()
      }
    },
    model: {
      value: (_vm.promotion.startDate),
      callback: function($$v) {
        _vm.promotion.startDate = $$v
      },
      expression: "promotion.startDate"
    }
  })], 1), _vm._v(" "), (_vm.showDates) ? _c('span', {
    slot: "view"
  }, [_vm._v("\n        " + _vm._s(_vm._f("formatDate")(_vm.promotion.startDate)) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('editable-grid-cell', {
    staticClass: "endDate",
    attrs: {
      "row": _vm.row,
      "column": 5,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "has-danger": _vm.$v.endDate.$error
    }
  }, [_c('span', {
    slot: "edit"
  }, [_c('flatpickr', {
    attrs: {
      "config": _vm.fpOptions
    },
    on: {
      "input": function($event) {
        _vm.$v.endDate.$touch()
      }
    },
    model: {
      value: (_vm.promotion.endDate),
      callback: function($$v) {
        _vm.promotion.endDate = $$v
      },
      expression: "promotion.endDate"
    }
  })], 1), _vm._v(" "), (_vm.showDates) ? _c('span', {
    slot: "view"
  }, [_vm._v("\n        " + _vm._s(_vm._f("formatDate")(_vm.promotion.endDate)) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('editable-grid-cell', {
    staticClass: "page",
    attrs: {
      "row": _vm.row,
      "column": 6,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "has-danger": _vm.$v.page.$error
    }
  }, [_c('span', {
    slot: "edit"
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "step": "1",
      "rows": 1
    },
    on: {
      "input": function($event) {
        _vm.$v.page.$touch()
      }
    },
    model: {
      value: (_vm.promotion.page),
      callback: function($$v) {
        _vm.promotion.page = _vm._n($$v)
      },
      expression: "promotion.page"
    }
  })], 1), _vm._v(" "), _c('span', {
    slot: "view"
  }, [_vm._v("\n        " + _vm._s(_vm.promotion.page) + "\n      ")])]), _vm._v(" "), _c('editable-grid-cell', {
    staticClass: "positionOnPage",
    attrs: {
      "row": _vm.row,
      "column": 7,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "has-danger": _vm.$v.positionOnPage.$error
    }
  }, [_c('span', {
    slot: "edit"
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "step": "1",
      "rows": 1
    },
    on: {
      "input": function($event) {
        _vm.$v.positionOnPage.$touch()
      }
    },
    model: {
      value: (_vm.promotion.positionOnPage),
      callback: function($$v) {
        _vm.promotion.positionOnPage = _vm._n($$v)
      },
      expression: "promotion.positionOnPage"
    }
  })], 1), _vm._v(" "), _c('span', {
    slot: "view"
  }, [_vm._v("\n        " + _vm._s(_vm.promotion.positionOnPage) + "\n      ")])]), _vm._v(" "), _c('editable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "column": 8,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "is-editable": false
    }
  }, [_c('span', {
    slot: "view"
  }, [_vm._v("\n        " + _vm._s(_vm.basePrice) + "\n      ")])]), _vm._v(" "), _c('editable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "column": 9,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "is-editable": false
    }
  }, [_c('span', {
    slot: "view"
  }, [_vm._v("\n        " + _vm._s(_vm.item.cost) + "\n      ")])]), _vm._v(" "), _c('editable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "column": 10,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited
    }
  }, [_c('span', {
    slot: "edit"
  }, [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "value": _vm.discountedPrice,
      "disabled": true,
      "type": "text"
    }
  }), _vm._v(" "), _c('b-input-group-button', [_c('b-button', {
    on: {
      "click": _vm.showPromotion
    }
  }, [_c('icon', {
    attrs: {
      "name": "pencil"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('span', {
    slot: "view"
  }, [_vm._v("\n        " + _vm._s(_vm._f("formatPrice")(_vm._f("rounded")(_vm.discountedPrice))) + "\n      ")])]), _vm._v(" "), _c('editable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "column": 11,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "is-editable": false
    }
  }, [_c('span', {
    slot: "view"
  }, [_vm._v("\n        " + _vm._s(_vm._f("rounded")(_vm.margin)) + "%\n      ")])]), _vm._v(" "), _c('editable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "column": 12,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "is-editable": !_vm.promotion.type.includes('BUY_ITEMS_GET')
    }
  }, [_c('span', {
    slot: "edit"
  }, [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "value": _vm.promotion.targetMargin,
      "disabled": true,
      "type": "text"
    }
  }), _vm._v(" "), _c('b-input-group-button', [_c('b-button', {
    on: {
      "click": _vm.showPromotion
    }
  }, [_c('icon', {
    attrs: {
      "name": "pencil"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('span', {
    slot: "view"
  }, [_vm._v("\n        " + _vm._s(_vm.promotion.targetMargin)), (_vm.promotion.targetMargin || _vm.promotion.targetMargin === 0) ? _c('span', [_vm._v("%")]) : _c('span', [_vm._v("-")])])]), _vm._v(" "), _c('editable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "hidden": "true",
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited
    }
  }, [_c('span', {
    slot: "edit"
  }, [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "value": _vm.promotion.subsidyPercentageOfDiscount,
      "disabled": true,
      "type": "text"
    }
  }), _vm._v(" "), _c('b-input-group-button', [_c('b-button', {
    on: {
      "click": _vm.showPromotion
    }
  }, [_c('icon', {
    attrs: {
      "name": "pencil"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('span', {
    slot: "view"
  }, [_vm._v("\n        " + _vm._s(_vm.promotion.subsidyPercentageOfDiscount) + "\n      ")])]), _vm._v(" "), _c('editable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "column": 13,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "is-editable": _vm.promotion.type !== 'BUY_ITEMS_FOR_SPECIAL_UNIT_PRICE' && _vm.promotion.type !== 'MULTIBUY_GET_PERCENTAGE_OFF' && _vm.promotion.type !== 'MULTIBUY_GET_SUM_OFF'
    }
  }, [_c('span', {
    slot: "edit"
  }, [_c('b-input-group', [(_vm.promotion.rewards.rewardMoneyEarnedPerItem !== null && _vm.promotion.type.includes('SPEND_GET')) ? _c('b-form-input', {
    attrs: {
      "value": _vm.promotion.rewards.rewardMoneyEarnedPerItem,
      "disabled": true,
      "type": "text"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.promotion.rewards.rewardMoneyEarnedPerRedemption !== null && _vm.promotion.type.includes('BUY_ITEMS_GET')) ? _c('b-form-input', {
    attrs: {
      "value": _vm.promotion.rewards.rewardMoneyEarnedPerRedemption,
      "disabled": true,
      "type": "text"
    }
  }) : _vm._e(), _vm._v(" "), _c('b-input-group-button', [_c('b-button', {
    on: {
      "click": _vm.showPromotion
    }
  }, [_c('icon', {
    attrs: {
      "name": "pencil"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('span', {
    slot: "view"
  }, [(_vm.promotion.rewards.rewardMoneyEarnedPerItem !== null && _vm.promotion.type.includes('SPEND_GET')) ? _c('span', [_vm._v(_vm._s(_vm.promotion.rewards.rewardMoneyEarnedPerItem))]) : (_vm.promotion.rewards.rewardMoneyEarnedPerRedemption !== null && _vm.promotion.type.includes('BUY_ITEMS_GET')) ? _c('span', [_vm._v(_vm._s(_vm.promotion.rewards.rewardMoneyEarnedPerRedemption))]) : _c('span', [_vm._v("-")])])]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [(!_vm.disableDelete) ? _c('b-button', {
    staticClass: "delete",
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.deletePromotion($event)
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "close"
    }
  })], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1694:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    on: {
      "click": _vm.select,
      "keydown": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.select($event)
      }
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 1695:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.applyFilter($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Event code"
    }
  }, [_c('b-form-input', {
    staticClass: "eventCode",
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.filter.eventCode),
      callback: function($$v) {
        _vm.filter.eventCode = $$v
      },
      expression: "filter.eventCode"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Region"
    }
  }, [_c('b-form-select', {
    staticClass: "col-12 region",
    attrs: {
      "options": _vm.regionOptions
    },
    model: {
      value: (_vm.filter.regionId),
      callback: function($$v) {
        _vm.filter.regionId = $$v
      },
      expression: "filter.regionId"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Start date"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [(!_vm.beingReset) ? _c('div', [_c('flatpickr', {
    staticClass: "form-control",
    attrs: {
      "config": _vm.fpOptions
    },
    model: {
      value: (_vm.filter.startDateFrom),
      callback: function($$v) {
        _vm.filter.startDateFrom = $$v
      },
      expression: "filter.startDateFrom"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [(!_vm.beingReset) ? _c('div', {
    class: {
      'has-danger': _vm.$v.filter.startDateTo.$error
    }
  }, [_c('flatpickr', {
    staticClass: "form-control",
    attrs: {
      "config": _vm.fpOptions
    },
    on: {
      "input": function($event) {
        _vm.$v.filter.startDateTo.$touch()
      }
    },
    model: {
      value: (_vm.filter.startDateTo),
      callback: function($$v) {
        _vm.filter.startDateTo = $$v
      },
      expression: "filter.startDateTo"
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.filter.startDateTo.greater),
      expression: "!$v.filter.startDateTo.greater"
    }],
    staticClass: "form-control-feedback"
  }, [_vm._v("End is earlier than\n                  start\n                ")])], 1) : _vm._e()])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "End date"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [(!_vm.beingReset) ? _c('div', [_c('flatpickr', {
    staticClass: "form-control",
    attrs: {
      "config": _vm.fpOptions
    },
    model: {
      value: (_vm.filter.endDateFrom),
      callback: function($$v) {
        _vm.filter.endDateFrom = $$v
      },
      expression: "filter.endDateFrom"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [(!_vm.beingReset) ? _c('div', {
    class: {
      'has-danger': _vm.$v.filter.endDateTo.$error
    }
  }, [_c('flatpickr', {
    staticClass: "form-control",
    attrs: {
      "config": _vm.fpOptions
    },
    on: {
      "input": function($event) {
        _vm.$v.filter.endDateTo.$touch()
      }
    },
    model: {
      value: (_vm.filter.endDateTo),
      callback: function($$v) {
        _vm.filter.endDateTo = $$v
      },
      expression: "filter.endDateTo"
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.filter.endDateTo.greater),
      expression: "!$v.filter.endDateTo.greater"
    }],
    staticClass: "form-control-feedback"
  }, [_vm._v("End is earlier than\n                  start\n                ")])], 1) : _vm._e()])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Type"
    }
  }, [_c('b-form-select', {
    staticClass: "col-12 type",
    attrs: {
      "options": _vm.types
    },
    model: {
      value: (_vm.filter.type),
      callback: function($$v) {
        _vm.filter.type = $$v
      },
      expression: "filter.type"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }), _vm._v(" "), _c('div', {
    staticClass: "col text-right"
  }, [_c('b-button', {
    attrs: {
      "variant": "secondary",
      "type": "submit"
    }
  }, [_vm._v("\n          show\n        ")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": _vm.resetFilter
    }
  }, [_vm._v("\n          clear\n        ")])], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 1696:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    attrs: {
      "id": _vm.id,
      "title": "Product",
      "hide-footer": "",
      "visible": _vm.shown
    },
    on: {
      "shown": _vm.reset,
      "hide": _vm.hide
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Search"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    ref: "searchTermContainer",
    staticClass: "col-8"
  }, [_c('b-form-input', {
    staticClass: "searchTerm",
    attrs: {
      "type": "text"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.fetchProducts($event)
      }
    },
    model: {
      value: (_vm.searchTerm),
      callback: function($$v) {
        _vm.searchTerm = $$v
      },
      expression: "searchTerm"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('b-button', {
    staticClass: "col",
    on: {
      "click": _vm.fetchProducts
    }
  }, [_vm._v("Search")])], 1)])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('selectable-grid', {
    attrs: {
      "rows": _vm.products.length,
      "focused": _vm.gridFocused
    },
    scopedSlots: _vm._u([
      ["default", function(grid) {
        return [_vm._l((_vm.products), function(product, index) {
          return _c('selectable-grid-row', {
            key: product.id,
            staticClass: "ProductSelectPartialView__result",
            attrs: {
              "activeRow": grid.activeRow
            },
            on: {
              "select": function () { return _vm.selectProduct(product); }
            }
          }, [_c('selectable-grid-cell', {
            staticClass: "productSelect",
            attrs: {
              "row": index,
              "activeRow": grid.activeRow
            }
          }, [_vm._v("\n              " + _vm._s(product.code) + "\n            ")]), _vm._v(" "), _c('selectable-grid-cell', {
            staticClass: "productSelect",
            attrs: {
              "row": index,
              "activeRow": grid.activeRow
            }
          }, [_vm._v("\n              " + _vm._s(product.name) + "\n            ")]), _vm._v(" "), _c('selectable-grid-cell', {
            staticClass: "productSelect",
            attrs: {
              "row": index,
              "activeRow": grid.activeRow
            }
          }, [_vm._v("\n              " + _vm._s(product.regionBasePrice) + "\n            ")])], 1)
        }), _vm._v(" "), (_vm.loading) ? _c('tr', [_c('td', {
          staticClass: "text-center",
          attrs: {
            "colspan": "3"
          }
        }, [_vm._v("Loading...")])]) : (!_vm.searchDone) ? _c('tr', [_c('td', {
          staticClass: "text-center",
          attrs: {
            "colspan": "3"
          }
        }, [_vm._v("Fill the search term above")])]) : (_vm.products.length === 0) ? _c('tr', [_c('td', {
          staticClass: "text-center",
          attrs: {
            "colspan": "3"
          }
        }, [_vm._v("No products found")])]) : _vm._e()]
      }]
    ])
  }, [_c('th', {
    slot: "header"
  }, [_vm._v("PLU")]), _vm._v(" "), _c('th', {
    slot: "header"
  }, [_vm._v("Product")]), _vm._v(" "), _c('th', {
    slot: "header"
  }, [_vm._v("Price")])])], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 1697:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('editable-grid-row', {
    class: {
      error: _vm.$v.$error
    },
    attrs: {
      "activeRow": _vm.activeRow
    }
  }, [_c('editable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "column": 0,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "is-editable": false,
      "has-danger": !_vm.$v.unique && _vm.$v.$error
    }
  }, [_c('span', {
    attrs: {
      "id": 'uuid' + _vm.promotion.uuid + '_' + _vm.itemIndex
    },
    slot: "view"
  }, [_vm._v("\n        " + _vm._s(_vm.item.plu) + "\n      ")]), _vm._v(" "), (!_vm.$v.unique && _vm.$v.$error) ? _c('b-tooltip', {
    attrs: {
      "target": 'uuid' + _vm.promotion.uuid + '_' + _vm.itemIndex,
      "placement": "right"
    }
  }, [_vm._v("\n        Some of the products already have an overlapping discount or promotion set in following events:\n        "), _c('strong', [_vm._v(_vm._s(_vm.$v.$params.unique.matches(_vm.promotion)))]), _vm._v("."), _c('br'), _c('br'), _vm._v("\n        Try selecting different products, changing customer group or picking different date range.\n      ")]) : _vm._e()], 1), _vm._v(" "), _c('editable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "column": 1,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "is-editable": false
    }
  }, [_c('span', {
    slot: "view"
  }, [_vm._v("\n        " + _vm._s(_vm._f("fixedLength")(_vm.item.name, 20)) + "\n      ")])]), _vm._v(" "), _c('editable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "column": 2,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "is-editable": false
    }
  }, [_c('span', {
    slot: "view"
  }, [_vm._v("\n        " + _vm._s(_vm._f("fixedLength")(_vm.typeName, 30)) + "\n      ")])]), _vm._v(" "), _c('editable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "column": 3,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "is-editable": false
    }
  }, [_c('span', {
    slot: "view"
  }, [_vm._v("\n        " + _vm._s(_vm.customerGroupName) + "\n      ")])]), _vm._v(" "), _c('editable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "column": 4,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "is-editable": _vm.promotion.isCustomDate,
      "has-danger": _vm.$v.startDate.$error
    }
  }, [_c('span', {
    slot: "edit"
  }, [_c('flatpickr', {
    attrs: {
      "config": Object.assign({}, _vm.fpOptions, {
        altInputClass: 'form-control startDate'
      })
    },
    on: {
      "input": function($event) {
        _vm.$v.startDate.$touch()
      }
    },
    model: {
      value: (_vm.promotion.startDate),
      callback: function($$v) {
        _vm.promotion.startDate = $$v
      },
      expression: "promotion.startDate"
    }
  })], 1), _vm._v(" "), (_vm.showDates) ? _c('span', {
    slot: "view"
  }, [_vm._v("\n        " + _vm._s(_vm._f("formatDate")(_vm.promotion.startDate)) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('editable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "column": 5,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "is-editable": _vm.promotion.isCustomDate,
      "has-danger": _vm.$v.endDate.$error
    }
  }, [_c('span', {
    slot: "edit"
  }, [_c('flatpickr', {
    attrs: {
      "config": Object.assign({}, _vm.fpOptions, {
        altInputClass: 'form-control endDate'
      })
    },
    on: {
      "input": function($event) {
        _vm.$v.endDate.$touch()
      }
    },
    model: {
      value: (_vm.promotion.endDate),
      callback: function($$v) {
        _vm.promotion.endDate = $$v
      },
      expression: "promotion.endDate"
    }
  })], 1), _vm._v(" "), (_vm.showDates) ? _c('span', {
    slot: "view"
  }, [_vm._v("\n        " + _vm._s(_vm._f("formatDate")(_vm.promotion.endDate)) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('editable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "column": 6,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "is-editable": false
    }
  }, [_c('span', {
    slot: "view"
  }, [_vm._v("\n        " + _vm._s(_vm.promotion.page) + "\n      ")])]), _vm._v(" "), _c('editable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "column": 7,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "is-editable": false
    }
  }, [_c('span', {
    slot: "view"
  }, [_vm._v("\n        " + _vm._s(_vm.promotion.positionOnPage) + "\n      ")])]), _vm._v(" "), _c('editable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "column": 8,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "is-editable": false
    }
  }, [_c('span', {
    slot: "view"
  }, [_vm._v("\n        " + _vm._s(_vm.basePrice) + "\n      ")])]), _vm._v(" "), _c('editable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "column": 9,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "is-editable": false
    }
  }, [_c('span', {
    slot: "view"
  }, [_vm._v("\n        " + _vm._s(_vm.item.cost) + "\n      ")])]), _vm._v(" "), _c('editable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "column": 10,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "is-editable": false
    }
  }, [_c('span', {
    slot: "view"
  }, [_vm._v("\n        " + _vm._s(_vm._f("rounded")(_vm.discountedPrice)) + "\n      ")])]), _vm._v(" "), _c('editable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "column": 11,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "is-editable": false
    }
  }, [_c('span', {
    slot: "view"
  }, [_vm._v("\n        " + _vm._s(_vm._f("rounded")(_vm.margin)) + "%\n      ")])]), _vm._v(" "), _c('editable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "column": 12,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "is-editable": false
    }
  }, [_c('span', {
    slot: "view"
  }, [_vm._v("\n        " + _vm._s(_vm.promotion.targetMargin)), (_vm.promotion.targetMargin || _vm.promotion.targetMargin === 0) ? _c('span', [_vm._v("%")]) : _c('span', [_vm._v("-")])])]), _vm._v(" "), _c('editable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "column": 13,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "is-editable": false
    }
  }, [_c('span', {
    slot: "view"
  }, [(_vm.promotion.rewards.rewardMoneyEarnedPerItem !== null && _vm.promotion.type.includes('SPEND_GET')) ? _c('span', [_vm._v(_vm._s(_vm.promotion.rewards.rewardMoneyEarnedPerItem))]) : (_vm.promotion.rewards.rewardMoneyEarnedPerRedemption !== null && _vm.promotion.type.includes('BUY_ITEMS_GET')) ? _c('span', [_vm._v(_vm._s(_vm.promotion.rewards.rewardMoneyEarnedPerRedemption))]) : _c('span', [_vm._v("-")])])]), _vm._v(" "), _c('editable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "hidden": "true",
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "is-editable": false
    }
  }, [_c('span', {
    slot: "view"
  }, [_vm._v("\n\t\t  " + _vm._s(_vm.promotion.subsidyPercentageOfDiscount) + "\n      ")])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1698:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 1699:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "30px",
      "margin-bottom": "20px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-6 text-right"
  }, [(this.event.isConfirmed) ? _c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.unconfirmationShown = true
      }
    }
  }, [_vm._v("\n          Save & Unconfirm\n        ")]) : _vm._e(), _vm._v(" "), (!this.event.isConfirmed) ? _c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.confirmationShown = true
      }
    }
  }, [_vm._v("\n          Save & Confirm\n        ")]) : _vm._e(), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('b-button', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")])], 1)]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "confirm_modal",
      "title": "Are your sure?",
      "ok-title": "Confirm and activate"
    },
    on: {
      "ok": _vm.saveAndConfirm
    },
    model: {
      value: (_vm.confirmationShown),
      callback: function($$v) {
        _vm.confirmationShown = $$v
      },
      expression: "confirmationShown"
    }
  }, [_vm._v("\n      This ​ ​will ​ ​activate ​ ​the ​ ​promotion, ​ ​are ​ ​you ​ ​sure to ​ ​activate ​ ​the ​ ​promotion?\n    ")]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "unconfirm_modal",
      "title": "Are your sure?",
      "ok-title": "Unconfirm and deactivate"
    },
    on: {
      "ok": _vm.saveAndUnconfirm
    },
    model: {
      value: (_vm.unconfirmationShown),
      callback: function($$v) {
        _vm.unconfirmationShown = $$v
      },
      expression: "unconfirmationShown"
    }
  }, [_vm._v("\n      This ​ ​will ​ ​deactivate ​ ​the ​ ​promotion, ​ ​are ​ ​you ​ ​sure to ​ ​deactivate ​ ​the ​ ​promotion?\n    ")]), _vm._v(" "), _c('b-alert', {
    attrs: {
      "variant": "danger",
      "show": _vm.$v.$error
    }
  }, [_vm._v("\n      Please check that all fields are correct. Incorrect values are highlighted.\n    ")]), _vm._v(" "), _c('event-form', {
    attrs: {
      "regions": _vm.regions,
      "types": _vm.types,
      "$v": _vm.$v,
      "disableType": true,
      "disableRegion": true,
      "disableStartAndEndDate": true
    },
    model: {
      value: (_vm.event),
      callback: function($$v) {
        _vm.event = $$v
      },
      expression: "event"
    }
  }), _vm._v(" "), _c('event-items', {
    attrs: {
      "discounted-products": _vm.event.discountedProducts,
      "special-promotions": _vm.event.specialPromotions,
      "deleted-discounts-and-promotions": _vm.event.deletedDiscountsAndPromotions,
      "event-start-date": _vm.event.startDate,
      "event-end-date": _vm.event.endDate,
      "customer-groups": _vm.customerGroups,
      "region-id": _vm.event.regionId,
      "event-id": _vm.$route.params.id,
      "max-customer-group-id": _vm.maxCustomerGroupId,
      "is-event-confirmed": _vm.event.isConfirmed,
      "$v": _vm.$v.event
    }
  }), _vm._v(" "), _c('loading', {
    attrs: {
      "show": _vm.loading
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('h1', [_vm._v("\n          Special price event\n        ")])])
}]}

/***/ }),

/***/ 1700:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_vm._t("header")], 2)]), _vm._v(" "), _c('tbody', {
    on: {
      "keydown": [function($event) {
        if ('button' in $event && $event.button !== 0) { return null; }
        if (!('button' in $event) && _vm._k($event.keyCode, "left", 37)) { return null; }
        _vm.selectLeftCell($event)
      }, function($event) {
        if ('button' in $event && $event.button !== 2) { return null; }
        if (!('button' in $event) && _vm._k($event.keyCode, "right", 39)) { return null; }
        _vm.selectRightCell($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38)) { return null; }
        _vm.selectUpCell($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40)) { return null; }
        _vm.selectDownCell($event)
      }]
    }
  }, [_vm._t("default", null, {
    activeRow: _vm.activeRow,
    activeColumn: _vm.activeColumn,
    isBeingEdited: _vm.isBeingEdited
  })], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 1701:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    class: _vm.clazz,
    style: (_vm.style),
    attrs: {
      "version": "1.1",
      "role": _vm.label ? 'img' : 'presentation',
      "aria-label": _vm.label,
      "x": _vm.x,
      "y": _vm.y,
      "width": _vm.width,
      "height": _vm.height,
      "viewBox": _vm.box
    }
  }, [_vm._t("default", [(_vm.icon && _vm.icon.paths) ? _vm._l((_vm.icon.paths), function(path) {
    return _c('path', _vm._b({}, 'path', path))
  }) : _vm._e(), _vm._v(" "), (_vm.icon && _vm.icon.polygons) ? _vm._l((_vm.icon.polygons), function(polygon) {
    return _c('polygon', _vm._b({}, 'polygon', polygon))
  }) : _vm._e(), _vm._v("\b\n    "), (_vm.icon && _vm.icon.raw) ? [_c('g', {
    domProps: {
      "innerHTML": _vm._s(_vm.icon.raw)
    }
  })] : _vm._e()])], 2)
},staticRenderFns: []}

/***/ }),

/***/ 1702:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "30px",
      "margin-bottom": "20px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-6 text-right"
  }, [_c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Cancel")])], 1)]), _vm._v(" "), _c('b-alert', {
    attrs: {
      "variant": "danger",
      "show": _vm.$v.$error
    }
  }, [_vm._v("\n      Please check that all fields are correct. Incorrect values are highlighted.\n    ")]), _vm._v(" "), _c('event-form', {
    attrs: {
      "regions": _vm.regions,
      "types": _vm.types,
      "$v": _vm.$v
    },
    model: {
      value: (_vm.event),
      callback: function($$v) {
        _vm.event = $$v
      },
      expression: "event"
    }
  }), _vm._v(" "), _c('loading', {
    attrs: {
      "show": _vm.loading
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('h1', [_vm._v("Special price event")])])
}]}

/***/ }),

/***/ 1703:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('h1', [_vm._v("We are experiencing some problems.")]), _vm._v(" "), _c('p', [_vm._v("We are most likely already fixing the problem. If you keep seeing this message for more than one day, then please contact ERPLY support.")])])
}]}

/***/ }),

/***/ 1704:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1705:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "BuyXGetYOff"
  }, [_c('b-modal', {
    attrs: {
      "hide-footer": "",
      "size": "lg",
      "visible": _vm.shown
    },
    on: {
      "hide": function($event) {
        _vm.$emit('hide')
      },
      "shown": _vm.reset
    }
  }, [_c('div', {
    staticClass: "w-100",
    slot: "modal-title"
  }, [_c('strong', [_vm._v(_vm._s(_vm.name))])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('ul', {
    staticClass: "nav nav-tabs card-header-tabs"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    class: {
      active: _vm.tab == 0
    },
    on: {
      "click": function($event) {
        _vm.tab = 0
      }
    }
  }, [_vm._v("Customer must buy")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    class: {
      active: _vm.tab == 1
    },
    on: {
      "click": function($event) {
        _vm.tab = 1
      }
    }
  }, [_vm._v("Customer will get")])])])]), _vm._v(" "), (_vm.tab === 0) ? _c('div', {
    staticClass: "card-body"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "at least"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": "items"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "step": "1",
      "rows": 1,
      "disabled": ""
    },
    model: {
      value: (_vm.promotion.requirements.purchasedAmount),
      callback: function($$v) {
        _vm.promotion.requirements.purchasedAmount = $$v
      },
      expression: "promotion.requirements.purchasedAmount"
    }
  })], 1)], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "up to"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": "items"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "step": "any",
      "rows": 1,
      "disabled": ""
    },
    model: {
      value: (_vm.promotion.rewards.redemptionLimit),
      callback: function($$v) {
        _vm.promotion.rewards.redemptionLimit = $$v
      },
      expression: "promotion.rewards.redemptionLimit"
    }
  })], 1)], 1), _vm._v(" "), _c('product-list', {
    attrs: {
      "value": _vm.promotion.requirements.purchasedProducts,
      "enableSubsidy": false
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.tab === 1) ? _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-5"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "reward money"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": "CAD"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "step": "any",
      "rows": 1,
      "disabled": ""
    },
    model: {
      value: (_vm.promotion.rewards.rewardMoneyEarnedPerRedemption),
      callback: function($$v) {
        _vm.promotion.rewards.rewardMoneyEarnedPerRedemption = _vm._n($$v)
      },
      expression: "promotion.rewards.rewardMoneyEarnedPerRedemption"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-2 text-center my-4 pt-3"
  }, [_vm._v("\n            and\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "col-5"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "rewards subsidy"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": "CAD"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "step": "any",
      "rows": 1,
      "disabled": ""
    },
    model: {
      value: (_vm.promotion.rewardsSubsidy),
      callback: function($$v) {
        _vm.promotion.rewardsSubsidy = _vm._n($$v)
      },
      expression: "promotion.rewardsSubsidy"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "target margin"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": "%"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "step": "any",
      "rows": 1,
      "disabled": ""
    },
    model: {
      value: (_vm.promotion.targetMargin),
      callback: function($$v) {
        _vm.promotion.targetMargin = _vm._n($$v)
      },
      expression: "promotion.targetMargin"
    }
  })], 1)], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "for"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-5"
  }, [_c('b-input-group', {
    attrs: {
      "right": "CAD"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "step": "any",
      "rows": 1,
      "disabled": ""
    },
    model: {
      value: (_vm.promotion.rewards.sumOff),
      callback: function($$v) {
        _vm.promotion.rewards.sumOff = $$v
      },
      expression: "promotion.rewards.sumOff"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-2 text-center"
  }, [_vm._v("or")]), _vm._v(" "), _c('div', {
    staticClass: "col-5"
  }, [_c('b-input-group', {
    attrs: {
      "right": "%"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "step": "any",
      "rows": 1,
      "disabled": ""
    },
    model: {
      value: (_vm.promotion.rewards.percentageOff),
      callback: function($$v) {
        _vm.promotion.rewards.percentageOff = $$v
      },
      expression: "promotion.rewards.percentageOff"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "from"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-5"
  }, [_c('b-input-group', {
    attrs: {
      "right": "times"
    }
  }, [_c('b-form-input', {
    staticClass: "sumOff",
    attrs: {
      "type": "number",
      "min": "0",
      "step": "any",
      "rows": 1
    },
    model: {
      value: (_vm.promotion.rewards.salesRedemptionLimit),
      callback: function($$v) {
        _vm.promotion.rewards.salesRedemptionLimit = _vm._n($$v)
      },
      expression: "promotion.rewards.salesRedemptionLimit"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-2 text-center"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-5"
  }, [_vm._v("\n              once per day:\n              "), _c('b-form-checkbox', {
    staticClass: "oncePerDay",
    attrs: {
      "size": "lg",
      "value": "1",
      "unchecked-value": "0",
      "switch": ""
    },
    on: {
      "input": function($event) {
        _vm.$v.promotion.oncePerDay.$touch()
      }
    },
    model: {
      value: (_vm.promotion.oncePerDay),
      callback: function($$v) {
        _vm.promotion.oncePerDay = $$v
      },
      expression: "promotion.oncePerDay"
    }
  })], 1)])])], 1) : _vm._e()])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1706:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "CopyEventToRegions"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "30px",
      "margin-bottom": "20px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-6 text-right"
  }, [_c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('b-button', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")])], 1)]), _vm._v(" "), _c('event-form', {
    attrs: {
      "regions": _vm.regions,
      "types": _vm.types,
      "$v": _vm.$v,
      "disabled": true
    },
    model: {
      value: (_vm.event),
      callback: function($$v) {
        _vm.event = $$v
      },
      expression: "event"
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.events), function(event, index) {
    return _c('tr', {
      class: {
        error: _vm.$v.selectedEvents.$each[index] && _vm.$v.selectedEvents.$each[index].$error
      }
    }, [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (event.isSelected),
        expression: "event.isSelected"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(event.isSelected) ? _vm._i(event.isSelected, null) > -1 : (event.isSelected)
      },
      on: {
        "__c": function($event) {
          var $$a = event.isSelected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (event.isSelected = $$a.concat($$v))
            } else {
              $$i > -1 && (event.isSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            event.isSelected = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(event.region.name) + "\n          ")]), _vm._v(" "), _c('td', [_c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.$v.selectedEvents.$each[index] && !_vm.$v.selectedEvents.$each[index].eventCode.unique),
        expression: "$v.selectedEvents.$each[index] && !$v.selectedEvents.$each[index].eventCode.unique"
      }]
    }, [_c('small', {
      staticClass: "CopyEventToRegions__error"
    }, [_vm._v("\n                Region already has event with code \"" + _vm._s(event.eventCode) + "\"\n              ")])]), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.$v.selectedEvents.$each[index] && _vm.$v.selectedEvents.$each[index].discountedProducts.$error),
        expression: "$v.selectedEvents.$each[index] && $v.selectedEvents.$each[index].discountedProducts.$error"
      }]
    }, [_c('small', {
      staticClass: "CopyEventToRegions__error"
    }, [_vm._v("\n                Some of the discounted products already has an overlapping discount or promotion set in this region.\n              ")])]), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.$v.selectedEvents.$each[index] && _vm.$v.selectedEvents.$each[index].specialPromotions.$error),
        expression: "$v.selectedEvents.$each[index] && $v.selectedEvents.$each[index].specialPromotions.$error"
      }]
    }, [_c('small', {
      staticClass: "CopyEventToRegions__error"
    }, [_vm._v("\n                Some of the special promotions already has an overlapping discount or promotion set in this region.\n              ")])])])])
  }))])])]), _vm._v(" "), _c('loading', {
    attrs: {
      "show": _vm.loading
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('h1', [_vm._v("\n        Copy special price event\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "30px",
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    staticClass: "col"
  }, [_c('h2', [_vm._v("Select the regions you want to copy this event to")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "30px"
    }
  }), _vm._v(" "), _c('th', [_vm._v("Region")]), _vm._v(" "), _c('th')])])
}]}

/***/ }),

/***/ 1707:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-form-fieldset', {
    attrs: {
      "label": "from a list of"
    }
  }, [_c('div', {
    staticClass: "row",
    class: _vm.className
  }, [_c('div', {
    staticClass: "col"
  }, [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("PLU")]), _vm._v(" "), _c('th', [_vm._v("Product")]), _vm._v(" "), (_vm.enableSubsidy) ? _c('th', [_vm._v("Regular price")]) : _vm._e(), _vm._v(" "), (_vm.enableSubsidy) ? _c('th', [_vm._v("Sales price")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_c('b-button', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v("\n              Add\n            ")])], 1)])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.value), function(product, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(product.plu))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(product.name))]), _vm._v(" "), (_vm.enableSubsidy) ? _c('td', [_vm._v(_vm._s(_vm.getBasePrice(product)))]) : _vm._e(), _vm._v(" "), (_vm.enableSubsidy) ? _c('td', [_vm._v(_vm._s(_vm._f("rounded")(_vm.getDiscountedPrice(product))))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_c('b-button', {
      staticClass: "delete",
      attrs: {
        "variant": "secondary"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.remove(product)
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "close"
      }
    })], 1)], 1)])
  }), _vm._v(" "), (_vm.value.length === 0) ? _c('tr', {
    class: {
      'has-danger': !_vm.validator.required
    }
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("Please add products")])]) : _vm._e()], 2)]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validator.required),
      expression: "!validator.required"
    }],
    staticClass: "BuyXFroDiscountPartialView__error"
  }, [_vm._v("\n        Required\n      ")])])])])
},staticRenderFns: []}

/***/ }),

/***/ 1708:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_vm._t("header")], 2)]), _vm._v(" "), _c('tbody', {
    on: {
      "keydown": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38)) { return null; }
        _vm.selectPreviousRow($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40)) { return null; }
        _vm.selectNextRow($event)
      }]
    }
  }, [_vm._t("default", null, {
    activeRow: _vm.activeRow
  })], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 1709:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "SelectableGridCell",
    class: {
      'active': _vm.isActive
    }
  }, [_c('a', {
    ref: "cell",
    attrs: {
      "href": "#"
    },
    on: {
      "focus": _vm.activate,
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 1710:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "BuyXForDiscount"
  }, [_c('b-modal', {
    attrs: {
      "size": "lg",
      "visible": _vm.shown,
      "no-enforce-focus": ""
    },
    on: {
      "hide": _vm.hide,
      "shown": _vm.reset
    }
  }, [_c('div', {
    staticClass: "w-100",
    slot: "modal-title"
  }, [_c('strong', [_vm._v(_vm._s(_vm.name))])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('ul', {
    staticClass: "nav nav-tabs card-header-tabs"
  }, [_c('li', {
    staticClass: "nav-item",
    class: {
      'has-danger': _vm.customerMustBuyError
    }
  }, [_c('a', {
    staticClass: "nav-link tab-0",
    class: {
      active: _vm.tab == 0
    },
    on: {
      "click": function($event) {
        _vm.tab = 0
      }
    }
  }, [_vm._v("Customer must buy")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    class: {
      'has-danger': _vm.customerWillGetError
    }
  }, [_c('a', {
    staticClass: "nav-link tab-1",
    class: {
      active: _vm.tab == 1
    },
    on: {
      "click": function($event) {
        _vm.tab = 1
      }
    }
  }, [_vm._v("Customer will get")])])])]), _vm._v(" "), (_vm.tab === 0) ? _c('div', {
    staticClass: "card-body"
  }, [_c('b-form-fieldset', {
    class: {
      'has-danger': _vm.$v.promotion.requirements.purchasedAmount.$error
    },
    attrs: {
      "label": "at least"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": "items"
    }
  }, [_c('b-form-input', {
    staticClass: "purchasedAmount",
    attrs: {
      "type": "number",
      "min": "0",
      "step": "1",
      "rows": 1
    },
    on: {
      "input": function($event) {
        _vm.$v.promotion.requirements.purchasedAmount.$touch()
      }
    },
    model: {
      value: (_vm.promotion.requirements.purchasedAmount),
      callback: function($$v) {
        _vm.promotion.requirements.purchasedAmount = _vm._n($$v)
      },
      expression: "promotion.requirements.purchasedAmount"
    }
  })], 1), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.promotion.requirements.purchasedAmount.required),
      expression: "!$v.promotion.requirements.purchasedAmount.required"
    }],
    staticClass: "BuyXFroDiscountPartialView__error"
  }, [_vm._v("\n              Required\n            ")])], 1), _vm._v(" "), _c('product-list', {
    attrs: {
      "enableSubsidy": false,
      "class-name": "BuyXForDiscount_purchasedProducts",
      "validator": _vm.$v.promotion.requirements.purchasedProducts
    },
    on: {
      "add": function($event) {
        _vm.purchasedProductSelectShown = true
      },
      "remove": _vm.removePurchasedProduct
    },
    model: {
      value: (_vm.promotion.requirements.purchasedProducts),
      callback: function($$v) {
        _vm.promotion.requirements.purchasedProducts = $$v
      },
      expression: "promotion.requirements.purchasedProducts"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.tab === 1) ? _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-5"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "reward money"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": "CAD"
    }
  }, [_c('b-form-input', {
    staticClass: "rewardMoneyEarned",
    attrs: {
      "type": "number",
      "min": "0",
      "step": "any",
      "rows": 1
    },
    model: {
      value: (_vm.promotion.rewards.rewardMoneyEarnedPerRedemption),
      callback: function($$v) {
        _vm.promotion.rewards.rewardMoneyEarnedPerRedemption = _vm._n($$v)
      },
      expression: "promotion.rewards.rewardMoneyEarnedPerRedemption"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-2 text-center my-4 pt-3"
  }, [_vm._v("\n\t\t\t\tand\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "col-5"
  }, [_c('b-form-fieldset', {
    class: {
      'has-danger': _vm.$v.promotion.rewardsSubsidy.$error
    },
    attrs: {
      "label": "rewards subsidy"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": "CAD"
    }
  }, [_c('b-form-input', {
    staticClass: "rewardsSubsidy",
    attrs: {
      "type": "number",
      "min": "0",
      "step": "any",
      "rows": 1
    },
    on: {
      "input": function($event) {
        _vm.$v.promotion.rewardsSubsidy.$touch()
      }
    },
    model: {
      value: (_vm.promotion.rewardsSubsidy),
      callback: function($$v) {
        _vm.promotion.rewardsSubsidy = _vm._n($$v)
      },
      expression: "promotion.rewardsSubsidy"
    }
  })], 1), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.promotion.rewardsSubsidy.required),
      expression: "!$v.promotion.rewardsSubsidy.required"
    }],
    staticClass: "BuyXFroDiscountPartialView__error"
  }, [_vm._v("\n\t                Required\n\t              ")])], 1)], 1)]), _vm._v(" "), _c('b-form-fieldset', {
    class: {
      'has-danger': _vm.$v.promotion.subsidyPercentageOfDiscount.$error
    },
    attrs: {
      "label": "subsidy percentage of discount"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": "%"
    }
  }, [_c('b-form-input', {
    staticClass: "subsidyPercentageOfDiscount",
    attrs: {
      "type": "number",
      "min": "0",
      "step": "any",
      "rows": 1
    },
    on: {
      "input": function($event) {
        _vm.$v.promotion.subsidyPercentageOfDiscount.$touch()
      }
    },
    model: {
      value: (_vm.promotion.subsidyPercentageOfDiscount),
      callback: function($$v) {
        _vm.promotion.subsidyPercentageOfDiscount = _vm._n($$v)
      },
      expression: "promotion.subsidyPercentageOfDiscount"
    }
  })], 1), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.promotion.subsidyPercentageOfDiscount.required),
      expression: "!$v.promotion.subsidyPercentageOfDiscount.required"
    }],
    staticClass: "SpendXForDiscountPartialView__error"
  }, [_vm._v("\n\t\t  \tRequired\n\t\t    ")])], 1), _vm._v(" "), _c('b-form-fieldset', {
    class: {
      'has-danger': _vm.$v.promotion.rewards.sumOff.$error || _vm.$v.promotion.rewards.percentageOff.$error
    },
    attrs: {
      "label": "for"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-5"
  }, [_c('b-input-group', {
    attrs: {
      "right": "CAD"
    }
  }, [_c('b-form-input', {
    staticClass: "sumOff",
    attrs: {
      "type": "number",
      "min": "0",
      "step": "any",
      "rows": 1,
      "disabled": _vm.disableSumOff
    },
    on: {
      "input": function($event) {
        _vm.$v.promotion.rewards.sumOff.$touch()
      }
    },
    model: {
      value: (_vm.promotion.rewards.sumOff),
      callback: function($$v) {
        _vm.promotion.rewards.sumOff = _vm._n($$v)
      },
      expression: "promotion.rewards.sumOff"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-2 text-center"
  }, [_vm._v("or")]), _vm._v(" "), _c('div', {
    staticClass: "col-5"
  }, [_c('b-input-group', {
    attrs: {
      "right": "%"
    }
  }, [_c('b-form-input', {
    staticClass: "percentageOff",
    attrs: {
      "type": "number",
      "min": "0",
      "step": "any",
      "rows": 1,
      "disabled": _vm.disablePercentageOff
    },
    on: {
      "input": function($event) {
        _vm.$v.promotion.rewards.percentageOff.$touch()
      }
    },
    model: {
      value: (_vm.promotion.rewards.percentageOff),
      callback: function($$v) {
        _vm.promotion.rewards.percentageOff = _vm._n($$v)
      },
      expression: "promotion.rewards.percentageOff"
    }
  })], 1)], 1)]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.promotion.rewards.sumOff.required || !_vm.$v.promotion.rewards.percentageOff.required),
      expression: "!$v.promotion.rewards.sumOff.required || !$v.promotion.rewards.percentageOff.required"
    }],
    staticClass: "BuyXFroDiscountPartialView__error"
  }, [_vm._v("\n\t\t  \tFill one or the other\n\t\t    ")])]), _vm._v(" "), _c('b-form-fieldset', {
    class: {
      'has-danger': _vm.$v.promotion.rewards.awardedAmount.$error
    },
    attrs: {
      "label": "off of"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": "items"
    }
  }, [_c('b-form-input', {
    staticClass: "awardedAmount",
    attrs: {
      "type": "number",
      "min": "0",
      "step": "any",
      "rows": 1
    },
    on: {
      "input": function($event) {
        _vm.$v.promotion.rewards.awardedAmount.$touch()
      }
    },
    model: {
      value: (_vm.promotion.rewards.awardedAmount),
      callback: function($$v) {
        _vm.promotion.rewards.awardedAmount = _vm._n($$v)
      },
      expression: "promotion.rewards.awardedAmount"
    }
  })], 1), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.promotion.rewards.awardedAmount.required),
      expression: "!$v.promotion.rewards.awardedAmount.required"
    }],
    staticClass: "BuyXFroDiscountPartialView__error"
  }, [_vm._v("\n              Required\n            ")])], 1), _vm._v(" "), _c('b-form-fieldset', {
    class: {
      'has-danger': _vm.$v.promotion.rewards.redemptionLimit.$error
    },
    attrs: {
      "label": "up to "
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": "items"
    }
  }, [_c('b-form-input', {
    staticClass: "redemptionLimit",
    attrs: {
      "type": "number",
      "min": "0",
      "step": "any",
      "rows": 1
    },
    on: {
      "input": function($event) {
        _vm.$v.promotion.rewards.redemptionLimit.$touch()
      }
    },
    model: {
      value: (_vm.promotion.rewards.redemptionLimit),
      callback: function($$v) {
        _vm.promotion.rewards.redemptionLimit = _vm._n($$v)
      },
      expression: "promotion.rewards.redemptionLimit"
    }
  })], 1), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.promotion.rewards.redemptionLimit.greater),
      expression: "!$v.promotion.rewards.redemptionLimit.greater"
    }],
    staticClass: "BuyXFroDiscountPartialView__error"
  }, [_vm._v("\n              Redemption limit has to be at least equal to the amount of awarded products\n            ")])], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": ""
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-5"
  }, [_vm._v("\n                once per day:\n                "), _c('b-form-checkbox', {
    staticClass: "oncePerDay",
    attrs: {
      "size": "lg",
      "value": "1",
      "unchecked-value": "0",
      "switch": ""
    },
    model: {
      value: (_vm.promotion.oncePerDay),
      callback: function($$v) {
        _vm.promotion.oncePerDay = $$v
      },
      expression: "promotion.oncePerDay"
    }
  })], 1)])]), _vm._v(" "), _c('product-list', {
    attrs: {
      "customerGroupId": _vm.promotion.customerGroupId,
      "discountedPriceFormula": _vm.discountedPriceFormula,
      "class-name": "BuyXForDiscount_awardedProducts",
      "validator": _vm.$v.promotion.rewards.awardedProducts
    },
    on: {
      "add": function($event) {
        _vm.awardedProductSelectShown = true
      },
      "remove": _vm.removeAwardedProduct
    },
    model: {
      value: (_vm.promotion.rewards.awardedProducts),
      callback: function($$v) {
        _vm.promotion.rewards.awardedProducts = $$v
      },
      expression: "promotion.rewards.awardedProducts"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "w-100",
    slot: "modal-footer"
  }, [_c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.savePromotion()
      }
    }
  }, [_vm._v("Done")])], 1)]), _vm._v(" "), _c('product-select', {
    attrs: {
      "shown": _vm.purchasedProductSelectShown,
      "regionId": _vm.regionId,
      "maxCustomerGroupId": _vm.maxCustomerGroupId
    },
    on: {
      "hide": function($event) {
        _vm.purchasedProductSelectShown = false
      },
      "change": _vm.addPurchasedProduct
    }
  }), _vm._v(" "), _c('product-select', {
    attrs: {
      "shown": _vm.awardedProductSelectShown,
      "regionId": _vm.regionId,
      "maxCustomerGroupId": _vm.maxCustomerGroupId
    },
    on: {
      "hide": function($event) {
        _vm.awardedProductSelectShown = false
      },
      "change": _vm.addAwardedProduct
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1711:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "MultiBuy"
  }, [_c('b-modal', {
    attrs: {
      "size": "lg",
      "visible": _vm.shown,
      "no-enforce-focus": ""
    },
    on: {
      "hide": _vm.hide,
      "shown": _vm.reset
    }
  }, [_c('div', {
    staticClass: "w-100",
    slot: "modal-title"
  }, [_c('strong', [_vm._v(_vm._s(_vm.name))])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('ul', {
    staticClass: "nav nav-tabs card-header-tabs"
  }, [_c('li', {
    staticClass: "nav-item",
    class: {
      'has-danger': _vm.customerMustBuyError
    }
  }, [_c('a', {
    staticClass: "nav-link tab-0",
    class: {
      active: _vm.tab == 0
    },
    on: {
      "click": function($event) {
        _vm.tab = 0
      }
    }
  }, [_vm._v("Customer must buy")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    class: {
      'has-danger': _vm.customerWillGetError
    }
  }, [_c('a', {
    staticClass: "nav-link tab-1",
    class: {
      active: _vm.tab == 1
    },
    on: {
      "click": function($event) {
        _vm.tab = 1
      }
    }
  }, [_vm._v("Customer will get")])])])]), _vm._v(" "), (_vm.tab === 0) ? _c('div', {
    staticClass: "card-body"
  }, [_c('b-form-fieldset', {
    class: {
      'has-danger': _vm.$v.promotion.requirements.purchasedAmount.$error
    },
    attrs: {
      "label": "at least"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": "items"
    }
  }, [_c('b-form-input', {
    staticClass: "purchasedAmount",
    attrs: {
      "type": "number",
      "min": "0",
      "step": "1",
      "rows": 1
    },
    on: {
      "input": function($event) {
        _vm.$v.promotion.requirements.purchasedAmount.$touch()
      }
    },
    model: {
      value: (_vm.promotion.requirements.purchasedAmount),
      callback: function($$v) {
        _vm.promotion.requirements.purchasedAmount = _vm._n($$v)
      },
      expression: "promotion.requirements.purchasedAmount"
    }
  })], 1), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.promotion.requirements.purchasedAmount.required),
      expression: "!$v.promotion.requirements.purchasedAmount.required"
    }],
    staticClass: "MultiBuyPartialView__error"
  }, [_vm._v("Required\n            ")])], 1), _vm._v(" "), _c('b-form-fieldset', {
    class: {
      'has-danger': _vm.$v.promotion.rewards.maxItemsWithSpecialUnitPrice.$error
    },
    attrs: {
      "label": "up to"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": "items"
    }
  }, [_c('b-form-input', {
    staticClass: "maxItemsWithSpecialUnitPrice",
    attrs: {
      "type": "number",
      "min": "0",
      "step": "1",
      "rows": 1
    },
    on: {
      "input": function($event) {
        _vm.$v.promotion.rewards.maxItemsWithSpecialUnitPrice.$touch()
      }
    },
    model: {
      value: (_vm.promotion.rewards.maxItemsWithSpecialUnitPrice),
      callback: function($$v) {
        _vm.promotion.rewards.maxItemsWithSpecialUnitPrice = _vm._n($$v)
      },
      expression: "promotion.rewards.maxItemsWithSpecialUnitPrice"
    }
  })], 1), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.promotion.rewards.maxItemsWithSpecialUnitPrice.greater),
      expression: "!$v.promotion.rewards.maxItemsWithSpecialUnitPrice.greater"
    }],
    staticClass: "MultiBuyPartialView__error"
  }, [_vm._v("\n\t\t\t\tMaximum amount of items has to be greater or equal to minimum amount of items\n            ")])], 1), _vm._v(" "), _c('product-list', {
    attrs: {
      "customerGroupId": _vm.promotion.customerGroupId,
      "discountedPriceFormula": _vm.discountedPriceFormula,
      "class-name": "MultiBuy_purchasedProducts",
      "validator": _vm.$v.promotion.requirements.purchasedProducts
    },
    on: {
      "add": function($event) {
        _vm.purchasedProductSelectShown = true
      },
      "remove": _vm.removePurchasedProduct
    },
    model: {
      value: (_vm.promotion.requirements.purchasedProducts),
      callback: function($$v) {
        _vm.promotion.requirements.purchasedProducts = $$v
      },
      expression: "promotion.requirements.purchasedProducts"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.tab === 1) ? _c('div', {
    staticClass: "card-body"
  }, [_c('b-form-fieldset', {
    class: {
      'has-danger': _vm.$v.promotion.rewards.specialUnitPrice.$error
    },
    attrs: {
      "label": "with price"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": "CAD"
    }
  }, [_c('b-form-input', {
    staticClass: "specialUnitPrice",
    attrs: {
      "type": "number",
      "min": "0",
      "step": "any",
      "rows": 1
    },
    on: {
      "input": function($event) {
        _vm.$v.promotion.rewards.specialUnitPrice.$touch()
      }
    },
    model: {
      value: (_vm.promotion.rewards.specialUnitPrice),
      callback: function($$v) {
        _vm.promotion.rewards.specialUnitPrice = _vm._n($$v)
      },
      expression: "promotion.rewards.specialUnitPrice"
    }
  })], 1), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.promotion.rewards.specialUnitPrice.required),
      expression: "!$v.promotion.rewards.specialUnitPrice.required"
    }],
    staticClass: "MultiBuyPartialView__error"
  }, [_vm._v("\n\t\t\t  Required\n\t\t\t")])], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "and target margin"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": "%"
    }
  }, [_c('b-form-input', {
    staticClass: "targetMargin",
    attrs: {
      "type": "number",
      "min": "0",
      "step": "any",
      "rows": 1
    },
    model: {
      value: (_vm.promotion.targetMargin),
      callback: function($$v) {
        _vm.promotion.targetMargin = _vm._n($$v)
      },
      expression: "promotion.targetMargin"
    }
  })], 1)], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": ""
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-5"
  }, [_vm._v("\n              once per day:\n              "), _c('b-form-checkbox', {
    staticClass: "oncePerDay",
    attrs: {
      "size": "lg",
      "value": "1",
      "unchecked-value": "0",
      "switch": ""
    },
    model: {
      value: (_vm.promotion.oncePerDay),
      callback: function($$v) {
        _vm.promotion.oncePerDay = $$v
      },
      expression: "promotion.oncePerDay"
    }
  })], 1)])])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "w-100",
    slot: "modal-footer"
  }, [_c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.savePromotion()
      }
    }
  }, [_vm._v("Done")])], 1)]), _vm._v(" "), _c('product-select', {
    attrs: {
      "shown": _vm.purchasedProductSelectShown,
      "regionId": _vm.regionId,
      "maxCustomerGroupId": _vm.maxCustomerGroupId
    },
    on: {
      "hide": function($event) {
        _vm.purchasedProductSelectShown = false
      },
      "change": _vm.addPurchasedProduct
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1712:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('editable-grid-row', {
    class: {
      error: _vm.$v.$error
    },
    attrs: {
      "activeRow": _vm.activeRow
    }
  }, [_c('editable-grid-cell', {
    staticClass: "plu",
    attrs: {
      "row": _vm.row,
      "column": 0,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "is-editable": !_vm.discount.priceListProductId,
      "has-danger": !_vm.$v.unique && _vm.$v.$error
    }
  }, [_c('span', {
    attrs: {
      "id": 'uuid' + _vm.discount.uuid
    },
    slot: "edit"
  }, [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "value": _vm.discount.plu,
      "disabled": true,
      "type": "text"
    }
  }), _vm._v(" "), _c('b-input-group-button', [_c('b-button', {
    on: {
      "click": _vm.showProductSelect
    }
  }, [_c('icon', {
    attrs: {
      "name": "pencil"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('span', {
    attrs: {
      "id": 'uuid' + _vm.discount.uuid
    },
    slot: "view"
  }, [_vm._v("\n        " + _vm._s(_vm._f("fixedLength")(_vm.discount.plu, 10)) + "\n      ")]), _vm._v(" "), (!_vm.$v.unique && _vm.$v.$error) ? _c('b-tooltip', {
    attrs: {
      "target": 'uuid' + _vm.discount.uuid,
      "placement": "right"
    }
  }, [_vm._v("\n        Product already has an overlapping discount or promotion set in following events:\n        "), _c('strong', [_vm._v(_vm._s(_vm.$v.$params.unique.matches(_vm.discount)))]), _vm._v("."), _c('br'), _c('br'), _vm._v("\n        Try selecting another product, changing customer group or picking different date range.\n      ")]) : _vm._e()], 1), _vm._v(" "), _c('editable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "column": 1,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "is-editable": !_vm.discount.priceListProductId
    }
  }, [_c('span', {
    slot: "edit"
  }, [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "value": _vm.discount.name,
      "disabled": true,
      "type": "text"
    }
  }), _vm._v(" "), _c('b-input-group-button', [_c('b-button', {
    on: {
      "click": _vm.showProductSelect
    }
  }, [_c('icon', {
    attrs: {
      "name": "pencil"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('span', {
    slot: "view"
  }, [_vm._v("\n        " + _vm._s(_vm._f("fixedLength")(_vm.discount.name, 15)) + "\n      ")])]), _vm._v(" "), _c('editable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "column": 2,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "is-editable": false
    }
  }, [_c('span', {
    slot: "view"
  }, [_vm._v("\n        Discount\n      ")])]), _vm._v(" "), _c('editable-grid-cell', {
    staticClass: "customerGroupId",
    attrs: {
      "row": _vm.row,
      "column": 3,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited
    }
  }, [_c('span', {
    slot: "edit"
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.customerGroups
    },
    model: {
      value: (_vm.discount.customerGroupId),
      callback: function($$v) {
        _vm.discount.customerGroupId = $$v
      },
      expression: "discount.customerGroupId"
    }
  })], 1), _vm._v(" "), _c('span', {
    slot: "view"
  }, [_vm._v("\n        " + _vm._s(_vm.customerGroupName) + "\n      ")])]), _vm._v(" "), _c('editable-grid-cell', {
    staticClass: "startDate",
    attrs: {
      "row": _vm.row,
      "column": 4,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "has-danger": _vm.$v.startDate.$error
    }
  }, [_c('span', {
    slot: "edit"
  }, [_c('flatpickr', {
    attrs: {
      "config": _vm.fpOptions
    },
    on: {
      "input": function($event) {
        _vm.$v.startDate.$touch()
      }
    },
    model: {
      value: (_vm.discount.startDate),
      callback: function($$v) {
        _vm.discount.startDate = $$v
      },
      expression: "discount.startDate"
    }
  })], 1), _vm._v(" "), (_vm.showDates) ? _c('span', {
    slot: "view"
  }, [_vm._v("\n        " + _vm._s(_vm._f("formatDate")(_vm.discount.startDate)) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('editable-grid-cell', {
    staticClass: "endDate",
    attrs: {
      "row": _vm.row,
      "column": 5,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "has-danger": _vm.$v.endDate.$error
    }
  }, [_c('span', {
    slot: "edit"
  }, [_c('flatpickr', {
    attrs: {
      "config": _vm.fpOptions
    },
    on: {
      "input": function($event) {
        _vm.$v.endDate.$touch()
      }
    },
    model: {
      value: (_vm.discount.endDate),
      callback: function($$v) {
        _vm.discount.endDate = $$v
      },
      expression: "discount.endDate"
    }
  })], 1), _vm._v(" "), (_vm.showDates) ? _c('span', {
    slot: "view"
  }, [_vm._v("\n        " + _vm._s(_vm._f("formatDate")(_vm.discount.endDate)) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('editable-grid-cell', {
    staticClass: "page",
    attrs: {
      "row": _vm.row,
      "column": 6,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "has-danger": _vm.$v.page.$error
    }
  }, [_c('span', {
    slot: "edit"
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "step": "1",
      "rows": 1
    },
    on: {
      "input": function($event) {
        _vm.$v.page.$touch()
      }
    },
    model: {
      value: (_vm.discount.page),
      callback: function($$v) {
        _vm.discount.page = _vm._n($$v)
      },
      expression: "discount.page"
    }
  })], 1), _vm._v(" "), _c('span', {
    slot: "view"
  }, [_vm._v("\n        " + _vm._s(_vm.discount.page) + "\n      ")])]), _vm._v(" "), _c('editable-grid-cell', {
    staticClass: "positionOnPage",
    attrs: {
      "row": _vm.row,
      "column": 7,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "has-danger": _vm.$v.positionOnPage.$error
    }
  }, [_c('span', {
    slot: "edit"
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "step": "1",
      "rows": 1
    },
    on: {
      "input": function($event) {
        _vm.$v.positionOnPage.$touch()
      }
    },
    model: {
      value: (_vm.discount.positionOnPage),
      callback: function($$v) {
        _vm.discount.positionOnPage = _vm._n($$v)
      },
      expression: "discount.positionOnPage"
    }
  })], 1), _vm._v(" "), _c('span', {
    slot: "view"
  }, [_vm._v("\n        " + _vm._s(_vm.discount.positionOnPage) + "\n      ")])]), _vm._v(" "), _c('editable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "column": 8,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "is-editable": false
    }
  }, [_c('span', {
    slot: "view"
  }, [_vm._v("\n        " + _vm._s(_vm.basePrice) + "\n      ")])]), _vm._v(" "), _c('editable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "column": 9,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "is-editable": false
    }
  }, [_c('span', {
    slot: "view"
  }, [_vm._v("\n        " + _vm._s(_vm.discount.cost) + "\n      ")])]), _vm._v(" "), _c('editable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "column": 10,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "has-danger": _vm.$v.salesPrice.$error
    }
  }, [_c('span', {
    slot: "edit"
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "step": "any",
      "rows": 1
    },
    on: {
      "input": function($event) {
        _vm.$v.salesPrice.$touch()
      }
    },
    model: {
      value: (_vm.discount.salesPrice),
      callback: function($$v) {
        _vm.discount.salesPrice = _vm._n($$v)
      },
      expression: "discount.salesPrice"
    }
  })], 1), _vm._v(" "), _c('span', {
    slot: "view"
  }, [_vm._v("\n        " + _vm._s(_vm._f("formatPrice")(_vm._f("rounded")(_vm.discount.salesPrice))) + "\n      ")])]), _vm._v(" "), _c('editable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "column": 11,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "is-editable": false
    }
  }, [_c('span', {
    slot: "view"
  }, [_vm._v("\n        " + _vm._s(_vm._f("rounded")(_vm.margin)) + "%\n      ")])]), _vm._v(" "), _c('editable-grid-cell', {
    staticClass: "targetMargin",
    attrs: {
      "row": _vm.row,
      "column": 12,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited
    }
  }, [_c('span', {
    slot: "edit"
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "step": "any",
      "rows": 1
    },
    model: {
      value: (_vm.discount.targetMargin),
      callback: function($$v) {
        _vm.discount.targetMargin = _vm._n($$v)
      },
      expression: "discount.targetMargin"
    }
  })], 1), _vm._v(" "), _c('span', {
    slot: "view"
  }, [_vm._v("\n        " + _vm._s(_vm.discount.targetMargin)), (_vm.discount.targetMargin) ? _c('span', [_vm._v("%")]) : _vm._e()])]), _vm._v(" "), _c('editable-grid-cell', {
    staticClass: "rewardMoneyEarnedPerItem",
    attrs: {
      "row": _vm.row,
      "column": 13,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited
    }
  }, [_c('span', {
    slot: "edit"
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "step": "any",
      "min": "0",
      "rows": 1
    },
    model: {
      value: (_vm.discount.rewardMoneyEarnedPerItem),
      callback: function($$v) {
        _vm.discount.rewardMoneyEarnedPerItem = _vm._n($$v)
      },
      expression: "discount.rewardMoneyEarnedPerItem"
    }
  })], 1), _vm._v(" "), _c('span', {
    slot: "view"
  }, [_vm._v("\n        " + _vm._s(_vm._f("formatPrice")(_vm.discount.rewardMoneyEarnedPerItem)) + "\n      ")])]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_c('b-button', {
    staticClass: "delete",
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.deleteDiscount($event)
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "close"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1729:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_dist_bootstrap_vue__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_dist_bootstrap_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_dist_bootstrap_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_awesome_icons__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_ComponentProvider__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_router__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__router_RouteBuilder__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api_Connection__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__api_Api__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__api_ApiVuePlugin__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ui_LocalizationVuePlugin__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ui_FormattersVuePlugin__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ui_FlatpickrConfigVuePlugin__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__exceptions_RavenErrorHandlerPlugin__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_axios__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_axios__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__store_Store__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_paginate__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_paginate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vue_paginate__);























console.log('SPEA ver: 1.1');


__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_16__exceptions_RavenErrorHandlerPlugin__["a" /* default */], {});

__WEBPACK_IMPORTED_MODULE_7__ui_ComponentProvider__["a" /* default */].register();

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vue_router___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_18_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_17_axios___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_14__ui_FormattersVuePlugin__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vuelidate___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_dist_bootstrap_vue___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_15__ui_FlatpickrConfigVuePlugin__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_20_vue_paginate___default.a);

var connection = new __WEBPACK_IMPORTED_MODULE_10__api_Connection__["a" /* default */](__WEBPACK_IMPORTED_MODULE_17_axios___default.a, "https://p2-plugin13s.erply.com/v1/", "p706n4am3wjnztn663du68ejfbs6tgi8t9kmjkyc", parseInt("1"), "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJ0X2lzcyI6bnVsbCwidF9wdCI6IjUzMzUwNmRkNGRkMDU1YjJlNDJjMTQyMzdjNmZmNzk4NTlkZGYwNDciLCJ0X2lzc3QiOjE1MzA3MTI0NjEsInRfcnQiOiJiMWQxNGYyMmViMjQ0MTFjMmVhZDg1MWNkOTIxMGVmM2U5ZTkzMTFjIiwidF90dGwiOjcyNTgxMDc2MDAsImlkX2VtIjoiaGVuZHJpay5ub2dlbmVAZXJwbHkuY29tIiwiaWRfdGlkIjoiTU0gRm9vZCBNYXJrZXQiLCJ0X3YiOjIsInRfaXR2IjpbXSwicGVybXMiOlsiMDAwMDAwMGItbW1wcm9tb3Rpb25cL2FwaVwvbW1wcmljZWxpc3RcL3JlYWQiLCIwMDAwMDAwYi1tbXByb21vdGlvblwvYXBpXC9tbXByaWNlbGlzdFwvd3JpdGUiLCIwMDAwMDAwYi1tbXByb21vdGlvblwvYXBpXC9tbXByb21vdGlvblwvd3JpdGUiLCIwMDAwMDAwYi1tbXByb21vdGlvblwvYXBpXC9tbXByb21vdGlvblwvcmVhZCIsIjAwMDAwMDBiLW1tcHJvbW90aW9uXC9hcGlcL21tcHJvbW90aW9ucHJvZHVjdHN1YnNpZHlcL3dyaXRlIiwiMDAwMDAwMGItbW1wcm9tb3Rpb25cL2FwaVwvbW1wcm9tb3Rpb25wcm9kdWN0c3Vic2lkeVwvcmVhZCJdfQ.bdt6huSXxfbkvEAhHw3SkzsNSVrR7rbGEhJ9NdpvI3rjPQqs-3T_WpDPuTjq7ePmHkTUSlgdf8AuJUrzNHLHPQBMJ-GBiy_Wn4nE7orRf4WA46RcBGjg-_nV8IOCT6okJV2xOqM6lyTLzmELCyyz61S4cCK4KaYg39VZv2fgcpq0yFlsE0M8O2fdPXKDEcVU4cgg6PWoZPwMByBwxVlSnIupEc3ldwUYwYOrjNQQ96eurqeVawNoq5vhEh1YUWITAopTl7ryX6K0xoeLYq6C-0ISEcvXeLjE-EYMPnHrT6ZDjR-aU4nTfRmwRrIFJXjHnMxA04hrsNzS9r1yj86rUg");

var api = new __WEBPACK_IMPORTED_MODULE_11__api_Api__["a" /* default */](connection, parseInt(3600));
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_12__api_ApiVuePlugin__["a" /* default */], {
  api: api,
  connection: connection
});

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_13__ui_LocalizationVuePlugin__["a" /* default */], { api: api });

var store = new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store(new __WEBPACK_IMPORTED_MODULE_19__store_Store__["a" /* default */]());

var routeBuilder = new __WEBPACK_IMPORTED_MODULE_9__router_RouteBuilder__["a" /* default */](store, connection);
var router = new __WEBPACK_IMPORTED_MODULE_8_vue_router___default.a({
  routes: routeBuilder.build()
});

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;
var root = new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#app',
  store: store,
  router: router,
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_3__App___default.a
  }
});

api.setEventBus(root);
/* harmony default export */ __webpack_exports__["default"] = root;

/***/ }),

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1529)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(1215),
  /* template */
  __webpack_require__(1709),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 181:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(1216),
  /* template */
  __webpack_require__(1694),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 189:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var ProductRepository = function () {
  function ProductRepository(api) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ProductRepository);

    this.api = api;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ProductRepository, [{
    key: 'setMaxCustomerGroupId',
    value: function setMaxCustomerGroupId(maxCustomerGroupId) {
      this.maxCustomerGroupId = maxCustomerGroupId;
    }
  }, {
    key: 'findProductWithBasePricesAndCost',
    value: function findProductWithBasePricesAndCost(searchTerm, regionId, startDate, endDate) {
      var _this = this;

      var params = {
        codePrefix: searchTerm
      };
      return this.api.products.getSome(params, 50).then(function (products) {
        return _this.mapBasePricesAndCostToProducts(products, regionId, _this.maxCustomerGroupId, startDate, endDate);
      });
    }
  }, {
    key: 'getProductsWithBasePricesAndCost',
    value: function getProductsWithBasePricesAndCost(productIds, regionId, startDate, endDate) {
      var _this2 = this;

      return this.api.products.getByIds(productIds).then(function (products) {
        return _this2.mapBasePricesAndCostToProducts(products, regionId, _this2.maxCustomerGroupId, startDate, endDate).then(function (productsWithBasePricesAndCost) {
          return productsWithBasePricesAndCost;
        });
      });
    }
  }, {
    key: 'mapBasePricesAndCostToProducts',
    value: function mapBasePricesAndCostToProducts(products, regionId, customerGroupId, startDate, endDate) {
      var _this3 = this;

      return this.mapRegionalBasePricesToProducts(products, regionId, startDate, endDate).then(function (products) {
        return _this3.mapRegionalCustomerGroupBasePricesToProducts(products, regionId, customerGroupId, startDate, endDate);
      }).then(function (products) {
        return _this3.mapRegionCostToProducts(products, regionId, startDate, endDate);
      });
    }
  }, {
    key: 'mapRegionalBasePricesToProducts',
    value: function mapRegionalBasePricesToProducts(products, regionId, startDate, endDate) {
      var _this4 = this;

      return this.api.regionPriceLists.getBasePriceList(regionId, startDate, endDate).then(function (priceList) {
        return _this4.mapProductRegionBasePriceFromPriceList(products, priceList);
      });
    }
  }, {
    key: 'mapRegionalCustomerGroupBasePricesToProducts',
    value: function mapRegionalCustomerGroupBasePricesToProducts(products, regionId, customerGroupId, startDate, endDate) {
      var _this5 = this;

      return this.api.regionCustomerGroupPriceLists.getBasePriceList(regionId, customerGroupId, startDate, endDate).then(function (priceList) {
        return _this5.mapProductRegionCustomerGroupBasePriceFromPriceList(products, priceList);
      });
    }
  }, {
    key: 'mapRegionCostToProducts',
    value: function mapRegionCostToProducts(products, regionId, startDate, endDate) {
      var _this6 = this;

      return this.api.regionSupplierPriceLists.getAll(regionId, startDate, endDate).then(function (priceLists) {
        return _this6.mapProductRegionCostFromPriceList(products, priceLists);
      });
    }
  }, {
    key: 'mapProductRegionBasePriceFromPriceList',
    value: function mapProductRegionBasePriceFromPriceList(products, priceList) {
      return products.map(function (product) {
        product.regionBasePrice = priceList.pricelistRules.reduce(function (result, pricelistRule) {
          if (pricelistRule.id !== product.productID) {
            return result;
          }

          return pricelistRule.price;
        }, product.price);
        return product;
      });
    }
  }, {
    key: 'mapProductRegionCustomerGroupBasePriceFromPriceList',
    value: function mapProductRegionCustomerGroupBasePriceFromPriceList(products, priceList) {
      return products.map(function (product) {
        product.regionCustomerGroupBasePrice = priceList.pricelistRules.reduce(function (result, pricelistRule) {
          if (pricelistRule.id !== product.productID) {
            return result;
          }

          return pricelistRule.price;
        }, product.regionBasePrice);

        return product;
      });
    }
  }, {
    key: 'mapProductRegionCostFromPriceList',
    value: function mapProductRegionCostFromPriceList(products, priceLists) {
      return products.map(function (product) {

        priceLists.forEach(function (priceList) {

          console.log('mapProductRegionCostFromPriceList priceList:', priceList);
          if (product.regionCost) {} else {

            if (priceList.pricelistRules) {
              product.regionCost = priceList.pricelistRules.reduce(function (result, pricelistRule) {

                if (pricelistRule.productID !== product.productID) {
                  return result;
                }

                return pricelistRule.price;
              }, product.cost);
            } else {
              product.regionCost = product.cost;
            }
          }
        });

        return product;
      });
    }
  }]);

  return ProductRepository;
}();

/* harmony default export */ __webpack_exports__["a"] = ProductRepository;

/***/ }),

/***/ 190:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);





var EventAndProductCombiningTransformer = function () {
  function EventAndProductCombiningTransformer() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, EventAndProductCombiningTransformer);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(EventAndProductCombiningTransformer, [{
    key: 'transform',
    value: function transform(event, foundProducts) {
      event.discountedProducts = this.mapDiscountedProducts(event.discountedProducts, foundProducts);
      event.discountedProducts = this.sortDiscountedProducts(event.discountedProducts);

      event.specialPromotions = this.mapSpecialPromotions(event.specialPromotions, foundProducts);

      return event;
    }
  }, {
    key: 'mapDiscountedProducts',
    value: function mapDiscountedProducts(discountedProducts, foundProducts) {
      var _this = this;

      return discountedProducts.map(function (discountedProduct) {
        var discountedProductChanges = foundProducts.reduce(function (result, foundProduct) {
          if (foundProduct.productID !== discountedProduct.id) {
            return result;
          }

          return _this.getProductChanges(foundProduct);
        }, {});

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(discountedProduct, discountedProductChanges);
      });
    }
  }, {
    key: 'mapSpecialPromotions',
    value: function mapSpecialPromotions(specialPromotions, foundProducts) {
      var _this2 = this;

      return specialPromotions.map(function (promotion) {
        if (promotion.rewards.awardedProducts) {
          console.log('mapSpecialPromotions');
          console.log(promotion);
          promotion.rewards.awardedProducts = _this2.mapAwardedOrPurchasedProducts(promotion.rewards.awardedProducts, foundProducts);
        }

        if (promotion.requirements.purchasedProducts) {
          promotion.requirements.purchasedProducts = _this2.mapAwardedOrPurchasedProducts(promotion.requirements.purchasedProducts, foundProducts);
        }

        return promotion;
      });
    }
  }, {
    key: 'mapAwardedOrPurchasedProducts',
    value: function mapAwardedOrPurchasedProducts(products, foundProducts) {
      var _this3 = this;

      return products.map(function (product) {
        var discountedProductChanges = foundProducts.reduce(function (result, foundProduct) {
          if (foundProduct.productID !== product.productId) {
            return result;
          }

          return _this3.getProductChanges(foundProduct);
        }, {});

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(product, discountedProductChanges);
      });
    }
  }, {
    key: 'getProductChanges',
    value: function getProductChanges(foundProduct) {
      return {
        id: foundProduct.productID,
        name: foundProduct.name,
        plu: foundProduct.code,

        regularPrice: foundProduct.regionBasePrice,
        regularCustomerGroupPrice: foundProduct.regionCustomerGroupBasePrice,
        cost: foundProduct.regionCost
      };
    }
  }, {
    key: 'mapProductChanges',
    value: function mapProductChanges(foundProduct) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, foundProduct, {
        id: foundProduct.productID || foundProduct.id,
        name: foundProduct.name,
        plu: foundProduct.code || foundProduct.plu,

        regularPrice: foundProduct.regionBasePrice || foundProduct.regularPrice,
        regularCustomerGroupPrice: foundProduct.regionCustomerGroupBasePrice || foundProduct.regularCustomerGroupPrice,
        cost: foundProduct.regionCost || foundProduct.cost
      });
    }
  }, {
    key: 'sortDiscountedProducts',
    value: function sortDiscountedProducts(discountedProducts) {
      return discountedProducts.sort(function (discountedProductA, discountedProductB) {
        if (discountedProductA.plu < discountedProductB.plu) {
          return -1;
        }
        if (discountedProductA.plu > discountedProductB.plu) {
          return 1;
        }
        return 0;
      });
    }
  }]);

  return EventAndProductCombiningTransformer;
}();

/* harmony default export */ __webpack_exports__["a"] = EventAndProductCombiningTransformer;

/***/ }),

/***/ 191:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(1261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);




var PriceListsAndPromotionsToEventTransformer = function () {
  function PriceListsAndPromotionsToEventTransformer() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, PriceListsAndPromotionsToEventTransformer);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(PriceListsAndPromotionsToEventTransformer, [{
    key: 'checkForNull',
    value: function checkForNull(value) {
      return value && value != 0;
    }
  }, {
    key: 'transform',
    value: function transform(eventMaster, products, campaigns) {
      var event = {
        id: eventMaster.id,
        eventCode: eventMaster.eventCode,
        name: eventMaster.name,
        regionId: eventMaster.regionId,
        startDate: eventMaster.startDate,
        endDate: eventMaster.endDate,
        notes: eventMaster.notes,
        type: eventMaster.type,
        isConfirmed: eventMaster.active,
        isLocked: eventMaster.locked,
        discountedProducts: [],
        specialPromotions: [],
        deletedDiscountsAndPromotions: []
      };

      if (!products) {
        return event;
      }

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(products), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var product = _step.value;

          event.discountedProducts.push({
            id: product.productId,
            customerGroupId: product.customerGroupId ? parseInt(product.customerGroupId) : 0,
            salesPrice: product.price,
            startDate: product.startDate,
            endDate: product.endDate,
            page: product.page,
            positionOnPage: product.positionOnPage,
            priceListProductId: product.priceListProductId,
            targetMargin: product.targetMargin,
            rewardsSubsidy: product.rewardsSubsidy,
            rewardMoneyEarnedPerItem: product.rewardMoneyEarnedPerItem,
            hasBeenEdited: false
          });
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(campaigns), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var promotion = _step2.value;

          var rewards = {
            redemptionLimit: promotion.rewards.redemptionLimit === null ? promotion.rewards.salesRedemptionLimit : promotion.rewards.redemptionLimit,
            salesRedemptionLimit: promotion.rewards.salesRedemptionLimit,
            maxItemsWithSpecialUnitPrice: promotion.rewards.maxItemsWithSpecialUnitPrice,

            specialUnitPrice: this.checkForNull(promotion.rewards.specialUnitPrice) ? parseFloat(promotion.rewards.specialUnitPrice) : null,

            rewardMoneyEarnedPerItem: promotion.rewards.rewardMoneyEarnedPerItem,
            rewardMoneyEarnedPerRedemption: promotion.rewards.rewardMoneyEarnedPerRedemption,
            awardedAmount: parseInt(promotion.rewards.awardedAmount),
            awardedProducts: promotion.rewards.awardedProducts,

            sumOff: this.checkForNull(promotion.rewards.sumOff) ? parseFloat(promotion.rewards.sumOff) : null,
            percentageOff: this.checkForNull(promotion.rewards.percentageOff) ? parseFloat(promotion.rewards.percentageOff) : null,
            sumOffMatchingItems: this.checkForNull(promotion.rewards.sumOffMatchingItems) ? parseFloat(promotion.rewards.sumOffMatchingItems) : null,
            percentageOffMatchingItems: this.checkForNull(promotion.rewards.percentageOffMatchingItems) ? parseFloat(promotion.rewards.percentageOffMatchingItems) : null

          };

          if (promotion.type === 'MULTIBUY_X_FOR_DISCOUNT' || promotion.type === 'MULTIBUY_GET_PERCENTAGE_OFF' || promotion.type === 'MULTIBUY_GET_SUM_OFF') {
            rewards.sumOff = rewards.sumOffMatchingItems ? parseFloat(rewards.sumOffMatchingItems) : rewards.sumOff;
            rewards.percentageOff = rewards.percentageOffMatchingItems ? parseFloat(rewards.percentageOffMatchingItems) : rewards.percentageOff;

            rewards.sumOffMatchingItems = rewards.sumOff;
            rewards.percentageOffMatchingItems = rewards.percentageOff;
          }

          event.specialPromotions.push({
            campaignId: promotion.campaignId,
            id: promotion.campaignId,
            eventId: promotion.eventId,
            name: promotion.name,
            startDate: promotion.startDate,
            endDate: promotion.endDate,
            customerGroupId: promotion.customerGroupId ? parseInt(promotion.customerGroupId) : 0,
            page: promotion.page,
            positionOnPage: promotion.positionOnPage,
            type: promotion.type,
            reasonId: promotion.reasonId,
            oncePerDay: promotion.oncePerDay,
            targetMargin: promotion.targetMargin,
            subsidyPercentageOfDiscount: promotion.subsidyPercentageOfDiscount,
            rewardsSubsidy: promotion.rewardsSubsidy,
            requirements: {
              purchaseTotalValue: parseFloat(promotion.requirements.purchaseTotalValue),
              purchasedAmount: parseInt(promotion.requirements.purchasedAmount),
              purchasedProducts: promotion.requirements.purchasedProducts
            },
            rewards: rewards,
            hasBeenEdited: false
          });
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      console.log('transform event');
      console.log(event);
      return event;
    }
  }]);

  return PriceListsAndPromotionsToEventTransformer;
}();

/* harmony default export */ __webpack_exports__["a"] = PriceListsAndPromotionsToEventTransformer;

/***/ }),

/***/ 192:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);


/* harmony default export */ __webpack_exports__["a"] = function (startFieldPath, endFieldPath) {
  return function (value) {
    var startValue = __WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(this, startFieldPath);
    var endValue = __WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(this, endFieldPath);

    return startValue <= value && value <= endValue;
  };
};

/***/ }),

/***/ 193:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);


/* harmony default export */ __webpack_exports__["a"] = function (siblingPath, startFieldName, endFieldName, siblingCompareCallback) {
  return function (value, parentVm) {
    var siblings = __WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(this, siblingPath);
    var startValue = parentVm[startFieldName];
    var endValue = parentVm[endFieldName];

    var similarSiblings = siblings.filter(function (sibling) {
      if (sibling === parentVm) {
        return false;
      }

      return siblingCompareCallback(parentVm, sibling);
    });

    var siblingRanges = similarSiblings.map(function (sibling) {
      return {
        startValue: sibling[startFieldName],
        endValue: sibling[endFieldName]
      };
    });

    var overlap = siblingRanges.reduce(function (result, siblingRange) {
      var isBefore = siblingRange.startValue < startValue && siblingRange.endValue < startValue;
      var isAfter = endValue < siblingRange.startValue && endValue < siblingRange.endValue;

      return result || !(isBefore || isAfter);
    }, false);

    return !overlap;
  };
};

/***/ }),

/***/ 382:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(1209),
  /* template */
  __webpack_require__(1700),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 383:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(1214),
  /* template */
  __webpack_require__(1708),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 387:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Service_Campaigns__ = __webpack_require__(1217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Service_Customers__ = __webpack_require__(1218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Service_PriceLists__ = __webpack_require__(1220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Service_Products__ = __webpack_require__(1221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Service_RegionCustomerGroupPriceLists__ = __webpack_require__(1222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Service_RegionPriceLists__ = __webpack_require__(1223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Service_RegionSupplierPriceLists__ = __webpack_require__(1224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Service_StoreRegions__ = __webpack_require__(1225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Service_Events__ = __webpack_require__(1219);












var Api = function () {
  function Api(connection) {
    var cacheTimeNormal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3600;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Api);

    this.storeRegions = new __WEBPACK_IMPORTED_MODULE_9__Service_StoreRegions__["a" /* default */](connection, cacheTimeNormal);
    this.customers = new __WEBPACK_IMPORTED_MODULE_3__Service_Customers__["a" /* default */](connection, cacheTimeNormal);
    this.products = new __WEBPACK_IMPORTED_MODULE_5__Service_Products__["a" /* default */](connection, cacheTimeNormal);

    this.campaigns = new __WEBPACK_IMPORTED_MODULE_2__Service_Campaigns__["a" /* default */](connection, cacheTimeNormal);
    this.priceLists = new __WEBPACK_IMPORTED_MODULE_4__Service_PriceLists__["a" /* default */](connection, this.productsInPriceList, cacheTimeNormal);
    this.events = new __WEBPACK_IMPORTED_MODULE_10__Service_Events__["a" /* default */](connection, cacheTimeNormal);

    this.regionCustomerGroupPriceLists = new __WEBPACK_IMPORTED_MODULE_6__Service_RegionCustomerGroupPriceLists__["a" /* default */](connection, this.storeRegions, this.priceLists, cacheTimeNormal);

    this.regionPriceLists = new __WEBPACK_IMPORTED_MODULE_7__Service_RegionPriceLists__["a" /* default */](connection, this.storeRegions, this.priceLists, cacheTimeNormal);

    this.regionSupplierPriceLists = new __WEBPACK_IMPORTED_MODULE_8__Service_RegionSupplierPriceLists__["a" /* default */](connection, cacheTimeNormal);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Api, [{
    key: 'setEventBus',
    value: function setEventBus(eventBus) {
      this.events.setEventBus(eventBus);
      this.campaigns.setEventBus(eventBus);
      this.customers.setEventBus(eventBus);
      this.priceLists.setEventBus(eventBus);
      this.products.setEventBus(eventBus);
      this.regionCustomerGroupPriceLists.setEventBus(eventBus);
      this.regionPriceLists.setEventBus(eventBus);
      this.regionSupplierPriceLists.setEventBus(eventBus);
      this.storeRegions.setEventBus(eventBus);
    }
  }]);

  return Api;
}();

/* harmony default export */ __webpack_exports__["a"] = Api;

/***/ }),

/***/ 388:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var ApiVuePlugin = function () {
  function ApiVuePlugin() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ApiVuePlugin);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ApiVuePlugin, null, [{
    key: "install",
    value: function install(Vue, options) {
      Vue.prototype.$api = options.api;
      Vue.prototype.$apiConnection = options.connection;
    }
  }]);

  return ApiVuePlugin;
}();

/* harmony default export */ __webpack_exports__["a"] = ApiVuePlugin;

/***/ }),

/***/ 389:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_querystring__ = __webpack_require__(1623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_querystring__);







var Connection = function () {
  function Connection(httpClient, apiUrl) {
    var partnerKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var debugLogEnabled = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var promotionRuleToken = arguments[4];

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Connection);

    this.httpClient = httpClient;
    this.apiUrl = apiUrl;
    this.clientCode = '';
    this.sessionKey = '';
    this.partnerKey = partnerKey;
    this.promotionRuleToken = promotionRuleToken;
    this.maxRequestsPerSecond = 5;
    this.nextRequestEarliestStart = Date.now();

    if (debugLogEnabled) {
      this.setLogger(console);
    }
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Connection, [{
    key: 'setLogger',
    value: function setLogger(logger) {
      this.logger = logger;
    }
  }, {
    key: 'log',
    value: function log(toLog) {
      if (this.logger) {
        this.logger.log(toLog);
      }
    }
  }, {
    key: 'openSession',
    value: function openSession(clientCode, sessionKey) {
      this.clientCode = clientCode;
      this.sessionKey = sessionKey;
    }
  }, {
    key: 'url',
    value: function url() {
      if (this.clientCode === '') {
        throw Error('Session not opened');
      }

      return this.apiUrl;
    }
  }, {
    key: 'addAuthParams',
    value: function addAuthParams(data) {
      data.partnerKey = this.partnerKey;

      if (data.request === 'verifyUser') {
        return data;
      }

      if (this.sessionKey === '') {
        throw Error('Session not opened');
      }

      data.sessionKey = this.sessionKey;
      data.clientCode = this.clientCode;

      return data;
    }
  }, {
    key: 'scheduleRequest',
    value: function scheduleRequest(request) {
      var minRequestInterval = 1000 / this.maxRequestsPerSecond;
      if (this.nextRequestEarliestStart <= Date.now()) {
        this.nextRequestEarliestStart = Date.now() + minRequestInterval;
        return request();
      }

      var timeout = this.nextRequestEarliestStart - Date.now();

      var promise = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
        setTimeout(function () {
          return resolve(request());
        }, timeout);
      });

      this.nextRequestEarliestStart = this.nextRequestEarliestStart + minRequestInterval;
      return promise;
    }
  }, {
    key: 'getSpeaHeaders',
    value: function getSpeaHeaders() {
      return {
        'Erply-Api-Clientcode': this.clientCode,
        'Erply-Api-Sessionkey': this.sessionKey,
        'Erply-Api-Partnerkey': this.partnerKey,
        'PromotionRule-Api-Token': this.promotionRuleToken,
        'Content-Type': 'application/json'
      };
    }
  }, {
    key: 'get',
    value: function get(request, parameters) {
      var _this = this;

      try {
        this.log('Sending get request to ' + this.url());
        this.log(parameters);
        parameters = __WEBPACK_IMPORTED_MODULE_5_querystring___default.a.stringify(parameters);

        var options = {};
        options.headers = this.getSpeaHeaders();

        request = parameters ? request + '?' + parameters : request;
        return this.scheduleRequest(function () {
          return _this.httpClient.get(_this.url() + request, options);
        }).then(function (response) {
          _this.log('Got get response');
          _this.log(response);

          return response;
        }).then(function (response) {
          return _this.assertResponseSuccess(response);
        }).catch(function (error) {
          _this.log('Got error during get request');
          _this.log(error);

          return null;
        });
      } catch (error) {
        this.log('Got error during get request');
        this.log(error);

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(error);
      }
    }
  }, {
    key: 'requestSpea',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(request, data) {
        var _this2 = this;

        var options;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                this.log('Sending request to SPEA to ' + this.url());
                this.log(data);

                options = {};

                options.headers = this.getSpeaHeaders();

                return _context.abrupt('return', this.scheduleRequest(function () {
                  if (data.mode === 'post') {
                    return _this2.httpClient.post(_this2.url() + request, data, options);
                  } else if (data.mode === 'patch') {
                    return _this2.httpClient.patch(_this2.url() + request, data, options);
                  } else if (data.mode === 'delete') {
                    return _this2.httpClient.delete(_this2.url() + request, options);
                  }
                }).then(function (response) {
                  _this2.log('Got response from SPEA');
                  _this2.log(response);

                  return response;
                }).then(function (response) {
                  return _this2.assertResponseSuccess(response);
                }).catch(function (error) {
                  _this2.log('Got error during SPEA request');
                  _this2.log(error);

                  return null;
                }));

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](0);

                this.log('Got error during posting');
                this.log(_context.t0);

                return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(_context.t0));

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 8]]);
      }));

      function requestSpea(_x3, _x4) {
        return _ref.apply(this, arguments);
      }

      return requestSpea;
    }()
  }, {
    key: 'postErply',
    value: function postErply(data) {
      var _this3 = this;

      try {
        data = this.addAuthParams(data);
        data = __WEBPACK_IMPORTED_MODULE_5_querystring___default.a.stringify(data);

        var urlToErply = 'https://' + this.clientCode + '.erply.com/api/';

        this.log('Sending post request to Erply to ' + urlToErply);
        this.log(data);

        var options = {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        };

        return this.scheduleRequest(function () {
          return _this3.httpClient.post(urlToErply, data, options);
        }).then(function (response) {
          _this3.log('Got post response');
          _this3.log(response);

          return response;
        }).then(function (response) {
          return _this3.assertResponseSuccess(response);
        });
      } catch (error) {
        this.log('Got error during posting');
        this.log(error);

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(error);
      }
    }
  }, {
    key: 'assertResponseSuccess',
    value: function assertResponseSuccess(response) {
      if (typeof response.status === 'undefined' || typeof response.statusText === 'undefined') {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(response);
      } else if (response.status < 200 || response.status >= 400) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(response);
      }

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(response);
    }
  }]);

  return Connection;
}();

/* harmony default export */ __webpack_exports__["a"] = Connection;

/***/ }),

/***/ 390:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var RavenErrorHandlerPlugin = function () {
  function RavenErrorHandlerPlugin() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, RavenErrorHandlerPlugin);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(RavenErrorHandlerPlugin, null, [{
    key: "install",
    value: function install(Vue, options) {
      Vue.mixin({
        methods: {
          $reportError: function $reportError(error) {
            console.log(error);
          }
        }
      });
    }
  }]);

  return RavenErrorHandlerPlugin;
}();

/* harmony default export */ __webpack_exports__["a"] = RavenErrorHandlerPlugin;

/***/ }),

/***/ 391:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_EventList_EventList_vue__ = __webpack_require__(1656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_EventList_EventList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_EventList_EventList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_AddEvent_AddEvent_vue__ = __webpack_require__(1637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_AddEvent_AddEvent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_AddEvent_AddEvent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_CopyEvent_CopyEvent_vue__ = __webpack_require__(1638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_CopyEvent_CopyEvent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_CopyEvent_CopyEvent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_CopyEventToRegions_CopyEventToRegions_vue__ = __webpack_require__(1642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_CopyEventToRegions_CopyEventToRegions_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_CopyEventToRegions_CopyEventToRegions_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_EditEvent_EditEvent_vue__ = __webpack_require__(1649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_EditEvent_EditEvent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__views_EditEvent_EditEvent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_ViewEvent_ViewEvent_vue__ = __webpack_require__(1661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_ViewEvent_ViewEvent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__views_ViewEvent_ViewEvent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_Error_AccessDenied_vue__ = __webpack_require__(1653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_Error_AccessDenied_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__views_Error_AccessDenied_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_Error_GeneralError_vue__ = __webpack_require__(1654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_Error_GeneralError_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__views_Error_GeneralError_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_Error_404_vue__ = __webpack_require__(1652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_Error_404_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__views_Error_404_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_Error_TemporaryProblem_vue__ = __webpack_require__(1655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_Error_TemporaryProblem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__views_Error_TemporaryProblem_vue__);













var RouteBuilder = function () {
  function RouteBuilder(store, apiConnection) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, RouteBuilder);

    this.store = store;
    this.apiConnection = apiConnection;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(RouteBuilder, [{
    key: 'build',
    value: function build() {
      var _this = this;

      return [{
        path: '/auth/:clientCode/:userId/:sessionKey',
        beforeEnter: function beforeEnter(to, from, next) {
          _this.apiConnection.openSession(to.params.clientCode, to.params.sessionKey);
          _this.store.commit('setUserId', parseInt(to.params.userId));
          _this.store.commit('setClientCode', to.params.clientCode);

          next('/');
        }
      }, {
        path: '/',
        name: 'Event list',
        component: __WEBPACK_IMPORTED_MODULE_2__views_EventList_EventList_vue___default.a
      }, {
        path: '/add-event',
        name: 'Add event',
        component: __WEBPACK_IMPORTED_MODULE_3__views_AddEvent_AddEvent_vue___default.a
      }, {
        path: '/copy-event/:id',
        name: 'Copy event',
        component: __WEBPACK_IMPORTED_MODULE_4__views_CopyEvent_CopyEvent_vue___default.a
      }, {
        path: '/copy-event-to-regions/:id',
        name: 'Copy event to regions',
        component: __WEBPACK_IMPORTED_MODULE_5__views_CopyEventToRegions_CopyEventToRegions_vue___default.a
      }, {
        path: '/edit-event/:id',
        name: 'Edit event',
        component: __WEBPACK_IMPORTED_MODULE_6__views_EditEvent_EditEvent_vue___default.a
      }, {
        path: '/view-event/:id',
        name: 'View event',
        component: __WEBPACK_IMPORTED_MODULE_7__views_ViewEvent_ViewEvent_vue___default.a
      }, {
        path: '/access-denied',
        component: __WEBPACK_IMPORTED_MODULE_8__views_Error_AccessDenied_vue___default.a
      }, {
        path: '/temporary-problem',
        component: __WEBPACK_IMPORTED_MODULE_11__views_Error_TemporaryProblem_vue___default.a
      }, {
        path: '/error',
        component: __WEBPACK_IMPORTED_MODULE_9__views_Error_GeneralError_vue___default.a
      }, {
        path: '*',
        component: __WEBPACK_IMPORTED_MODULE_10__views_Error_404_vue___default.a
      }];
    }
  }]);

  return RouteBuilder;
}();

/* harmony default export */ __webpack_exports__["a"] = RouteBuilder;

/***/ }),

/***/ 392:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var Store = function Store() {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Store);

  this.state = {
    filter: {
      eventCode: '',
      startDateFrom: '',
      startDateTo: '',
      endDateFrom: '',
      endDateTo: '',
      region: '',
      status: '',
      type: ''
    },

    userId: null,
    clientCode: null
  };
  this.mutations = {
    setFilter: function setFilter(state, filter) {
      state.filter = filter;
    },
    setUserId: function setUserId(state, userId) {
      state.userId = userId;
    },
    setClientCode: function setClientCode(state, clientCode) {
      state.clientCode = clientCode;
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = Store;

/***/ }),

/***/ 393:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_awesome_components_Icon_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_flatpickr_component__ = __webpack_require__(1634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_flatpickr_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_flatpickr_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Loading_vue__ = __webpack_require__(1635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Loading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Loading_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Pagination_vue__ = __webpack_require__(1636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Pagination_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Pagination_vue__);









var ComponentProvider = function () {
  function ComponentProvider() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ComponentProvider);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ComponentProvider, null, [{
    key: 'register',
    value: function register() {
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('icon', __WEBPACK_IMPORTED_MODULE_3_vue_awesome_components_Icon_vue___default.a);
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('flatpickr', __WEBPACK_IMPORTED_MODULE_4_vue_flatpickr_component___default.a);
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('loading', __WEBPACK_IMPORTED_MODULE_5__components_Loading_vue___default.a);
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('pagination', __WEBPACK_IMPORTED_MODULE_6__components_Pagination_vue___default.a);
    }
  }]);

  return ComponentProvider;
}();

/* harmony default export */ __webpack_exports__["a"] = ComponentProvider;

/***/ }),

/***/ 394:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var FlatpickrConfigVuePlugin = function () {
  function FlatpickrConfigVuePlugin() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, FlatpickrConfigVuePlugin);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(FlatpickrConfigVuePlugin, null, [{
    key: "install",
    value: function install(Vue) {
      Vue.mixin({
        created: function created() {
          this.fpOptions = {
            altFormat: this.dateFormat,
            altInput: true,
            allowInput: true
          };
        }
      });
    }
  }]);

  return FlatpickrConfigVuePlugin;
}();

/* harmony default export */ __webpack_exports__["a"] = FlatpickrConfigVuePlugin;

/***/ }),

/***/ 395:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var FormattersVuePlugin = function () {
  function FormattersVuePlugin() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, FormattersVuePlugin);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(FormattersVuePlugin, null, [{
    key: 'install',
    value: function install(Vue) {
      Vue.mixin({
        filters: {
          fixedLength: function fixedLength(value, maxLength) {
            if (!value) {
              return '';
            }

            if (value.length > maxLength) {
              return value.slice(0, maxLength - 3) + '...';
            } else {
              return value;
            }
          },

          rounded: function rounded(value) {
            var decimalPlaces = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

            return Math.round(parseFloat(value) * Math.pow(10, decimalPlaces)) / Math.pow(10, decimalPlaces);
          },
          formatPrice: function formatPrice(value) {
            if (!value) return '0.00';
            value = value.toString();
            if (!value.includes('.')) return value;
            var trimmedAmount = 2 - value.toString().split('.')[1].length;
            trimmedAmount = trimmedAmount >= 0 ? trimmedAmount : 0;
            return value.toString() + '0'.repeat(trimmedAmount);
          }
        }
      });
    }
  }]);

  return FormattersVuePlugin;
}();

/* harmony default export */ __webpack_exports__["a"] = FormattersVuePlugin;

/***/ }),

/***/ 396:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_AccountConfigRepository__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);





var LocalizationVuePlugin = function () {
  function LocalizationVuePlugin() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, LocalizationVuePlugin);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(LocalizationVuePlugin, null, [{
    key: 'install',
    value: function install(Vue, options) {
      var config = new __WEBPACK_IMPORTED_MODULE_2__model_AccountConfigRepository__["a" /* default */](options.api);

      Vue.mixin({
        filters: {
          formatDate: function formatDate(value) {
            if (!value) {
              return '';
            }

            return __WEBPACK_IMPORTED_MODULE_3_moment___default()(value).format(config.getMomentDateFormat());
          }
        },

        computed: {
          dateFormat: function dateFormat() {
            return config.getDateFormat();
          }
        }
      });
    }
  }]);

  return LocalizationVuePlugin;
}();

/* harmony default export */ __webpack_exports__["a"] = LocalizationVuePlugin;

/***/ }),

/***/ 40:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_get__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_get__);





var Service = function () {
  function Service(connection) {
    var cacheTimeNormal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 600;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Service);

    this.connection = connection;
    this.cacheTimeNormal = cacheTimeNormal;
    this.eventBus = null;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Service, [{
    key: 'setEventBus',
    value: function setEventBus(eventBus) {
      this.eventBus = eventBus;
    }
  }, {
    key: 'emitTemporaryProblemEvent',
    value: function emitTemporaryProblemEvent() {
      if (this.eventBus !== null) {
        this.eventBus.$emit('temporary-problem');
      }
    }
  }, {
    key: 'emitErrorEvent',
    value: function emitErrorEvent() {
      if (this.eventBus !== null) {
        this.eventBus.$emit('error');
      }
    }
  }, {
    key: 'emitUnauthorizedEvent',
    value: function emitUnauthorizedEvent() {
      if (this.eventBus !== null) {
        this.eventBus.$emit('unauthorized');
      }
    }
  }, {
    key: 'handleEmptyResponse',
    value: function handleEmptyResponse() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
    }
  }, {
    key: 'handleSingleRecordResponse',
    value: function handleSingleRecordResponse(response) {

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response.data.records[0]);
    }
  }, {
    key: 'handleSingleRecordResponseWithDefault',
    value: function handleSingleRecordResponseWithDefault(response, defaultRecord) {

      if (response.data.records.length === 0) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(defaultRecord);
      }

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response.data.records[0]);
    }
  }, {
    key: 'handleMultiRecordResponse',
    value: function handleMultiRecordResponse(response) {
      var returnRaw = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      console.log('handleMultiRecordResponse');
      console.log(response);
      if (__WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(response, 'code') === '0' || __WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(response, 'status') === 200 || __WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(response, 'data.status.errorCode') === '0') {

        if (returnRaw) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response.data.records);
        }
      }

      return this.handleErrorResponse(response);
    }
  }, {
    key: 'handlePossibleDuplicateErrorResponse',
    value: function handlePossibleDuplicateErrorResponse(response) {
      console.log('handlePossibleDuplicateErrorResponse');
      console.log(response);
      if (__WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(response, 'data.status.errorCode') === '1026') {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
      }

      return this.handleErrorResponse(response);
    }
  }, {
    key: 'handleErrorResponse',
    value: function handleErrorResponse(response) {
      console.log('handleErrorResponse');
      console.log(response);
      console.log('end response');

      if (typeof response === 'undefined' || !response) {
        return this.emitErrorEvent();
      }
      if (typeof response.message !== 'undefined' && response.message === 'Session not opened' || response.message === 'Cannot read property \'length\' of undefined') {
        this.emitUnauthorizedEvent();
      } else {
        if (typeof response.data !== 'undefined' && typeof response.data.status !== 'undefined' && typeof response.data.status.errorCode !== 'undefined') {
          if (response.data.status.errorCode === 1002) {
            this.emitTemporaryProblemEvent();
          } else if (response.data.status.errorCode === 1054 || response.data.status.errorCode === 1055 || response.data.status.errorCode === 1056 || response.data.status.errorCode === 1009) {
            this.emitUnauthorizedEvent();
          } else {
            this.emitErrorEvent();
          }
        } else {
          this.emitErrorEvent();
        }
      }

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
    }
  }, {
    key: 'fetchAllRecords',
    value: function fetchAllRecords(request, params) {
      var recordsOnPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
      var recursive = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

      var pageNo = 1;

      if (request) {
        return this.fetchRecursive(request, params, recordsOnPage, pageNo, recursive);
      } else {
        return this.fetchRecursivefromErply(params, recordsOnPage, pageNo, recursive);
      }
    }
  }, {
    key: 'fetchRecursive',
    value: function fetchRecursive(request, params, recordsOnPage, pageNo, recursive) {
      var _this = this;

      params.limit = recordsOnPage;
      params.page = pageNo;

      return this.connection.get(request, params).then(function (response) {
        return _this.handleMultiRecordResponse(response);
      }).then(function (records) {
        if (records.length >= recordsOnPage && recursive) {
          return _this.fetchRecursive(request, params, recordsOnPage, pageNo + 1, recursive).then(function (nextRecords) {
            return records.concat(nextRecords);
          });
        } else {
          return records;
        }
      });
    }
  }, {
    key: 'fetchRecursivefromErply',
    value: function fetchRecursivefromErply(params, recordsOnPage, pageNo) {
      var _this2 = this;

      params.recordsOnPage = recordsOnPage;
      params.pageNo = pageNo;

      return this.connection.postErply(params).then(function (response) {
        return _this2.handleMultiRecordResponse(response);
      }).then(function (records) {
        if (records.length >= recordsOnPage) {
          return _this2.fetchRecursivefromErply(params, recordsOnPage, pageNo + 1).then(function (nextRecords) {
            return records.concat(nextRecords);
          });
        } else {
          return records;
        }
      });
    }
  }]);

  return Service;
}();

/* harmony default export */ __webpack_exports__["a"] = Service;

/***/ }),

/***/ 400:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1527)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(1208),
  /* template */
  __webpack_require__(1704),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 55:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var AccountConfigRepository = function () {
  function AccountConfigRepository(api) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, AccountConfigRepository);

    this.api = api;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(AccountConfigRepository, [{
    key: 'getDateFormat',
    value: function getDateFormat() {
      return 'm/d/Y';
    }
  }, {
    key: 'getMomentDateFormat',
    value: function getMomentDateFormat() {
      return 'MM/DD/YYYY';
    }
  }, {
    key: 'getCustomerGroupIds',
    value: function getCustomerGroupIds() {
      return this.api.customers.getGroups().then(function (groups) {

        var ret = {
          nonMemberGroupId: 0,
          emailMemberGroupId: 0,
          nonEmailMemberGroupId: 0,
          maxGroupId: 0
        };

        console.log("getMaxCustomerGroupId request", groups);

        groups.forEach(function (group) {
          switch (group.name) {
            case 'Non-Member':
              ret.nonMemberGroupId = parseInt(group.customerGroupID);
              break;

            case 'Email Member':
              ret.emailMemberGroupId = parseInt(group.customerGroupID);
              break;

            case 'Non-Email Member':
              ret.nonEmailMemberGroupId = parseInt(group.customerGroupID);
              break;

            default:
              break;
          }
        });

        ret.maxGroupId = ret.emailMemberGroupId;
        return ret;
      });
    }
  }]);

  return AccountConfigRepository;
}();

/* harmony default export */ __webpack_exports__["a"] = AccountConfigRepository;

/***/ }),

/***/ 56:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);


/* harmony default export */ __webpack_exports__["a"] = function (otherField) {
  return function (value, parentVm) {
    var compareTo = '';
    if (typeof otherField === 'string') {
      compareTo = typeof parentVm[otherField] !== 'undefined' ? parentVm[otherField] : __WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(this, otherField);
    } else {
      compareTo = otherField;
    }

    if (value === null || value === undefined || value === '') {
      return true;
    }

    if (compareTo === null || compareTo === undefined || compareTo === '') {
      return true;
    }

    return value >= compareTo;
  };
};

/***/ }),

/***/ 72:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify__ = __webpack_require__(1262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__transformers_PriceListsAndPromotionsToEventTransformer__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__transformers_PriceListsAndPromotionsToEventsTransformer__ = __webpack_require__(1228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__transformers_EventToProductIdsTransformer__ = __webpack_require__(1227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__transformers_EventAndProductCombiningTransformer__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ProductRepository__ = __webpack_require__(189);















var EventRepository = function () {
  function EventRepository(api) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, EventRepository);

    this.api = api;
  }

  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass___default()(EventRepository, [{
    key: 'setMaxCustomerGroupId',
    value: function setMaxCustomerGroupId(maxCustomerGroupId) {
      this.maxCustomerGroupId = maxCustomerGroupId;
    }
  }, {
    key: 'getStatuses',
    value: function getStatuses() {
      return [{
        text: 'Locked',
        value: 'LOCKED'
      }, {
        text: 'Confirmed',
        value: 'CONFIRMED'
      }, {
        text: 'In Preparation',
        value: 'IN_PREPARATION'
      }];
    }
  }, {
    key: 'getStatusesForFilter',
    value: function getStatusesForFilter() {
      return [{
        text: 'Confirmed/Locked',
        value: 'CONFIRMED_AND_LOCKED'
      }, {
        text: 'Confirmed',
        value: 'CONFIRMED'
      }, {
        text: 'In Preparation',
        value: 'IN_PREPARATION'
      }];
    }
  }, {
    key: 'getTypes',
    value: function getTypes() {
      return [{
        text: 'Flyer',
        value: 'FLYER_MASTER'
      }, {
        text: 'Manager\'s special',
        value: 'MANAGERS_SPECIAL_MASTER'
      }, {
        text: 'Other',
        value: 'OTHER_MASTER'
      }];
    }
  }, {
    key: 'getReasonNameTypes',
    value: function getReasonNameTypes() {
      return {
        'BUY_ITEMS_GET_PERCENTAGE_OFF_ITEMS': 'Buy and Get Percent Off',
        'BUY_ITEMS_GET_SUM_OFF_ITEMS': 'Buy and Get Dollar Off',
        'BUY_ITEMS_FOR_SPECIAL_UNIT_PRICE': 'Multi-Buy',
        'SPEND_GET_PERCENTAGE_OFF_ITEMS': 'Spend and Get Percent Off',
        'SPEND_GET_SUM_OFF_ITEMS': 'Spend and Get Dollar Off',
        'MULTIBUY_GET_PERCENTAGE_OFF': 'Item % off',
        'MULTIBUY_GET_SUM_OFF': 'Item $ off'
      };
    }
  }, {
    key: 'getCustomerGroups',
    value: function getCustomerGroups(groupIds) {

      return [{ text: 'Email Member', value: groupIds.emailMemberGroupId }, { text: 'Non-Email Member', value: groupIds.nonEmailMemberGroupId }, { text: 'Non-Member', value: groupIds.nonMemberGroupId }];
    }
  }, {
    key: 'getStoreRegions',
    value: function getStoreRegions() {
      return this.api.storeRegions.get();
    }
  }, {
    key: 'getEventsByPage',
    value: function getEventsByPage(pageNo, params) {
      var transformer = new __WEBPACK_IMPORTED_MODULE_9__transformers_PriceListsAndPromotionsToEventsTransformer__["a" /* default */]();

      if (typeof pageNo === 'undefined') pageNo = 1;

      return this.api.events.getEventsByPage(pageNo, params).then(function (resp) {

        console.log('pre transform: ', resp);
        resp.records = transformer.transform(resp.records, [], []);
        return resp;
      });
    }
  }, {
    key: 'getAllEvents',
    value: function getAllEvents() {
      var transformer = new __WEBPACK_IMPORTED_MODULE_9__transformers_PriceListsAndPromotionsToEventsTransformer__["a" /* default */]();

      return this.api.events.getEvents().then(function (masterPriceLists) {
        return masterPriceLists.sort(function (a, b) {
          if (!a.startDate) {
            return -1;
          } else if (!b.startDate) {
            return 1;
          } else if (a.startDate < b.startDate) {
            return 1;
          } else if (a.startDate > b.startDate) {
            return -1;
          } else {
            return 0;
          }
        });
      }).then(function (masterPriceLists) {
        return transformer.transform(masterPriceLists, [], []);
      });
    }
  }, {
    key: 'getEvent',
    value: function getEvent(id) {
      var _this = this;

      var eventTransformer = new __WEBPACK_IMPORTED_MODULE_8__transformers_PriceListsAndPromotionsToEventTransformer__["a" /* default */]();
      var productRepository = new __WEBPACK_IMPORTED_MODULE_12__ProductRepository__["a" /* default */](this.api);
      var productIdTransformer = new __WEBPACK_IMPORTED_MODULE_10__transformers_EventToProductIdsTransformer__["a" /* default */]();
      var combiningTransformer = new __WEBPACK_IMPORTED_MODULE_11__transformers_EventAndProductCombiningTransformer__["a" /* default */]();
      productRepository.setMaxCustomerGroupId(this.maxCustomerGroupId);

      return this.api.events.getEvent(id).then(function (event) {
        return _this.api.products.getProducts(id).then(function (products) {
          return _this.api.campaigns.getCampaigns(id).then(function (campaigns) {
            event = eventTransformer.transform(event, products, campaigns);
            var productIds = productIdTransformer.transform(event);

            return productRepository.getProductsWithBasePricesAndCost(productIds, event.regionId, event.startDate, event.endDate).then(function (productsWithBasePricesAndCost) {
              return combiningTransformer.transform(event, productsWithBasePricesAndCost);
            });
          });
        });
      });
    }
  }, {
    key: 'createEvent',
    value: function createEvent(eventOrig) {
      var event = JSON.parse(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(eventOrig));
      event.name = {
        'en': event.name,
        'fr': event.name
      };
      return this.api.events.createNewEvent(event).then(function (event) {
        return event;
      });
    }
  }, {
    key: 'copyEvent',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2(event) {
        var _this2 = this;

        var productRepository, discountedProducts, specialPromotions;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                productRepository = new __WEBPACK_IMPORTED_MODULE_12__ProductRepository__["a" /* default */](this.api);
                discountedProducts = event.discountedProducts;
                specialPromotions = event.specialPromotions;

                discountedProducts.forEach(function (product) {
                  return delete product.priceListProductId;
                });
                specialPromotions.forEach(function (campaign) {
                  delete campaign.campaignId;
                  delete campaign.eventId;
                  delete campaign.id;
                });

                productRepository.setMaxCustomerGroupId(this.maxCustomerGroupId);

                _context2.next = 8;
                return this.createEvent(event).then(function (eventId) {
                  return _this2.getEvent(eventId.id).then(function (newEvent) {
                    newEvent.discountedProducts = discountedProducts;
                    newEvent.specialPromotions = specialPromotions;
                    var productIds = newEvent.discountedProducts.map(function (product) {
                      return product.id;
                    });
                    return productRepository.getProductsWithBasePricesAndCost(productIds, newEvent.regionId).then(function (products) {
                      var discountedProducts = _this2.recalculateDiscountedPrices(newEvent.discountedProducts, products);
                      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(newEvent, { discountedProducts: discountedProducts });
                    });
                  });
                }).then(function () {
                  var _ref2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(eventWithDiscountsAndPromotions) {
                    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            eventWithDiscountsAndPromotions.isConfirmed = false;
                            eventWithDiscountsAndPromotions.isLocked = false;
                            _context.next = 4;
                            return _this2.saveEvent(eventWithDiscountsAndPromotions).then(function () {
                              return eventWithDiscountsAndPromotions;
                            });

                          case 4:
                            return _context.abrupt('return', _context.sent);

                          case 5:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this2);
                  }));

                  return function (_x2) {
                    return _ref2.apply(this, arguments);
                  };
                }());

              case 8:
                return _context2.abrupt('return', _context2.sent);

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function copyEvent(_x) {
        return _ref.apply(this, arguments);
      }

      return copyEvent;
    }()
  }, {
    key: 'recalculateDiscountedPrices',
    value: function recalculateDiscountedPrices(eventDiscountsInPreviousRegion, productsInNewRegion) {
      return eventDiscountsInPreviousRegion.map(function (eventDiscount) {
        var discountedProductChanges = productsInNewRegion.reduce(function (result, foundProduct) {
          if (foundProduct.productID !== eventDiscount.id) {
            return result;
          }

          var basePriceDifference = void 0;
          if (eventDiscount.customerGroupId !== 0) {
            console.log('eventDiscount.customerGroupId !== 0 -> yes');
            console.log(eventDiscount.regularCustomerGroupPrice, foundProduct.regionCustomerGroupBasePrice, eventDiscount.salesPrice);

            basePriceDifference = eventDiscount.regularCustomerGroupPrice - foundProduct.regionCustomerGroupBasePrice;
          } else {
            console.log('eventDiscount.customerGroupId !== 0 -> no');
            console.log(eventDiscount.regularPrice, foundProduct.regionBasePrice, eventDiscount.salesPrice);

            basePriceDifference = eventDiscount.regularPrice - foundProduct.regionBasePrice;
          }

          return {
            salesPrice: eventDiscount.salesPrice - basePriceDifference,
            cost: foundProduct.regionCost
          };
        }, {});

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, eventDiscount, discountedProductChanges);
      });
    }
  }, {
    key: 'saveEvent',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3(eventOrig) {
        var _this3 = this;

        var addedProducts, editedProducts, addedCampaigns, editedCampaigns, deletedProducts, deletedCampaigns, event, promises, errors, _ref4, campaignPromises, campaignErrors;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log('saveEvent');
                console.log(eventOrig);
                addedProducts = [];
                editedProducts = [];
                addedCampaigns = [];
                editedCampaigns = [];
                deletedProducts = [];
                deletedCampaigns = [];
                event = JSON.parse(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(eventOrig));
                promises = [];


                event.discountedProducts.map(function (product) {
                  product.targetMargin = parseFloat(product.targetMargin);
                  product.price = product.salesPrice;
                  product.customerGroupId = product.customerGroupId === 0 ? null : product.customerGroupId;
                  product.priceListProductId ? editedProducts.push(product) : addedProducts.push(product);
                });

                event.specialPromotions.map(function (promotion) {
                  if (promotion.type === 'MULTIBUY_X_FOR_DISCOUNT' || promotion.type === 'MULTIBUY_GET_PERCENTAGE_OFF' || promotion.type === 'MULTIBUY_GET_SUM_OFF') {
                    console.log('before 1');
                    console.log(promotion);

                    promotion.rewards.sumOffMatchingItems = promotion.rewards.sumOff ? promotion.rewards.sumOff.valueOf() : promotion.rewards.sumOffMatchingItems;

                    promotion.rewards.percentageOffMatchingItems = promotion.rewards.percentageOff ? promotion.rewards.percentageOff.valueOf() : promotion.rewards.percentageOffMatchingItems;

                    console.log('after 1');
                    console.log(promotion);
                    console.log('delete 1');

                    if (promotion.rewards.awardedProducts) {

                      promotion.rewards.awardedProducts = promotion.rewards.awardedProducts.map(function (product) {
                        return { productId: product.productID ? product.productID : product.productId };
                      });
                    }

                    delete promotion.rewards.sumOff;
                    delete promotion.rewards.percentageOff;
                  }

                  promotion.customerGroupId = promotion.customerGroupId === 0 ? null : promotion.customerGroupId;
                  promotion.campaignId ? editedCampaigns.push(promotion) : addedCampaigns.push(promotion);
                });

                event.deletedDiscountsAndPromotions.map(function (item) {
                  if (item.campaignId) {
                    deletedCampaigns.push(item);
                  } else if (item.priceListProductId) {
                    deletedProducts.push(item);
                  }
                });

                errors = {};


                addedProducts.map(function (product) {
                  product.productId = product.id;

                  promises.push(_this3.api.products.addProduct(event.id, product).then(function (response) {
                    product.priceListProductId = response.data.priceListProductId;
                  }).catch(function (error) {
                    errors[product.productId] = error.data && error.data.validationErrors ? error.data.validationErrors : null;
                  }));
                });

                editedProducts.map(function (product) {
                  if (product.hasBeenEdited) promises.push(_this3.api.products.edit(event.id, product));
                });

                deletedProducts.map(function (product) {
                  promises.push(_this3.api.products.remove(event.id, product));
                });

                deletedCampaigns.map(function (campaign) {
                  promises.push(_this3.api.campaigns.remove(event.id, campaign));
                });

                console.log('promises1');
                console.log(promises);
                _context3.next = 22;
                return this.saveCampaigns(addedCampaigns, editedCampaigns, event);

              case 22:
                _ref4 = _context3.sent;
                campaignPromises = _ref4.campaignPromises;
                campaignErrors = _ref4.campaignErrors;

                console.log('promises3');
                console.log(campaignPromises);
                promises = promises.concat(campaignPromises);
                errors = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(errors, campaignErrors);

                event.name = {
                  'en': event.name,
                  'fr': event.name
                };

                console.log('promises2');
                console.log(promises);
                _context3.next = 34;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(promises);

              case 34:
                _context3.next = 36;
                return this.api.events.save(event);

              case 36:
                event = _context3.sent;
                return _context3.abrupt('return', { event: event, errors: errors });

              case 38:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function saveEvent(_x3) {
        return _ref3.apply(this, arguments);
      }

      return saveEvent;
    }()
  }, {
    key: 'saveCampaigns',
    value: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4(addedCampaigns, editedCampaigns, event) {
        var _this4 = this;

        var reasons, campaignPromises, campaignErrors;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                console.log('saveCampaigns');
                _context4.next = 3;
                return this.api.events.getReasonCodes();

              case 3:
                reasons = _context4.sent;
                campaignPromises = [];
                campaignErrors = {};

                addedCampaigns.map(function (campaign) {
                  var addedCampaign = JSON.parse(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(campaign));

                  if (addedCampaign.name && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(addedCampaign.name) !== 'object') {
                    addedCampaign.name = {
                      'en': addedCampaign.name,
                      'fr': addedCampaign.nameLat
                    };
                  }

                  var eventType = '';
                  _this4.getTypes().map(function (type) {
                    if (type.value === event.type) eventType = type.text;
                  });

                  reasons.map(function (reason) {
                    if (reason.name === eventType + '-' + _this4.getReasonNameTypes()[addedCampaign.type]) addedCampaign.reasonId = reason.reasonID;
                  });
                  addedCampaign.requirements.purchasedProducts = addedCampaign.requirements.purchasedProducts.map(function (product) {
                    return { productId: product.productID ? product.productID : product.productId };
                  });

                  addedCampaign.rewards.awardedProducts = addedCampaign.rewards.awardedProducts.map(function (product) {
                    return { productId: product.productID ? product.productID : product.productId };
                  });

                  switch (addedCampaign.type) {
                    case 'SPEND_GET_SUM_OFF_ITEMS':
                      addedCampaign.rewards.lowestPriceItemIsAwarded = false;
                      break;
                    case 'SPEND_GET_PERCENTAGE_OFF_ITEMS':
                      addedCampaign.rewards.lowestPriceItemIsAwarded = true;
                      break;
                    case 'BUY_ITEMS_GET_SUM_OFF_ITEMS':
                      addedCampaign.rewards.lowestPriceItemIsAwarded = false;
                      break;
                    case 'BUY_ITEMS_GET_PERCENTAGE_OFF_ITEMS':
                      addedCampaign.rewards.lowestPriceItemIsAwarded = false;
                      break;
                    case 'MULTIBUY_GET_PERCENTAGE_OFF':
                      addedCampaign.rewards.lowestPriceItemIsAwarded = false;
                      break;
                    case 'MULTIBUY_GET_SUM_OFF':
                      addedCampaign.rewards.lowestPriceItemIsAwarded = false;
                      break;

                    default:
                      break;
                  }

                  if (typeof addedCampaign.oncePerDay == 'undefined' || addedCampaign.oncePerDay === '') {
                    addedCampaign.oncePerDay = 0;
                  }

                  if (typeof addedCampaign.rewards.redemptionLimit !== 'undefined') {
                    if (addedCampaign.rewards.redemptionLimit === '') addedCampaign.rewards.redemptionLimit = null;
                  }

                  if (typeof addedCampaign.rewards.salesRedemptionLimit !== 'undefined') {
                    if (addedCampaign.rewards.salesRedemptionLimit === '') addedCampaign.rewards.salesRedemptionLimit = null;
                  }

                  if (typeof addedCampaign.oncePerDay == 'undefined' || addedCampaign.oncePerDay === '') {
                    addedCampaign.oncePerDay = 0;
                  } else {
                    addedCampaign.oncePerDay = parseInt(addedCampaign.oncePerDay);
                  }

                  if (addedCampaign.type === 'BUY_ITEMS_FOR_SPECIAL_UNIT_PRICE' || addedCampaign.type === 'MULTIBUY_GET_PERCENTAGE_OFF' || addedCampaign.type === 'MULTIBUY_GET_SUM_OFF') {
                    console.log('before 2');
                    console.log(addedCampaign);
                    addedCampaign.rewards.sumOffMatchingItems = addedCampaign.rewards.sumOff ? addedCampaign.rewards.sumOff.valueOf() : addedCampaign.rewards.sumOffMatchingItems;
                    addedCampaign.rewards.percentageOffMatchingItems = addedCampaign.rewards.percentageOff ? addedCampaign.rewards.percentageOff.valueOf() : addedCampaign.rewards.percentageOffMatchingItems;
                    console.log('after 2');
                    console.log(addedCampaign);
                    console.log('delete 2');
                    delete addedCampaign.rewards.sumOff;
                    delete addedCampaign.rewards.percentageOff;
                  }

                  if (addedCampaign.type == 'SPEND_GET_SUM_OFF_ITEMS' || addedCampaign.type == 'BUY_ITEMS_GET_SUM_OFF_ITEMS') {
                    if (!addedCampaign.rewards.percentageOff) {
                      delete addedCampaign.rewards.percentageOff;
                    }

                    if (!addedCampaign.rewards.percentageOffMatchingItems) {
                      delete addedCampaign.rewards.percentageOffMatchingItems;
                    }

                    if (!addedCampaign.rewards.sumOffMatchingItems) {
                      delete addedCampaign.rewards.sumOffMatchingItems;
                    }
                  }

                  if (addedCampaign.type == 'SPEND_GET_SUM_OFF_ITEMS' || addedCampaign.type == 'SPEND_GET_PERCENTAGE_OFF_ITEMS' || addedCampaign.type == 'MULTIBUY_GET_SUM_OFF' || addedCampaign.type == 'BUY_ITEMS_GET_SUM_OFF_ITEMS') {

                    delete addedCampaign.rewards.specialUnitPrice;
                  }

                  if (addedCampaign.type == 'BUY_ITEMS_FOR_SPECIAL_UNIT_PRICE' || addedCampaign.type == 'SPEND_GET_PERCENTAGE_OFF_ITEMS') {

                    if (!addedCampaign.rewards.percentageOffMatchingItems) {
                      delete addedCampaign.rewards.percentageOffMatchingItems;
                    }

                    if (!addedCampaign.rewards.sumOffMatchingItems) {
                      delete addedCampaign.rewards.sumOffMatchingItems;
                    }

                    delete addedCampaign.subsidyPercentageOfDiscount;
                    delete addedCampaign.rewards.rewardMoneyEarnedPerRedemption;
                  }

                  if (addedCampaign.type == 'SPEND_GET_PERCENTAGE_OFF_ITEMS') {

                    if (!addedCampaign.rewards.sumOff) {
                      delete addedCampaign.rewards.sumOff;
                    }
                  }

                  if (addedCampaign.type == 'MULTIBUY_GET_SUM_OFF') {
                    if (!addedCampaign.rewards.percentageOffMatchingItems) {
                      delete addedCampaign.rewards.percentageOffMatchingItems;
                    }
                    delete addedCampaign.subsidyPercentageOfDiscount;
                    delete addedCampaign.rewards.rewardMoneyEarnedPerItem;
                  }

                  if (addedCampaign.type == 'MULTIBUY_GET_PERCENTAGE_OFF') {
                    delete addedCampaign.subsidyPercentageOfDiscount;
                    delete addedCampaign.rewards.rewardMoneyEarnedPerItem;
                  }

                  if (addedCampaign.type == 'BUY_ITEMS_GET_SUM_OFF_ITEMS' || addedCampaign.type == 'BUY_ITEMS_GET_PERCENTAGE_OFF_ITEMS') {

                    addedCampaign.rewards.salesRedemptionLimit = addedCampaign.rewards.redemptionLimit;

                    delete addedCampaign.rewards.redemptionLimit;
                  }

                  if (addedCampaign.type == 'BUY_ITEMS_GET_PERCENTAGE_OFF_ITEMS') {
                    delete addedCampaign.rewards.rewardMoneyEarnedPerItem;
                    delete addedCampaign.targetMargin;
                  }


                  campaignPromises.push(_this4.api.campaigns.addCampaign(addedCampaign, event.id).then(function (response) {
                    campaign.campaignId = response.data.campaignId;
                  }).catch(function (error) {
                    if (error.data && error.data.validationErrors) campaignErrors[campaign.id] = error.data.validationErrors;
                  }));
                });
                editedCampaigns.map(function (campaign) {
                  delete campaign.name;
                  delete campaign.nameLat;
                  campaign.requirements.purchasedProducts = campaign.requirements.purchasedProducts.map(function (product) {
                    return { productId: product.productID ? product.productID : product.productId };
                  });

                  campaign.rewards.awardedProducts = campaign.rewards.awardedProducts.map(function (product) {
                    return { productId: product.productID ? product.productID : product.productId };
                  });

                  if (typeof campaign.rewards.redemptionLimit !== 'undefined') {
                    console.log('campaign.rewards.redemptionLimit', campaign.rewards.redemptionLimit);

                    if (campaign.rewards.redemptionLimit === '') campaign.rewards.redemptionLimit = null;
                  }

                  if (typeof campaign.rewards.salesRedemptionLimit !== 'undefined') {
                    console.log('campaign.rewards.salesRedemptionLimit', campaign.rewards.salesRedemptionLimit);

                    if (campaign.rewards.salesRedemptionLimit === '') campaign.rewards.salesRedemptionLimit = null;
                  }

                  if (typeof campaign.oncePerDay == 'undefined' || campaign.oncePerDay === '') {
                    campaign.oncePerDay = 0;
                  } else {
                    campaign.oncePerDay = parseInt(campaign.oncePerDay);
                  }

                  if (campaign.type === 'MULTIBUY_X_FOR_DISCOUNT' || campaign.type === 'MULTIBUY_GET_PERCENTAGE_OFF' || campaign.type === 'MULTIBUY_GET_SUM_OFF') {
                    console.log('before 3');
                    console.log(campaign);
                    campaign.rewards.sumOffMatchingItems = campaign.rewards.sumOff ? campaign.rewards.sumOff.valueOf() : campaign.rewards.sumOffMatchingItems;
                    campaign.rewards.percentageOffMatchingItems = campaign.rewards.percentageOff ? campaign.rewards.percentageOff.valueOf() : campaign.rewards.percentageOffMatchingItems;

                    console.log('before 31');
                    console.log(campaign);
                    console.log('delete 3');
                    delete campaign.rewards.sumOff;
                    delete campaign.rewards.percentageOff;
                  }

                  if (campaign.type == 'SPEND_GET_SUM_OFF_ITEMS' || campaign.type == 'BUY_ITEMS_GET_SUM_OFF_ITEMS') {
                    if (!campaign.rewards.percentageOff) {
                      delete campaign.rewards.percentageOff;
                    }

                    if (!campaign.rewards.percentageOffMatchingItems) {
                      delete campaign.rewards.percentageOffMatchingItems;
                    }

                    if (!campaign.rewards.sumOffMatchingItems) {
                      delete campaign.rewards.sumOffMatchingItems;
                    }
                  }

                  if (campaign.type == 'SPEND_GET_SUM_OFF_ITEMS' || campaign.type == 'SPEND_GET_PERCENTAGE_OFF_ITEMS' || campaign.type == 'MULTIBUY_GET_SUM_OFF' || campaign.type == 'BUY_ITEMS_GET_SUM_OFF_ITEMS') {

                    delete campaign.rewards.specialUnitPrice;
                  }

                  if (campaign.type == 'BUY_ITEMS_FOR_SPECIAL_UNIT_PRICE' || campaign.type == 'SPEND_GET_PERCENTAGE_OFF_ITEMS') {

                    if (!campaign.rewards.percentageOffMatchingItems) {
                      delete campaign.rewards.percentageOffMatchingItems;
                    }

                    if (!campaign.rewards.sumOffMatchingItems) {
                      delete campaign.rewards.sumOffMatchingItems;
                    }
                    delete campaign.subsidyPercentageOfDiscount;
                    delete campaign.rewards.rewardMoneyEarnedPerRedemption;
                  }

                  if (campaign.type == 'SPEND_GET_PERCENTAGE_OFF_ITEMS') {

                    if (!campaign.rewards.sumOff) {
                      delete campaign.rewards.sumOff;
                    }
                  }

                  if (campaign.type == 'MULTIBUY_GET_SUM_OFF') {
                    if (!campaign.rewards.percentageOffMatchingItems) {
                      delete campaign.rewards.percentageOffMatchingItems;
                    }
                    delete campaign.subsidyPercentageOfDiscount;
                    delete campaign.rewards.rewardMoneyEarnedPerItem;
                  }

                  if (campaign.type == 'MULTIBUY_GET_PERCENTAGE_OFF') {
                    delete campaign.subsidyPercentageOfDiscount;
                    delete campaign.rewards.rewardMoneyEarnedPerItem;
                  }

                  if (campaign.type == 'BUY_ITEMS_GET_SUM_OFF_ITEMS' || campaign.type == 'BUY_ITEMS_GET_PERCENTAGE_OFF_ITEMS') {

                    campaign.rewards.salesRedemptionLimit = campaign.rewards.redemptionLimit;

                    delete campaign.rewards.redemptionLimit;
                  }

                  if (campaign.type == 'BUY_ITEMS_GET_PERCENTAGE_OFF_ITEMS') {
                    delete campaign.rewards.rewardMoneyEarnedPerItem;
                    delete campaign.targetMargin;
                  }


                  if (campaign.hasBeenEdited) {
                    campaignPromises.push(_this4.api.campaigns.edit(event.id, campaign));
                  }
                });
                return _context4.abrupt('return', { campaignPromises: campaignPromises, campaignErrors: campaignErrors });

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function saveCampaigns(_x4, _x5, _x6) {
        return _ref5.apply(this, arguments);
      }

      return saveCampaigns;
    }()
  }, {
    key: 'lockEvent',
    value: function lockEvent(event) {
      event.locked = true;
      return this.api.events.save(event);
    }
  }, {
    key: 'unlockEvent',
    value: function unlockEvent(event) {
      event.locked = false;
      return this.api.events.save(event);
    }
  }, {
    key: 'confirmEvent',
    value: function confirmEvent(event) {
      event.active = true;
      return this.api.events.save(event);
    }
  }, {
    key: 'unconfirmEvent',
    value: function unconfirmEvent(event) {
      event.active = false;
      return this.api.events.save(event);
    }
  }, {
    key: 'deleteEvent',
    value: function deleteEvent(id) {
      return this.api.events.deleteEvent(id).then(function (response) {
        return response;
      }).catch(function (error) {
        return error;
      });
    }
  }, {
    key: 'getEventCodeOccurrences',
    value: function getEventCodeOccurrences(excludeEventId) {
      return this.api.events.getEvents().then(function (events) {
        return events.map(function (event) {
          if (event.id !== parseInt(excludeEventId)) {
            return {
              eventCode: event.eventCode.toLowerCase(),
              regionId: parseInt(event.regionId),
              type: event.type
            };
          }
        });
      });
    }
  }]);

  return EventRepository;
}();

/* harmony default export */ __webpack_exports__["a"] = EventRepository;

/***/ }),

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1515)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(1244),
  /* template */
  __webpack_require__(1670),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 94:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(1245),
  /* template */
  __webpack_require__(1696),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 95:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_Util__ = __webpack_require__(1226);





var EventProductRepository = function () {
  function EventProductRepository(api) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, EventProductRepository);

    this.api = api;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(EventProductRepository, [{
    key: 'setMaxCustomerGroupId',
    value: function setMaxCustomerGroupId(maxCustomerGroupId) {
      this.maxCustomerGroupId = maxCustomerGroupId;
    }
  }, {
    key: 'getProductOccurrences',
    value: function getProductOccurrences(regionId, startDate, endDate, excludeId) {
      var _this = this;

      var priceLists = [];
      var campaigns = [];
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([this.getPriceListsForRegion(regionId).then(function (records) {
        return priceLists = records;
      }), this.getCampaignsForRegion(regionId).then(function (records) {
        return campaigns = records;
      })]).then(function () {
        priceLists = _this.filterWithoutEventId(priceLists);
        priceLists = _this.filterPriceListsWithId(priceLists, excludeId);
        priceLists = _this.filterByDate(priceLists, startDate, endDate);
        var priceListProducts = _this.getProductOccurrencesInPriceLists(priceLists);

        campaigns = _this.filterWithoutEventId(campaigns);
        campaigns = _this.filterCampaignsWithId(campaigns, excludeId);
        campaigns = _this.filterByDate(campaigns, startDate, endDate);
        var campaignProducts = _this.getProductOccurrencesInCampaigns(campaigns);

        return priceListProducts.concat(campaignProducts);
      });
    }
  }, {
    key: 'getPriceListsForRegion',
    value: function getPriceListsForRegion(regionId) {
      var priceListParameters = {
        searchAttributeName: 'regionId',
        searchAttributeValue: regionId
      };

      return this.api.priceLists.get(priceListParameters).then(function (pricelists) {
        return pricelists;
      });
    }
  }, {
    key: 'getCampaignsForRegion',
    value: function getCampaignsForRegion(regionId) {
      var campaignParams = {
        searchAttributeName: 'regionId',
        searchAttributeValue: regionId
      };
      return this.api.campaigns.get(campaignParams);
    }
  }, {
    key: 'filterPriceListsWithId',
    value: function filterPriceListsWithId(priceLists, excludeEventId) {
      return priceLists.filter(function (priceList) {
        if (priceList.pricelistID === excludeEventId) {
          return false;
        } else if (parseInt(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api_Util__["a" /* getAttribute */])(priceList, 'relatedPriceListId')) === excludeEventId) {
          return false;
        } else {
          return true;
        }
      });
    }
  }, {
    key: 'filterCampaignsWithId',
    value: function filterCampaignsWithId(campaigns, excludeEventId) {
      return campaigns.filter(function (campaign) {
        if (parseInt(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api_Util__["a" /* getAttribute */])(campaign, 'relatedPriceListId')) === excludeEventId) {
          return false;
        } else {
          return true;
        }
      });
    }
  }, {
    key: 'filterWithoutEventId',
    value: function filterWithoutEventId(items) {
      return items.filter(function (item) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api_Util__["a" /* getAttribute */])(item, 'eventId');
      });
    }
  }, {
    key: 'filterByDate',
    value: function filterByDate(dateables, startDate, endDate) {
      return dateables.filter(function (dateable) {
        if (dateable.startDate === '0000-00-00') {
          dateable.startDate = null;
        }
        if (dateable.endDate === '0000-00-00') {
          dateable.endDate = null;
        }
        if (dateable.startDate && dateable.startDate > endDate) {
          return false;
        } else if (dateable.endDate && dateable.endDate < startDate) {
          return false;
        } else {
          return true;
        }
      });
    }
  }, {
    key: 'getProductOccurrencesInPriceLists',
    value: function getProductOccurrencesInPriceLists(priceLists) {
      return priceLists.reduce(function (result, priceList) {
        return result.concat(priceList.pricelistRules.map(function (rule) {
          return {
            customerGroupId: priceList.customerGroupId ? priceList.customerGroupId : 0,
            startDate: priceList.startDate,
            endDate: priceList.endDate,
            id: rule.id,
            eventCode: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api_Util__["a" /* getAttribute */])(priceList, 'eventId')
          };
        }));
      }, []);
    }
  }, {
    key: 'getProductOccurrencesInCampaigns',
    value: function getProductOccurrencesInCampaigns(campaigns) {
      return campaigns.reduce(function (result, campaign) {
        var customerGroupId = 0;
        if (campaign.customerGroups[0]) {
          customerGroupId = campaign.customerGroups[0].id;
        }
        if (campaign.awardedProducts.length) {
          return result.concat(campaign.awardedProducts.map(function (product) {
            return {
              customerGroupId: customerGroupId,
              startDate: campaign.startDate,
              endDate: campaign.endDate,
              id: product.productID,
              eventCode: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api_Util__["a" /* getAttribute */])(campaign, 'eventId')
            };
          }));
        } else {
          return result.concat(campaign.purchasedProducts.map(function (product) {
            return {
              customerGroupId: customerGroupId,
              startDate: campaign.startDate,
              endDate: campaign.endDate,
              id: product.productID,
              eventCode: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api_Util__["a" /* getAttribute */])(campaign, 'eventId')
            };
          }));
        }
      }, []);
    }
  }]);

  return EventProductRepository;
}();

/* harmony default export */ __webpack_exports__["a"] = EventProductRepository;

/***/ }),

/***/ 96:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isEqual__ = __webpack_require__(1612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isEqual__);



/* harmony default export */ __webpack_exports__["a"] = function (arrayFieldPath, transformationFunction) {
  return function (value, parentVm) {
    var theOccurrence = transformationFunction(value, parentVm, this);
    var otherOccurrences = __WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(this, arrayFieldPath);

    var matches = otherOccurrences.filter(function (occurence) {
      return __WEBPACK_IMPORTED_MODULE_1_lodash_isEqual___default()(occurence, theOccurrence);
    });

    return matches.length === 0;
  };
};

/***/ })

},[1729]);


// WEBPACK FOOTER //
// static/js/app.6d03489f21a2dd14760b.js